import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, Pipe, ViewEncapsulation, ViewChild, Inject, EventEmitter, Output, ContentChildren, InjectionToken, NgModule, Optional } from '@angular/core';
import * as i1$2 from '@angular/forms';
import { Validators, FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as i2$2 from '@capturum/ui/accordion';
import { CapturumAccordionModule } from '@capturum/ui/accordion';
import * as i5 from '@capturum/ui/api';
import { CapturumDialogService, CapturumTemplateDirective, CapturumSharedModule } from '@capturum/ui/api';
import * as i3 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i3$2 from '@capturum/ui/calendar';
import { CalendarSelectionMode, CapturumCalendarModule } from '@capturum/ui/calendar';
import * as i3$1 from '@capturum/ui/checkbox';
import { CapturumCheckboxModule } from '@capturum/ui/checkbox';
import * as i3$3 from '@capturum/ui/dropdown';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import * as i2 from '@capturum/ui/editor';
import { defaultModulesConfig, CapturumEditorModule } from '@capturum/ui/editor';
import * as i5$1 from '@capturum/ui/file-preview-list';
import { CapturumFilePreviewListModule } from '@capturum/ui/file-preview-list';
import * as i4$2 from '@capturum/ui/file-upload';
import { CapturumFileUploadModule } from '@capturum/ui/file-upload';
import * as i2$1 from '@capturum/ui/input';
import { CapturumInputModule } from '@capturum/ui/input';
import * as i2$4 from '@capturum/ui/input-number';
import { CapturumInputNumberModule } from '@capturum/ui/input-number';
import * as i3$6 from '@capturum/ui/input-switch';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import * as i3$4 from '@capturum/ui/multi-select';
import { CapturumMultiSelectModule } from '@capturum/ui/multi-select';
import * as i2$5 from '@capturum/ui/textarea';
import { CapturumTextareaModule } from '@capturum/ui/textarea';
import * as i1$6 from '@ngx-formly/core';
import { FieldType, FieldWrapper, FieldArrayType, FormlyConfig, FormlyModule } from '@ngx-formly/core';
import * as i6 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1 from '@ngxs/store';
import { createSelector, Action, State, NgxsModule } from '@ngxs/store';
import * as i4$1 from 'ngx-permissions';
import { NgxPermissionsModule } from 'ngx-permissions';
import * as i6$1 from 'primeng/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import * as i1$4 from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import * as i3$5 from 'primeng/radiobutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import * as i4$4 from 'primeng/splitbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import * as i4$3 from '@capturum/ui/password';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { combineLatest, throwError, Subject, from, Observable, Subscription, of, BehaviorSubject, interval, forkJoin, concat, takeUntil as takeUntil$1 } from 'rxjs';
import { __decorate } from 'tslib';
import { tap, switchMap, map, catchError, take, startWith, takeUntil, filter, debounceTime, shareReplay } from 'rxjs/operators';
import * as i4 from '@capturum/builders/core';
import { LabelPosition, DependencyOperator, responseData, InputType, controlsEqual, clone } from '@capturum/builders/core';
import { DestroyBase } from '@capturum/shared';
import * as i1$3 from '@capturum/api';
import { ApiService } from '@capturum/api';
import { BaseDataIndexedDbModel, BaseDataValueIndexedDbModel, IndexedDbModel } from '@capturum/complete';
import * as i2$3 from '@capturum/auth';
import * as i1$7 from '@angular/common/http';
import { HttpEventType } from '@angular/common/http';
import * as i1$5 from '@angular/platform-browser';
import { passwordValidator } from '@capturum/formly';
function CancelButtonComponent_ng_container_0_cap_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 2);
    i0.ɵɵlistener("click", function CancelButtonComponent_ng_container_0_cap_button_1_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.submit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.actionConfiguration.name)("icon", ctx_r1.actionConfiguration.icon)("disabled", ctx_r1.submitting);
  }
}
function CancelButtonComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CancelButtonComponent_ng_container_0_cap_button_1_Template, 1, 3, "cap-button", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.actionConfiguration);
  }
}
const _c0 = ["*"];
function CapturumBuilderCheckboxInputComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.to == null ? null : ctx_r0.to.description);
  }
}
function CapturumBuilderCheckboxListInputComponent_ng_container_0_cap_checkbox_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-checkbox", 3);
    i0.ɵɵlistener("change", function CapturumBuilderCheckboxListInputComponent_ng_container_0_cap_checkbox_2_Template_cap_checkbox_change_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r5);
      const option_r3 = restoredCtx.$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.setChecked(option_r3, $event.checked));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("label", option_r3.value);
  }
}
function CapturumBuilderCheckboxListInputComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, CapturumBuilderCheckboxListInputComponent_ng_container_0_cap_checkbox_2_Template, 1, 1, "cap-checkbox", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "cpb-readonly-container", 1);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "labelsByValue");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const options_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", ctx_r0.to.readonly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", options_r1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r0.to.readonly);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 4, i0.ɵɵpipeBind1(6, 7, ctx_r0.readonlyString), options_r1), " ");
  }
}
function CapturumBuilderCheckboxValueInputComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.to == null ? null : ctx_r0.to.description);
  }
}
const _c1 = ".fa-info-circle[_ngcontent-%COMP%]{margin-top:.5rem;margin-left:.313rem;font-size:.75rem;color:var(--cap-primary-color)}";
function CapturumBuilderDateInputComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "default");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.formControl.value, ctx_r0.to == null ? null : ctx_r0.to.defaultEmptyValue), " ");
  }
}
function CapturumBuilderDateInputComponent_ng_template_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r3.formControl.value, ctx_r3.to.time ? "dd-MM-yyyy HH:mm" : "dd-MM-yyyy"), " ");
  }
}
function CapturumBuilderDateInputComponent_ng_template_7_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "date");
    i0.ɵɵpipe(2, "date");
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, ctx_r5.formControl.value[0], "dd-MM-yyyy"), " - ", i0.ɵɵpipeBind2(2, 5, ctx_r5.formControl.value[1], "dd-MM-yyyy"), " ");
  }
}
function CapturumBuilderDateInputComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CapturumBuilderDateInputComponent_ng_template_7_ng_container_0_Template, 3, 4, "ng-container", 2);
    i0.ɵɵtemplate(1, CapturumBuilderDateInputComponent_ng_template_7_ng_template_1_Template, 3, 8, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const _r4 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r2.to.selectionMode || (ctx_r2.to == null ? null : ctx_r2.to.selectionMode) === "single" || (ctx_r2.to == null ? null : ctx_r2.to.selectionMode) !== "single" && !(ctx_r2.formControl == null ? null : ctx_r2.formControl.value == null ? null : ctx_r2.formControl.value.length))("ngIfElse", _r4);
  }
}
const _c2 = function (a0) {
  return [a0];
};
function CapturumBuilderDropdownInputComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cap-dropdown", 1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "observablePipe");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "observablePipe");
    i0.ɵɵelementStart(7, "cpb-readonly-container", 2);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "default");
    i0.ɵɵpipe(10, "labelsByValue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const options_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("hidden", ctx_r0.props.readonly)("options", options_r1)("optionLabel", "label")("optionValue", "key")("placeholder", ctx_r0.props.placeholder || i0.ɵɵpipeBind1(2, 23, "placeholder.select"))("floatLabel", i0.ɵɵpipeBind1(3, 25, i0.ɵɵpipeBind1(4, 27, ctx_r0.props.label_position)) === ctx_r0.labelPosition.Floating)("label", i0.ɵɵpipeBind1(5, 29, i0.ɵɵpipeBind1(6, 31, ctx_r0.props.label_position)) === ctx_r0.labelPosition.Floating ? ctx_r0.props.label : "")("appendTo", (ctx_r0.props == null ? null : ctx_r0.props.appendTo) || "body")("readonly", ctx_r0.props.readonly)("virtualScroll", ctx_r0.props.virtualScroll)("showClear", true)("withImages", !!ctx_r0.props.image_key)("withIcons", ctx_r0.props.withIcons)("virtualScrollItemSize", ctx_r0.props.virtualScrollItemSize || 30)("filter", true)("filterBy", ctx_r0.props.filterBy)("panelStyleClass", ctx_r0.props.css_class)("sortAlphabetically", ctx_r0.props == null ? null : ctx_r0.props.sort_asc);
    i0.ɵɵattribute("data-test", "builder-" + ctx_r0.field.key);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("hidden", !ctx_r0.props.readonly);
    i0.ɵɵattribute("data-test", "builder-readonly-" + ctx_r0.field.key);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 33, i0.ɵɵpipeBind2(10, 36, i0.ɵɵpureFunction1(39, _c2, ctx_r0.formControl.value), options_r1), ctx_r0.props == null ? null : ctx_r0.props.defaultEmptyValue), " ");
  }
}
const _c3 = function () {
  return ["bottom-right", "bottom-left"];
};
const _c4 = function () {
  return ["top-right", "top-left"];
};
const _c5 = function (a0, a1, a2) {
  return {
    "arrow-top": a0,
    "arrow-bottom": a1,
    short: a2
  };
};
const _c6 = function (a0, a1, a2) {
  return {
    "body-bottom": a0,
    "body-top": a1,
    short: a2
  };
};
function FormTooltipComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 1);
    i0.ɵɵelementStart(2, "cpb-tooltip", 2);
    i0.ɵɵelement(3, "p", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("position", ctx_r0.position);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r0.text, i0.ɵɵsanitizeHtml);
  }
}
function CapturumBuilderValidationMessageComponent_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errors_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", errors_r1[0], "\n");
  }
}
function CapturumBuilderDefaultInputWrapperComponent_div_3_label_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function CapturumBuilderDefaultInputWrapperComponent_div_3_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 10);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, CapturumBuilderDefaultInputWrapperComponent_div_3_label_1_span_2_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("for", ctx_r4.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.to.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.to.required);
  }
}
function CapturumBuilderDefaultInputWrapperComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CapturumBuilderDefaultInputWrapperComponent_div_3_label_1_Template, 3, 3, "label", 8);
    i0.ɵɵelement(2, "cpb-form-tooltip", 9);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "observablePipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.to.label && ctx_r0.to.hideLabel !== true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("text", ctx_r0.to.tooltip)("position", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(4, 5, ctx_r0.to.labelPosition)) === ctx_r0.labelPosition.Before ? "bottom-left" : "bottom-right");
  }
}
function CapturumBuilderDefaultInputWrapperComponent_ng_template_7_Template(rf, ctx) {}
function CapturumBuilderDefaultInputWrapperComponent_small_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, ctx_r3.to.description)), " ");
  }
}
const _c7 = ["accordionCard"];
function CapturumBuilderCollapsableWrapperComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 4);
  }
}
function CapturumBuilderCollapsableWrapperComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "p", 6);
    i0.ɵɵlistener("click", function CapturumBuilderCollapsableWrapperComponent_ng_template_3_Template_p_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.toggleCard());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "cpb-form-tooltip", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.to.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("text", ctx_r3.to.tooltip);
  }
}
function CapturumBuilderCheckboxWrapperComponent_label_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function CapturumBuilderCheckboxWrapperComponent_label_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 10);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, CapturumBuilderCheckboxWrapperComponent_label_5_span_2_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r0.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.to.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.to.required);
  }
}
function CapturumBuilderCheckboxWrapperComponent_ng_template_7_Template(rf, ctx) {}
function CapturumBuilderCheckboxWrapperComponent_small_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, ctx_r3.to.description)), " ");
  }
}
const _c8 = ["autoComplete"];
function CapturumBuilderFileInputComponent_ng_template_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "file.upload.description"));
  }
}
function CapturumBuilderFileInputComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "i", 5)(2, "p", 6);
    i0.ɵɵtemplate(3, CapturumBuilderFileInputComponent_ng_template_3_span_3_Template, 3, 3, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.field == null ? null : ctx_r1.field.name, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.field == null ? null : ctx_r1.field.props == null ? null : ctx_r1.field.props.label);
  }
}
function FilePreviewComponent_div_0_div_1_div_1_ng_container_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 11);
    i0.ɵɵpipe(1, "createObjectUrl");
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r8.imagePathProperty ? item_r4[ctx_r8.imagePathProperty] : i0.ɵɵpipeBind1(1, 2, item_r4), i0.ɵɵsanitizeUrl)("alt", item_r4[ctx_r8.nameProperty]);
  }
}
function FilePreviewComponent_div_0_div_1_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FilePreviewComponent_div_0_div_1_div_1_ng_container_2_img_1_Template, 2, 4, "img", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showThumbnail);
  }
}
function FilePreviewComponent_div_0_div_1_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementContainerEnd();
  }
}
function FilePreviewComponent_div_0_div_1_div_1_i_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵlistener("click", function FilePreviewComponent_div_0_div_1_div_1_i_6_Template_i_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const item_r4 = i0.ɵɵnextContext().ngIf;
      const ctx_r10 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r10.handleRemoveIconClick($event, item_r4[ctx_r10.nameProperty]));
    });
    i0.ɵɵelementEnd();
  }
}
const _c9 = function (a0) {
  return {
    "file__preview--centered": a0
  };
};
function FilePreviewComponent_div_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function FilePreviewComponent_div_0_div_1_div_1_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r14);
      const item_r4 = restoredCtx.ngIf;
      const ctx_r13 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r13.cardClick.emit(item_r4[ctx_r13.nameProperty]));
    });
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, FilePreviewComponent_div_0_div_1_div_1_ng_container_2_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtemplate(3, FilePreviewComponent_div_0_div_1_div_1_ng_container_3_Template, 2, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, FilePreviewComponent_div_0_div_1_div_1_i_6_Template, 1, 0, "i", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c9, !ctx_r3.showThumbnail));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showThumbnail);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.showThumbnail);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4[ctx_r3.nameProperty]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.deletable);
  }
}
function FilePreviewComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, FilePreviewComponent_div_0_div_1_div_1_Template, 7, 7, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const uploaderItem_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("classList", ctx_r1.styleClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (uploaderItem_r2 == null ? null : uploaderItem_r2.file) || uploaderItem_r2);
  }
}
function FilePreviewComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FilePreviewComponent_div_0_div_1_Template, 2, 2, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
function SubmitButtonComponent_ng_container_0_cap_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 2);
    i0.ɵɵlistener("click", function SubmitButtonComponent_ng_container_0_cap_button_1_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.submit());
    });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.actionConfiguration.name)("icon", i0.ɵɵpipeBind1(1, 3, ctx_r1.loading$) ? "fas fa-spinner fa-spin" : ctx_r1.actionConfiguration.icon)("disabled", i0.ɵɵpipeBind1(2, 5, ctx_r1.loading$));
  }
}
function SubmitButtonComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SubmitButtonComponent_ng_container_0_cap_button_1_Template, 3, 7, "cap-button", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.actionConfiguration);
  }
}
const _c10 = "[_nghost-%COMP%]     .p-button-icon-left{padding-right:0;margin-right:1em}";
function FormRendererHeaderComponent_ng_container_5_cpb_form_submit_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cpb-form-submit-button", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("key", ctx_r1.formKey)("actionConfiguration", ctx_r1.callbacks.submit);
  }
}
function FormRendererHeaderComponent_ng_container_5_cpb_form_cancel_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cpb-form-cancel-button", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("key", ctx_r2.formKey)("actionConfiguration", ctx_r2.callbacks.cancel);
  }
}
function FormRendererHeaderComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormRendererHeaderComponent_ng_container_5_cpb_form_submit_button_1_Template, 1, 2, "cpb-form-submit-button", 5);
    i0.ɵɵtemplate(2, FormRendererHeaderComponent_ng_container_5_cpb_form_cancel_button_2_Template, 1, 2, "cpb-form-cancel-button", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.callbacks == null ? null : ctx_r0.callbacks.submit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.callbacks == null ? null : ctx_r0.callbacks.cancel);
  }
}
function CapturumBuilderGroupInputComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h3", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.field.label);
  }
}
function CapturumBuilderGroupInputComponent_formly_field_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "formly-field", 6);
  }
  if (rf & 2) {
    const field_r2 = ctx.$implicit;
    i0.ɵɵproperty("field", field_r2);
  }
}
function CapturumBuilderImageInputComponent_cap_file_upload_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-file-upload", 5, 6);
    i0.ɵɵlistener("onFileChange", function CapturumBuilderImageInputComponent_cap_file_upload_0_Template_cap_file_upload_onFileChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.handleFileChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵproperty("id", ctx_r0.field.key)("multiple", ctx_r0.to == null ? null : ctx_r0.to.multiple)("accept", ctx_r0.to.availableExtensions)("uploaderContent", _r1);
    i0.ɵɵattribute("data-test", "builder-" + ctx_r0.field.key);
  }
}
function CapturumBuilderImageInputComponent_ng_template_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "file.upload.description"));
  }
}
function CapturumBuilderImageInputComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "i", 8)(2, "p", 9);
    i0.ɵɵtemplate(3, CapturumBuilderImageInputComponent_ng_template_3_span_3_Template, 3, 3, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r2.field == null ? null : ctx_r2.field.name, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.field == null ? null : ctx_r2.field.props == null ? null : ctx_r2.field.props.label);
  }
}
function CapturumBuilderLabelInputComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.to.label);
  }
}
function CapturumMultiSelectInputComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cpb-readonly-container")(2, "div", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "default");
    i0.ɵɵpipe(5, "labelsByValue");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const options_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("data-test", "builder-readonly-" + ctx_r2.field.key);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, i0.ɵɵpipeBind2(5, 5, ctx_r2.formControl.value, options_r1), ctx_r2.props == null ? null : ctx_r2.props.defaultEmptyValue), " ");
  }
}
function CapturumMultiSelectInputComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cap-multi-select", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "observablePipe");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, CapturumMultiSelectInputComponent_ng_container_0_ng_container_7_Template, 6, 8, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const options_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("display", ctx_r0.props.readonly ? "none" : "block");
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("floatLabel", i0.ɵɵpipeBind1(2, 20, i0.ɵɵpipeBind1(3, 22, ctx_r0.props.label_position)) === ctx_r0.labelPosition.Floating)("label", i0.ɵɵpipeBind1(4, 24, i0.ɵɵpipeBind1(5, 26, ctx_r0.props.label_position)) === ctx_r0.labelPosition.Floating ? ctx_r0.props.label : "")("options", options_r1)("optionLabel", ctx_r0.props.label_key)("optionValue", ctx_r0.props.value_key)("selectionLimit", ctx_r0.props.selectionLimit)("panelStyleClass", ctx_r0.field.key)("resetFilterOnHide", ctx_r0.props.resetFilterOnHide || true)("virtualScroll", ctx_r0.props.virtualScroll)("filterBy", ctx_r0.props == null ? null : ctx_r0.props.filterBy)("virtualScrollItemSize", ctx_r0.props.virtualScrollItemSize || 30)("defaultLabel", ctx_r0.props.placeholder || i0.ɵɵpipeBind1(6, 28, "placeholder.select"))("appendTo", (ctx_r0.props == null ? null : ctx_r0.props.appendTo) || "body")("readonly", ctx_r0.props.readonly)("sortBy", "order");
    i0.ɵɵattribute("data-test", "builder-" + ctx_r0.field.key);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.props.readonly);
  }
}
function CapturumBuilderRadioInputComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "p-radioButton", 4);
    i0.ɵɵelementStart(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", option_r3[ctx_r2.to.value_key])("inputId", option_r3[ctx_r2.to.value_key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", option_r3[ctx_r2.to.value_key]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(option_r3[ctx_r2.to.label_key]);
  }
}
function CapturumBuilderRadioInputComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumBuilderRadioInputComponent_ng_container_1_div_1_Template, 4, 4, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const options_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", options_r1);
  }
}
function CapturumRepeatInputTypeComponent_ng_container_0_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵlistener("click", function CapturumRepeatInputTypeComponent_ng_container_0_div_1_i_3_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const index_r4 = i0.ɵɵnextContext().index;
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.remove(index_r4));
    });
    i0.ɵɵelementEnd();
  }
}
function CapturumRepeatInputTypeComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "formly-field", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, CapturumRepeatInputTypeComponent_ng_container_0_div_1_i_3_Template, 1, 0, "i", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldGroupField_r3 = ctx.$implicit;
    const first_r5 = ctx.first;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("field", fieldGroupField_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !first_r5 && !ctx_r1.to.hideDeleteButton);
  }
}
function CapturumRepeatInputTypeComponent_ng_container_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "cap-button", 9);
    i0.ɵɵlistener("click", function CapturumRepeatInputTypeComponent_ng_container_0_div_2_Template_cap_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.add());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r2.to.addButtonText)("icon", ctx_r2.to.addButtonIcon);
  }
}
function CapturumRepeatInputTypeComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumRepeatInputTypeComponent_ng_container_0_div_1_Template, 4, 2, "div", 1);
    i0.ɵɵtemplate(2, CapturumRepeatInputTypeComponent_ng_container_0_div_2_Template, 2, 2, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.field.fieldGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.to.hideAddButton);
  }
}
function CapturumBuilderTextInputComponent_ng_container_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r1.to == null ? null : ctx_r1.to.content_left);
  }
}
function CapturumBuilderTextInputComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumBuilderTextInputComponent_ng_container_5_ng_template_1_Template, 1, 1, "ng-template", 3);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumBuilderToggleInputComponent_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-test", "builder-readonly-" + ctx_r0.field.key);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r0.formControl.value), " ");
  }
}
const _c11 = ["localeButton"];
function CapturumBuilderTranslatedInputComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "formly-field", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fieldGroupField_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("field", fieldGroupField_r2);
  }
}
const _c12 = function (a0) {
  return {
    $implicit: a0
  };
};
function CapturumBuilderIconInputComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c12, item_r4))("ngTemplateOutlet", _r2);
  }
}
function CapturumBuilderIconInputComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c12, item_r5))("ngTemplateOutlet", _r2);
  }
}
function CapturumBuilderIconInputComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(item_r6.key);
    i0.ɵɵproperty("ngClass", "input-icon");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.label);
  }
}
function CapturumFormRendererComponent_ng_container_0_ng_template_2_cpb_form_renderer_header_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cpb-form-renderer-header", 5);
  }
  if (rf & 2) {
    const config_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("leftButtonTemplate", ctx_r6.leftButtonTemplate)("rightButtonTemplate", ctx_r6.rightButtonTemplate)("formKey", ctx_r6.formKey)("callbacks", config_r5.callbacks)("title", config_r5.title);
  }
}
function CapturumFormRendererComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CapturumFormRendererComponent_ng_container_0_ng_template_2_cpb_form_renderer_header_0_Template, 1, 5, "cpb-form-renderer-header", 4);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showHeader);
  }
}
function CapturumFormRendererComponent_ng_container_0_ng_container_4_formly_form_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "formly-form", 7);
  }
  if (rf & 2) {
    const fields_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("model", ctx_r8.formModel)("form", ctx_r8.form)("options", ctx_r8.formOptions)("fields", fields_r1.inputs);
    i0.ɵɵattribute("data-test", "builder-" + ctx_r8.formKey);
  }
}
function CapturumFormRendererComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumFormRendererComponent_ng_container_0_ng_container_4_formly_form_1_Template, 1, 5, "formly-form", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.modelId || ctx_r4.modelId && ctx_r4.formModel);
  }
}
function CapturumFormRendererComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 1);
    i0.ɵɵtemplate(2, CapturumFormRendererComponent_ng_container_0_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, CapturumFormRendererComponent_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fields_r1 = ctx.ngIf;
    const _r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate || _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c12, fields_r1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngxPermissionsOnly", fields_r1.permissions);
  }
}
let SetFormValue$1 = class SetFormValue {
  static {
    this.type = '[FormRenderer] Set form value';
  }
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
};
let SetFormConfiguration$1 = class SetFormConfiguration {
  static {
    this.type = '[FormRenderer] Set form configuration';
  }
  constructor(key, configuration, context) {
    this.key = key;
    this.configuration = configuration;
    this.context = context;
  }
};
let SetFormStatus$1 = class SetFormStatus {
  static {
    this.type = '[FormRenderer] Set form status';
  }
  constructor(key, valid) {
    this.key = key;
    this.valid = valid;
  }
};
let ResetFormValue$1 = class ResetFormValue {
  static {
    this.type = '[FormRenderer] Reset form value';
  }
  constructor(key) {
    this.key = key;
  }
};
let SetSubmitted = /*#__PURE__*/(() => {
  class SetSubmitted {
    static {
      this.type = '[FormRenderer] Set Submitted';
    }
    constructor(key) {
      this.key = key;
    }
  }
  return SetSubmitted;
})();
let SetSourceValue = /*#__PURE__*/(() => {
  class SetSourceValue {
    static {
      this.type = '[FormRenderer] Set Source value';
    }
    constructor(key, value) {
      this.key = key;
      this.value = value;
    }
  }
  return SetSourceValue;
})();
let GetSourceValue = /*#__PURE__*/(() => {
  class GetSourceValue {
    static {
      this.type = '[FormRenderer] Set Source value';
    }
    constructor(key) {
      this.key = key;
    }
  }
  return GetSourceValue;
})();
let SetFormValidationErrors = /*#__PURE__*/(() => {
  class SetFormValidationErrors {
    static {
      this.type = '[FormRenderer] Set Validation Errors';
    }
    constructor(key, validationErrors) {
      this.key = key;
      this.validationErrors = validationErrors;
    }
  }
  return SetFormValidationErrors;
})();
let ResetFormFieldValidationErrors = /*#__PURE__*/(() => {
  class ResetFormFieldValidationErrors {
    static {
      this.type = '[FormRenderer] Reset Validation Errors';
    }
    constructor(key, field) {
      this.key = key;
      this.field = field;
    }
  }
  return ResetFormFieldValidationErrors;
})();
function deepEqual(object1, object2) {
  const objectKeys = Object.keys,
    typeObject1 = typeof object1,
    typeObject2 = typeof object2;
  return object1 && object2 && typeObject1 === 'object' && typeObject1 === typeObject2 ? objectKeys(object1).length === objectKeys(object2).length && objectKeys(object1).every(key => deepEqual(object1[key], object2[key])) : object1 === object2;
}
var FormRendererState_1;
// @dynamic
let FormRendererState = class FormRendererState {
  static {
    FormRendererState_1 = this;
  }
  static configurationByKey(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].configuration;
    });
  }
  static contextByKey(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].context;
    });
  }
  static formByKeyAndContext(key, context, skipCacheCheck) {
    return createSelector([FormRendererState_1], state => {
      if (state.forms[key] && (skipCacheCheck || !context && !state.forms[key].context || deepEqual(context, state.forms[key].context))) {
        return state.forms[key];
      }
      return null;
    });
  }
  static formValueByKey(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].value;
    });
  }
  static sourceValueByKey(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].sourceValue;
    });
  }
  static isFormValid(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].valid;
    });
  }
  static isSubmitted(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key].submitted;
    });
  }
  static validationErrorsByKeyAndControlName(key, controlName) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key]?.validationErrors?.[controlName];
    });
  }
  static validationErrorsByKey(key) {
    return createSelector([FormRendererState_1], state => {
      return state.forms[key] && state.forms[key]?.validationErrors;
    });
  }
  setFormValue(ctx, {
    key,
    value
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          value
        }
      }
    });
  }
  setFormConfiguration(ctx, {
    key,
    configuration,
    context
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          configuration,
          context
        }
      }
    });
  }
  setFormStatus(ctx, {
    key,
    valid
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          valid
        }
      }
    });
  }
  resetFormValue(ctx, {
    key
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          valid: false,
          value: null,
          submitted: false
        }
      }
    });
  }
  setSubmitted(ctx, {
    key
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          submitted: true
        }
      }
    });
  }
  setSourceValue(ctx, {
    key,
    value
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          sourceValue: value
        }
      }
    });
  }
  setValidationErrors(ctx, {
    key,
    validationErrors
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          validationErrors: validationErrors
        }
      }
    });
  }
  resetFormFieldValidationErrors(ctx, {
    key,
    field
  }) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      forms: {
        ...state.forms,
        [key]: {
          ...state.forms[key],
          validationErrors: {
            ...state.forms[key]?.validationErrors,
            [field]: null
          }
        }
      }
    });
  }
  static {
    this.ɵfac = function FormRendererState_Factory(t) {
      return new (t || FormRendererState)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormRendererState,
      factory: FormRendererState.ɵfac
    });
  }
};
__decorate([Action(SetFormValue$1)], FormRendererState.prototype, "setFormValue", null);
__decorate([Action(SetFormConfiguration$1)], FormRendererState.prototype, "setFormConfiguration", null);
__decorate([Action(SetFormStatus$1)], FormRendererState.prototype, "setFormStatus", null);
__decorate([Action(ResetFormValue$1)], FormRendererState.prototype, "resetFormValue", null);
__decorate([Action(SetSubmitted)], FormRendererState.prototype, "setSubmitted", null);
__decorate([Action(SetSourceValue)], FormRendererState.prototype, "setSourceValue", null);
__decorate([Action(SetFormValidationErrors)], FormRendererState.prototype, "setValidationErrors", null);
__decorate([Action(ResetFormFieldValidationErrors)], FormRendererState.prototype, "resetFormFieldValidationErrors", null);
FormRendererState = FormRendererState_1 = __decorate([State({
  name: 'formRenderer',
  defaults: {
    forms: {}
  }
})], FormRendererState);
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormSaverService = /*#__PURE__*/(() => {
  class FormSaverService {
    constructor(store, actionService, builderApiService) {
      this.store = store;
      this.actionService = actionService;
      this.builderApiService = builderApiService;
    }
    submit(key, additionalValue = {}) {
      return combineLatest([this.getFormValueByKey(key), this.getFormConfigurationByKey(key)]).pipe(tap(() => this.markFormAsSubmitted(key)), switchMap(([value, configuration]) => {
        return this.submitToBackend(configuration.submit.endpoint, {
          ...value,
          ...additionalValue
        }, key);
      }), switchMap(response => this.getFormConfigurationByKey(key).pipe(map(config => {
        return {
          config,
          response
        };
      }))), tap(({
        config,
        response
      }) => {
        const body = response.data || response;
        this.actionService.executeAction(config.callbacks.submit, body, key);
      }));
    }
    cancel(key) {
      const config = this.store.selectSnapshot(FormRendererState.configurationByKey(key));
      const value = this.store.selectSnapshot(FormRendererState.sourceValueByKey(key));
      this.actionService.executeAction(config.callbacks.cancel, value, key);
    }
    submitToBackend(endpoint, value, key, contextKey) {
      return this.builderApiService.post(key, endpoint, value).pipe(catchError(({
        error
      }) => {
        if (error) {
          this.setValidationErrors(error, key);
        }
        return throwError(error);
      }));
    }
    markFormAsSubmitted(key) {
      this.store.dispatch(new SetSubmitted(key));
    }
    getFormValueByKey(key) {
      return this.store.select(FormRendererState.formValueByKey(key)).pipe(take(1));
    }
    getFormConfigurationByKey(key) {
      return this.store.select(FormRendererState.configurationByKey(key)).pipe(take(1));
    }
    setValidationErrors(error, key) {
      const keys = error.errors && Object.keys(error.errors);
      if (keys && keys.length) {
        this.store.dispatch(new SetFormValidationErrors(key, error.errors));
      }
    }
    getValidationErrors(key) {
      return this.store.select(FormRendererState.validationErrorsByKey(key));
    }
    static {
      this.ɵfac = function FormSaverService_Factory(t) {
        return new (t || FormSaverService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i4.CapturumBuilderActionService), i0.ɵɵinject(i4.BuilderApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormSaverService,
        factory: FormSaverService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormSaverService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CancelButtonComponent = /*#__PURE__*/(() => {
  class CancelButtonComponent {
    constructor(formSaverService) {
      this.formSaverService = formSaverService;
      this.submitting = false;
      this.loadingIconClass = 'fas fa-spinner fa-spin';
    }
    submit() {
      this.formSaverService.cancel(this.key);
    }
    static {
      this.ɵfac = function CancelButtonComponent_Factory(t) {
        return new (t || CancelButtonComponent)(i0.ɵɵdirectiveInject(FormSaverService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CancelButtonComponent,
        selectors: [["cpb-form-cancel-button"]],
        inputs: {
          actionConfiguration: "actionConfiguration",
          key: "key"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngxPermissionsOnly"], ["styleClass", "secondary", 3, "label", "icon", "disabled", "click", 4, "ngIf"], ["styleClass", "secondary", 3, "label", "icon", "disabled", "click"]],
        template: function CancelButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CancelButtonComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngxPermissionsOnly", ctx.actionConfiguration.permissions);
          }
        },
        dependencies: [i1$1.NgIf, i3.CapturumButtonComponent, i4$1.NgxPermissionsDirective],
        styles: ["[_nghost-%COMP%]     .p-button-icon-left{padding-right:0;margin-right:1em}"],
        changeDetection: 0
      });
    }
  }
  return CancelButtonComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumReadonlyContainerComponent = /*#__PURE__*/(() => {
  class CapturumReadonlyContainerComponent {
    static {
      this.ɵfac = function CapturumReadonlyContainerComponent_Factory(t) {
        return new (t || CapturumReadonlyContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumReadonlyContainerComponent,
        selectors: [["cpb-readonly-container"]],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [[1, "readonly-container"]],
        template: function CapturumReadonlyContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-test", "builder-readonly");
          }
        },
        styles: [".readonly-container[_ngcontent-%COMP%]{min-height:38px;display:flex;flex-direction:column;justify-content:center}"]
      });
    }
  }
  return CapturumReadonlyContainerComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderCheckboxInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderCheckboxInputComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderCheckboxInputComponent_BaseFactory;
        return function CapturumBuilderCheckboxInputComponent_Factory(t) {
          return (ɵCapturumBuilderCheckboxInputComponent_BaseFactory || (ɵCapturumBuilderCheckboxInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderCheckboxInputComponent)))(t || CapturumBuilderCheckboxInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderCheckboxInputComponent,
        selectors: [["cpb-checkbox-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 11,
        consts: [[1, "d-flex"], [3, "hidden", "formControl"], [3, "hidden"], ["class", "small-description", 4, "ngIf"], [1, "small-description"]],
        template: function CapturumBuilderCheckboxInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cap-checkbox", 1);
            i0.ɵɵelementStart(2, "cpb-readonly-container", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, CapturumBuilderCheckboxInputComponent_span_6_Template, 2, 1, "span", 3);
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.to.readonly)("formControl", ctx.formControl);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", !!ctx.formControl.value ? i0.ɵɵpipeBind1(4, 7, ctx.to.activeTranslationKey || "builders.checkbox.active") : i0.ɵɵpipeBind1(5, 9, ctx.to.inactiveTranslationKey || "builders.checkbox.inactive"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.to == null ? null : ctx.to.description);
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$1.CapturumCheckboxComponent, CapturumReadonlyContainerComponent, i6.TranslatePipe],
        styles: [".fa-info-circle[_ngcontent-%COMP%]{margin-top:.5rem;margin-left:.313rem;font-size:.75rem;color:var(--cap-primary-color)}"]
      });
    }
  }
  return CapturumBuilderCheckboxInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelsByValuesPipe = /*#__PURE__*/(() => {
  class LabelsByValuesPipe {
    transform(values, options, labelKey = 'label', valueKey = 'key') {
      if (values) {
        return options.filter(option => values.includes(option[valueKey])).map(option => {
          return option[labelKey];
        }).join(', ');
      }
      return null;
    }
    static {
      this.ɵfac = function LabelsByValuesPipe_Factory(t) {
        return new (t || LabelsByValuesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "labelsByValue",
        type: LabelsByValuesPipe,
        pure: true
      });
    }
  }
  return LabelsByValuesPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderCheckboxListInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderCheckboxListInputComponent extends FieldType {
    constructor() {
      super();
      this.destroy$ = new Subject();
    }
    ngOnDestroy() {
      this.destroy$.next();
    }
    setChecked(option, checked) {
      let controlValue = this.formControl.value;
      const optionValue = option.key;
      if (checked) {
        if (Array.isArray(controlValue)) {
          controlValue.push(optionValue);
        } else {
          controlValue = [optionValue];
        }
      } else {
        controlValue = controlValue.filter(item => item !== optionValue);
      }
      this.formControl.setValue(controlValue);
    }
    ngOnInit() {
      this.readonlyString = this.formControl.valueChanges.pipe(startWith(this.formControl.value), takeUntil(this.destroy$));
    }
    static {
      this.ɵfac = function CapturumBuilderCheckboxListInputComponent_Factory(t) {
        return new (t || CapturumBuilderCheckboxListInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderCheckboxListInputComponent,
        selectors: [["cpb-checkbox-list-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "hidden"], [3, "label", "change", 4, "ngFor", "ngForOf"], [3, "label", "change"]],
        template: function CapturumBuilderCheckboxListInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumBuilderCheckboxListInputComponent_ng_container_0_Template, 7, 9, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.to.options$.asObservable()));
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i3$1.CapturumCheckboxComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, LabelsByValuesPipe],
        styles: ["[_nghost-%COMP%]     p-checkbox{padding:10px 0}"]
      });
    }
  }
  return CapturumBuilderCheckboxListInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderCheckboxValueInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderCheckboxValueInputComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderCheckboxValueInputComponent_BaseFactory;
        return function CapturumBuilderCheckboxValueInputComponent_Factory(t) {
          return (ɵCapturumBuilderCheckboxValueInputComponent_BaseFactory || (ɵCapturumBuilderCheckboxValueInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderCheckboxValueInputComponent)))(t || CapturumBuilderCheckboxValueInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderCheckboxValueInputComponent,
        selectors: [["cpb-checkbox-value-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 13,
        consts: [[1, "d-flex"], [3, "hidden", "formControl", "trueValue", "falseValue"], [3, "hidden"], ["class", "small-description", 4, "ngIf"], [1, "small-description"]],
        template: function CapturumBuilderCheckboxValueInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cap-checkbox", 1);
            i0.ɵɵelementStart(2, "cpb-readonly-container", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, CapturumBuilderCheckboxValueInputComponent_span_6_Template, 2, 1, "span", 3);
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.to.readonly)("formControl", ctx.formControl)("trueValue", ctx.to.trueValue)("falseValue", ctx.to.falseValue);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", !!ctx.formControl.value ? i0.ɵɵpipeBind1(4, 9, "builders.checkbox.active") : i0.ɵɵpipeBind1(5, 11, "builders.checkbox.inactive"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.to == null ? null : ctx.to.description);
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$1.CapturumCheckboxComponent, CapturumReadonlyContainerComponent, i6.TranslatePipe],
        styles: [_c1]
      });
    }
  }
  return CapturumBuilderCheckboxValueInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderDateInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderDateInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.separator = ':';
      this.labelPosition = LabelPosition;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(take(1)).subscribe(value => {
        this.innerValue = value;
        if (typeof value === 'string') {
          if (new Date(value).getTime() > 0 || this.props?.timezone) {
            this.formControl.patchValue(new Date(value), {
              onlySelf: true
            });
          } else if (!this.props?.date && this.props?.time) {
            const timeParts = value.split(this.separator);
            if (timeParts && timeParts.length >= 3) {
              const time = timeParts.slice(0, 2).join(this.separator);
              this.formControl.patchValue(time, {
                onlySelf: true
              });
            }
          }
        }
      });
    }
    onClickOutside() {
      const dates = this.formControl.value;
      if (this.props?.selectionMode === CalendarSelectionMode.range && dates?.some(date => !!date)) {
        if (dates.some(date => !date)) {
          this.formControl.setValue(dates.map(date => date || dates.find(date => !!date)));
        }
      }
    }
    ngOnDestroy() {
      if (this.destroy$) {
        this.destroy$.next(true);
        this.destroy$.complete();
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderDateInputComponent_BaseFactory;
        return function CapturumBuilderDateInputComponent_Factory(t) {
          return (ɵCapturumBuilderDateInputComponent_BaseFactory || (ɵCapturumBuilderDateInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderDateInputComponent)))(t || CapturumBuilderDateInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderDateInputComponent,
        selectors: [["cpb-date-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 31,
        consts: [["styleClass", "p-inputgroup", 3, "hidden", "formControl", "floatLabel", "label", "maxDate", "minDate", "showIcon", "name", "dataType", "placeholder", "hasTooltip", "selectionMode", "readOnly", "showTime", "appendTo", "timeOnly", "setTimeZone", "hideOnDateTimeSelect", "clickOutside"], [3, "hidden"], [4, "ngIf", "ngIfElse"], ["showDate", ""], ["rangeDate", ""]],
        template: function CapturumBuilderDateInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-calendar", 0);
            i0.ɵɵlistener("clickOutside", function CapturumBuilderDateInputComponent_Template_cap_calendar_clickOutside_0_listener() {
              return ctx.onClickOutside();
            });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "cpb-readonly-container", 1);
            i0.ɵɵtemplate(6, CapturumBuilderDateInputComponent_ng_container_6_Template, 3, 4, "ng-container", 2);
            i0.ɵɵtemplate(7, CapturumBuilderDateInputComponent_ng_template_7_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const _r1 = i0.ɵɵreference(8);
            let tmp_11_0;
            let tmp_16_0;
            i0.ɵɵproperty("hidden", ctx.to.readonly)("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 23, i0.ɵɵpipeBind1(2, 25, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 27, i0.ɵɵpipeBind1(4, 29, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("maxDate", ctx.to.max_date)("minDate", ctx.to.min_date)("showIcon", true)("name", ctx.field.key)("dataType", !(ctx.to == null ? null : ctx.to.date) ? "string" : "date")("placeholder", ctx.formState.readonly ? "" : ctx.to.placeholder)("hasTooltip", ctx.to.tooltip)("selectionMode", (tmp_11_0 = ctx.to == null ? null : ctx.to.selectionMode) !== null && tmp_11_0 !== undefined ? tmp_11_0 : "single")("readOnly", !!ctx.formState.readonly)("showTime", ctx.to == null ? null : ctx.to.time)("appendTo", ctx.to == null ? null : ctx.to.appendTo)("timeOnly", !(ctx.to == null ? null : ctx.to.date))("setTimeZone", (tmp_16_0 = ctx.to == null ? null : ctx.to.timezone) !== null && tmp_16_0 !== undefined ? tmp_16_0 : true)("hideOnDateTimeSelect", true);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.to == null ? null : ctx.to.date))("ngIfElse", _r1);
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$2.CapturumCalendarComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i1$1.DatePipe, i5.ObservablePipe, i5.DefaultPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderDateInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderDropdownInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderDropdownInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderDropdownInputComponent_BaseFactory;
        return function CapturumBuilderDropdownInputComponent_Factory(t) {
          return (ɵCapturumBuilderDropdownInputComponent_BaseFactory || (ɵCapturumBuilderDropdownInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderDropdownInputComponent)))(t || CapturumBuilderDropdownInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderDropdownInputComponent,
        selectors: [["cpb-dropdown-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "formControl", "hidden", "options", "optionLabel", "optionValue", "placeholder", "floatLabel", "label", "appendTo", "readonly", "virtualScroll", "showClear", "withImages", "withIcons", "virtualScrollItemSize", "filter", "filterBy", "panelStyleClass", "sortAlphabetically"], [3, "hidden"]],
        template: function CapturumBuilderDropdownInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumBuilderDropdownInputComponent_ng_container_0_Template, 11, 41, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.props.options$));
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$3.CapturumDropdownComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe, i6.TranslatePipe, LabelsByValuesPipe],
        styles: ["cpb-dropdown-input.has-icon{position:relative}cpb-dropdown-input.has-icon .cpb-dropdown-input-icon{position:absolute;top:15px;transform:translateY(-50%);left:.5rem;color:var(--cap-primary-color)}cpb-dropdown-input.has-icon .cap-dropdown.p-dropdown .p-dropdown-label,cpb-dropdown-input.has-icon .cap-dropdown.p-dropdown .p-dropdown-label.p-placeholder{padding-left:2rem}cpb-dropdown-input .cap-dropdown.p-dropdown .p-dropdown-clear-icon{position:static;padding-right:.5rem;margin-top:0;align-self:center}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderDropdownInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderEditorInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderEditorInputComponent extends FieldType {
    get config() {
      return {
        placeholder: this.props?.placeholder || '',
        modules: this.props?.modules || {
          ...defaultModulesConfig
        }
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderEditorInputComponent_BaseFactory;
        return function CapturumBuilderEditorInputComponent_Factory(t) {
          return (ɵCapturumBuilderEditorInputComponent_BaseFactory || (ɵCapturumBuilderEditorInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderEditorInputComponent)))(t || CapturumBuilderEditorInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderEditorInputComponent,
        selectors: [["cpb-editor-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 10,
        consts: [[3, "hidden", "config", "formControl"], [3, "hidden"], [3, "innerHtml"]],
        template: function CapturumBuilderEditorInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-editor", 0);
            i0.ɵɵelementStart(1, "cpb-readonly-container", 1);
            i0.ɵɵelement(2, "p", 2);
            i0.ɵɵpipe(3, "default");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.to.readonly)("config", ctx.config)("formControl", ctx.formControl);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 7, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2.EditorComponent, CapturumReadonlyContainerComponent, i5.DefaultPipe]
      });
    }
  }
  return CapturumBuilderEditorInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderEmailInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderEmailInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    ngOnInit() {
      this.formControl.setValidators(Validators.email);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderEmailInputComponent_BaseFactory;
        return function CapturumBuilderEmailInputComponent_Factory(t) {
          return (ɵCapturumBuilderEmailInputComponent_BaseFactory || (ɵCapturumBuilderEmailInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderEmailInputComponent)))(t || CapturumBuilderEmailInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderEmailInputComponent,
        selectors: [["cpb-email-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 22,
        consts: [["type", "email", 3, "formControl", "floatLabel", "label", "hasTooltip", "hidden", "readonly", "placeholder"], [3, "hidden"]],
        template: function CapturumBuilderEmailInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵelementStart(5, "cpb-readonly-container", 1);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "default");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 11, i0.ɵɵpipeBind1(2, 13, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 15, i0.ɵɵpipeBind1(4, 17, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("hasTooltip", ctx.to.tooltip)("hidden", ctx.to.readonly)("readonly", ctx.to.readonly)("placeholder", ctx.to.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 19, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue), "\n");
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2$1.CapturumInputComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderEmailInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EntityDialogAction = /*#__PURE__*/function (EntityDialogAction) {
  EntityDialogAction["submit"] = "submit";
  EntityDialogAction["cancel"] = "cancel";
  return EntityDialogAction;
}(EntityDialogAction || {});
var EntityInfoType = /*#__PURE__*/function (EntityInfoType) {
  EntityInfoType["name"] = "name";
  EntityInfoType["columns"] = "columns";
  EntityInfoType["relations"] = "relations";
  EntityInfoType["method"] = "method";
  EntityInfoType["methods"] = "methods";
  EntityInfoType["start"] = "start";
  EntityInfoType["list"] = "list";
  EntityInfoType["form"] = "form";
  return EntityInfoType;
}(EntityInfoType || {});
var EntityInfoSourceMethod = /*#__PURE__*/function (EntityInfoSourceMethod) {
  EntityInfoSourceMethod["getSourceValueByKey"] = "getSourceValueByKey";
  EntityInfoSourceMethod["getFormValueByKey"] = "getFormValueByKey";
  return EntityInfoSourceMethod;
}(EntityInfoSourceMethod || {});
let BuilderUiEntityService = /*#__PURE__*/(() => {
  class BuilderUiEntityService extends ApiService {
    constructor(apiHttp) {
      super(apiHttp);
      this.endpoint = 'builder/ui/entity';
    }
    searchEntityInformation(data) {
      return this.apiHttp.post(`/${this.endpoint}/info`, data);
    }
    static {
      this.ɵfac = function BuilderUiEntityService_Factory(t) {
        return new (t || BuilderUiEntityService)(i0.ɵɵinject(i1$3.ApiHttpService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderUiEntityService,
        factory: BuilderUiEntityService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BuilderUiEntityService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderContentWrapperComponent = /*#__PURE__*/(() => {
  class CapturumBuilderContentWrapperComponent extends FieldWrapper {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderContentWrapperComponent_BaseFactory;
        return function CapturumBuilderContentWrapperComponent_Factory(t) {
          return (ɵCapturumBuilderContentWrapperComponent_BaseFactory || (ɵCapturumBuilderContentWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderContentWrapperComponent)))(t || CapturumBuilderContentWrapperComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderContentWrapperComponent,
        selectors: [["cpb-content-wrapper"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 0,
        consts: [["fieldComponent", ""]],
        template: function CapturumBuilderContentWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderContentWrapperComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumTooltipComponent = /*#__PURE__*/(() => {
  class CapturumTooltipComponent {
    constructor() {
      this.position = 'bottom-right';
      this.isShort = false;
    }
    static {
      this.ɵfac = function CapturumTooltipComponent_Factory(t) {
        return new (t || CapturumTooltipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumTooltipComponent,
        selectors: [["cpb-tooltip"]],
        inputs: {
          position: "position",
          isShort: "isShort"
        },
        ngContentSelectors: _c0,
        decls: 3,
        vars: 16,
        consts: [[1, "cpb-tooltip-arrow", 3, "ngClass"], [3, "ngClass"]],
        template: function CapturumTooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelement(0, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c5, i0.ɵɵpureFunction0(4, _c3).includes(ctx.position), i0.ɵɵpureFunction0(5, _c4).includes(ctx.position), ctx.isShort));
            i0.ɵɵadvance(1);
            i0.ɵɵclassMap("cpb-tooltip-body " + ctx.position);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c6, i0.ɵɵpureFunction0(10, _c3).includes(ctx.position), i0.ɵɵpureFunction0(11, _c4).includes(ctx.position), ctx.isShort));
          }
        },
        dependencies: [i1$1.NgClass],
        styles: [".cpb-tooltip-arrow{position:absolute;width:100%;display:none;z-index:101;animation:.3s linear fadeIn;left:-.2rem}.cpb-tooltip-arrow:after{content:\"\";position:absolute;top:0;left:calc(50% - .219rem)}.cpb-tooltip-arrow.arrow-top{top:16px}.cpb-tooltip-arrow.arrow-top:after{border:.438rem solid transparent;border-bottom-color:#495057}.cpb-tooltip-arrow.arrow-top.short{top:1.625rem}.cpb-tooltip-arrow.arrow-bottom{bottom:2.313rem}.cpb-tooltip-arrow.arrow-bottom:after{border:.438rem solid transparent;border-top-color:#495057}.cpb-tooltip-body{display:none;position:absolute;z-index:100;padding:.7rem 1rem;background:#495057;border-radius:2px;width:auto;min-width:18rem;max-width:23rem;font-size:.85rem;animation:.3s linear fadeIn;color:#fff;font-family:opensans regular;line-height:21px}.cpb-tooltip-body.body-bottom.bottom-right{bottom:-50px;right:-16px}.cpb-tooltip-body.body-bottom.bottom-left{bottom:-50px;left:-16px}.br{right:0;box-shadow:0 0 10px #0000001f;top:55px}.br.short{top:2.5rem}.tr{right:-1rem;box-shadow:0 0 10px #0000001f;bottom:2.313rem}.bl{left:0;box-shadow:0 0 10px #0000001f;top:55px}.tl{left:0;box-shadow:0 0 10px #0000001f;bottom:2.313rem}@keyframes fadeIn{0%{opacity:0}}.tooltip-content{position:relative;display:inline;line-height:17px;max-height:18px}.tooltip-content:hover .cpb-tooltip-body,.tooltip-content:hover .cpb-tooltip-arrow{display:block}.tooltip-content i{color:var(--cap-primary-color)}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumTooltipComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormTooltipComponent = /*#__PURE__*/(() => {
  class FormTooltipComponent {
    constructor() {
      this.position = 'bottom-right';
    }
    static {
      this.ɵfac = function FormTooltipComponent_Factory(t) {
        return new (t || FormTooltipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormTooltipComponent,
        selectors: [["cpb-form-tooltip"]],
        inputs: {
          text: "text",
          position: "position"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [1, "fas", "fa-info-circle"], [3, "position"], [1, "text-tooltip", 3, "innerHTML"]],
        template: function FormTooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FormTooltipComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.text);
          }
        },
        dependencies: [i1$1.NgIf, CapturumTooltipComponent],
        encapsulation: 2
      });
    }
  }
  return FormTooltipComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderValidationMessageComponent = /*#__PURE__*/(() => {
  class CapturumBuilderValidationMessageComponent {
    constructor(store) {
      this.store = store;
    }
    ngOnInit() {
      if (this.field) {
        this.validationErrors = this.store.select(FormRendererState.validationErrorsByKeyAndControlName(this.field.props.formKey, this.field.key));
        if (this.field.form.get(this.field.key)) {
          this.subscription = this.field.form.get(this.field.key).valueChanges.subscribe(() => {
            this.store.dispatch(new ResetFormFieldValidationErrors(this.field.props.formKey, this.field.key));
          });
        }
      }
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function CapturumBuilderValidationMessageComponent_Factory(t) {
        return new (t || CapturumBuilderValidationMessageComponent)(i0.ɵɵdirectiveInject(i1.Store));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderValidationMessageComponent,
        selectors: [["cbp-validation-message"]],
        inputs: {
          field: "field"
        },
        decls: 2,
        vars: 3,
        consts: [["class", "cpb-validation-message", 4, "ngIf"], [1, "cpb-validation-message"]],
        template: function CapturumBuilderValidationMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumBuilderValidationMessageComponent_span_0_Template, 2, 1, "span", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.validationErrors));
          }
        },
        dependencies: [i1$1.NgIf, i1$1.AsyncPipe],
        styles: ["span.cpb-validation-message[_ngcontent-%COMP%]{font-size:.75rem;color:#ff3b30}"]
      });
    }
  }
  return CapturumBuilderValidationMessageComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderDefaultInputWrapperComponent = /*#__PURE__*/(() => {
  class CapturumBuilderDefaultInputWrapperComponent extends FieldWrapper {
    constructor(store) {
      super();
      this.store = store;
      this.labelPosition = LabelPosition;
    }
    ngOnInit() {
      this.submitted = this.store.select(FormRendererState.isSubmitted(this.to.formKey));
    }
    static {
      this.ɵfac = function CapturumBuilderDefaultInputWrapperComponent_Factory(t) {
        return new (t || CapturumBuilderDefaultInputWrapperComponent)(i0.ɵɵdirectiveInject(i1.Store));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderDefaultInputWrapperComponent,
        selectors: [["cpb-default-input-wrapper"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 22,
        consts: [[1, "form-group", "cbp-default-input-wrapper", 3, "ngClass"], ["class", "label-wrapper", 4, "ngIf"], [1, "field-wrapper"], ["fieldComponent", ""], [1, "form-invalid-feedback"], [3, "field"], ["class", "form-text text-muted", 4, "ngIf"], [1, "label-wrapper"], ["class", "d-block", 4, "ngIf"], [1, "tooltip-content", 3, "text", "position"], [1, "d-block"], ["class", "cpb-required-indicator", 4, "ngIf"], [1, "cpb-required-indicator"], [1, "form-text", "text-muted"]],
        template: function CapturumBuilderDefaultInputWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵtemplate(3, CapturumBuilderDefaultInputWrapperComponent_div_3_Template, 5, 7, "div", 1);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementStart(6, "div", 2);
            i0.ɵɵtemplate(7, CapturumBuilderDefaultInputWrapperComponent_ng_template_7_Template, 0, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(9, "div", 4);
            i0.ɵɵpipe(10, "async");
            i0.ɵɵelement(11, "cbp-validation-message", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, CapturumBuilderDefaultInputWrapperComponent_small_12_Template, 4, 5, "small", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("cpb-readonly", ctx.formState.readonly)("has-error", ctx.showError)("position-before", i0.ɵɵpipeBind1(1, 12, i0.ɵɵpipeBind1(2, 14, ctx.to.label_position)) === ctx.labelPosition.Before);
            i0.ɵɵproperty("ngClass", ctx.to.css_class);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !(i0.ɵɵpipeBind1(4, 16, i0.ɵɵpipeBind1(5, 18, ctx.to.label_position)) === ctx.labelPosition.Floating));
            i0.ɵɵadvance(6);
            i0.ɵɵstyleProp("visibility", (i0.ɵɵpipeBind1(10, 20, ctx.submitted) || ctx.showError) && !ctx.formState.readonly ? "visible" : "hidden");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("field", ctx.field);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to.description);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, FormTooltipComponent, CapturumBuilderValidationMessageComponent, i1$1.AsyncPipe, i5.ObservablePipe],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.cbp-default-input-wrapper .form-invalid-feedback{color:#fa4331;min-height:1.2em}.cbp-default-input-wrapper.form-group.position-before{display:flex;margin:1rem 0}.cbp-default-input-wrapper.form-group.position-before .label-wrapper{flex:0 1 20%;max-width:20%}.cbp-default-input-wrapper.form-group.position-before .label-wrapper label{display:flex!important;align-items:center}.cbp-default-input-wrapper.form-group.position-before .field-wrapper{flex:1}.cbp-default-input-wrapper .label-wrapper{display:flex;justify-content:space-between}.cbp-default-input-wrapper label:not(.cpb-float-label){margin:0}.cbp-default-input-wrapper cap-validator{display:none}.cbp-default-input-wrapper formly-validation-message{font-size:.8em}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderDefaultInputWrapperComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderCollapsableWrapperComponent = /*#__PURE__*/(() => {
  class CapturumBuilderCollapsableWrapperComponent extends FieldWrapper {
    constructor() {
      super(...arguments);
      this.clickable = true;
    }
    toggleCard() {
      this.accordionCard.toggleCard(this.clickable);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderCollapsableWrapperComponent_BaseFactory;
        return function CapturumBuilderCollapsableWrapperComponent_Factory(t) {
          return (ɵCapturumBuilderCollapsableWrapperComponent_BaseFactory || (ɵCapturumBuilderCollapsableWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderCollapsableWrapperComponent)))(t || CapturumBuilderCollapsableWrapperComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderCollapsableWrapperComponent,
        selectors: [["cpb-collapsable-wrapper"]],
        viewQuery: function CapturumBuilderCollapsableWrapperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionCard = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 3,
        consts: [[3, "isOpen", "clickable", "headerTemplate"], ["accordionCard", ""], ["capTemplate", "content"], ["accordionHeader", ""], ["fieldComponent", ""], [1, "ac-header__left"], [1, "accordion-card__title", 3, "click"], [1, "accordion-card__actions"], [1, "tooltip-content", 3, "text"]],
        template: function CapturumBuilderCollapsableWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-accordion-card", 0, 1);
            i0.ɵɵtemplate(2, CapturumBuilderCollapsableWrapperComponent_ng_template_2_Template, 2, 0, "ng-template", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CapturumBuilderCollapsableWrapperComponent_ng_template_3_Template, 5, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const _r2 = i0.ɵɵreference(4);
            i0.ɵɵproperty("isOpen", !ctx.to.collapsed)("clickable", ctx.clickable)("headerTemplate", _r2);
          }
        },
        dependencies: [i5.CapturumTemplateDirective, i2$2.CapturumAccordionCardComponent, FormTooltipComponent],
        styles: ["[_nghost-%COMP%]     .accordion-card{border:1px solid #ddd;border-radius:5px;margin-bottom:15px}[_nghost-%COMP%]     .accordion-card__header{justify-content:flex-start}[_nghost-%COMP%]     .accordion-card__header .ac-header__left{flex:1;align-items:center;justify-content:space-between;padding-right:1rem}[_nghost-%COMP%]     .accordion-card__header .ac-header__right{width:auto}[_nghost-%COMP%]     .accordion-card__title{cursor:pointer}[_nghost-%COMP%]     .accordion-card__content{transition:none}"],
        changeDetection: 0
      });
    }
  }
  return CapturumBuilderCollapsableWrapperComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderCheckboxWrapperComponent = /*#__PURE__*/(() => {
  class CapturumBuilderCheckboxWrapperComponent extends FieldWrapper {
    constructor(store) {
      super();
      this.store = store;
      this.labelPosition = LabelPosition;
    }
    ngOnInit() {
      this.submitted = this.store.select(FormRendererState.isSubmitted(this.to.formKey));
    }
    static {
      this.ɵfac = function CapturumBuilderCheckboxWrapperComponent_Factory(t) {
        return new (t || CapturumBuilderCheckboxWrapperComponent)(i0.ɵɵdirectiveInject(i1.Store));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderCheckboxWrapperComponent,
        selectors: [["cpb-checkbox-wrapper"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 20,
        consts: [[1, "checkbox-wrapper", "form-group"], [1, "checkbox-wrapper-container"], [1, "label-wrapper"], ["class", "checkbox-label", 4, "ngIf"], [1, "field-wrapper"], ["fieldComponent", ""], [1, "tooltip-content", 3, "text"], [1, "form-invalid-feedback"], [3, "field"], ["class", "form-text text-muted", 4, "ngIf"], [1, "checkbox-label"], ["class", "cpb-required-indicator", 4, "ngIf"], [1, "cpb-required-indicator"], [1, "form-text", "text-muted"]],
        template: function CapturumBuilderCheckboxWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵelementStart(3, "div", 1)(4, "div", 2);
            i0.ɵɵtemplate(5, CapturumBuilderCheckboxWrapperComponent_label_5_Template, 3, 3, "label", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵtemplate(7, CapturumBuilderCheckboxWrapperComponent_ng_template_7_Template, 0, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "cpb-form-tooltip", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelement(12, "cbp-validation-message", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, CapturumBuilderCheckboxWrapperComponent_small_13_Template, 4, 5, "small", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("cpb-readonly", ctx.to.readonly)("has-error", ctx.showError)("position-before", i0.ɵɵpipeBind1(1, 14, i0.ɵɵpipeBind1(2, 16, ctx.to.label_position)) === ctx.labelPosition.Before);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("readonly-container", ctx.to.readonly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.to.label && ctx.to.hideLabel !== true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("text", ctx.to.tooltip);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("visibility", (i0.ɵɵpipeBind1(11, 18, ctx.submitted) || ctx.showError) && !ctx.formState.readonly ? "visible" : "hidden");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("field", ctx.field);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to.description);
          }
        },
        dependencies: [i1$1.NgIf, FormTooltipComponent, CapturumBuilderValidationMessageComponent, i1$1.AsyncPipe, i5.ObservablePipe],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.checkbox-wrapper .form-invalid-feedback{color:#fa4331;min-height:1.2em}.checkbox-wrapper.form-group.position-before .checkbox-wrapper-container{display:flex;margin:1rem 0}.checkbox-wrapper.form-group.position-before .checkbox-wrapper-container .label-wrapper{flex:0 1 20%;max-width:20%}.checkbox-wrapper.form-group.position-before .checkbox-wrapper-container .label-wrapper label{display:flex!important;align-items:center}.checkbox-wrapper.form-group.position-before .checkbox-wrapper-container .field-wrapper{flex:1}.checkbox-wrapper .label-wrapper{display:flex;justify-content:space-between}.checkbox-wrapper label{margin:0}.checkbox-wrapper cap-validator{display:none}.checkbox-wrapper formly-validation-message{font-size:.8em}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderCheckboxWrapperComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderHiddenWrapperComponent = /*#__PURE__*/(() => {
  class CapturumBuilderHiddenWrapperComponent extends FieldWrapper {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderHiddenWrapperComponent_BaseFactory;
        return function CapturumBuilderHiddenWrapperComponent_Factory(t) {
          return (ɵCapturumBuilderHiddenWrapperComponent_BaseFactory || (ɵCapturumBuilderHiddenWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderHiddenWrapperComponent)))(t || CapturumBuilderHiddenWrapperComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderHiddenWrapperComponent,
        selectors: [["cpb-hidden-wrapper"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function CapturumBuilderHiddenWrapperComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderHiddenWrapperComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const inputTypeWrappers = [{
  name: 'content',
  component: CapturumBuilderContentWrapperComponent
}, {
  name: 'default-input-wrapper',
  component: CapturumBuilderDefaultInputWrapperComponent
}, {
  name: 'collapsable-wrapper',
  component: CapturumBuilderCollapsableWrapperComponent
}, {
  name: 'checkbox-wrapper',
  component: CapturumBuilderCheckboxWrapperComponent
}, {
  name: 'hidden',
  component: CapturumBuilderHiddenWrapperComponent
}];
let SetValue = /*#__PURE__*/(() => {
  class SetValue {
    static {
      this.type = '[FormBuilder] Set value';
    }
    constructor(key, value) {
      this.key = key;
      this.value = value;
    }
  }
  return SetValue;
})();
let SetFormValue = /*#__PURE__*/(() => {
  class SetFormValue {
    static {
      this.type = '[FormRenderer] Set form value';
    }
    constructor(key, value) {
      this.key = key;
      this.value = value;
    }
  }
  return SetFormValue;
})();
let SetFormConfiguration = /*#__PURE__*/(() => {
  class SetFormConfiguration {
    static {
      this.type = '[FormRenderer] Set form configuration';
    }
    constructor(key, configuration, context) {
      this.key = key;
      this.configuration = configuration;
      this.context = context;
    }
  }
  return SetFormConfiguration;
})();
let SetFormStatus = /*#__PURE__*/(() => {
  class SetFormStatus {
    static {
      this.type = '[FormRenderer] Set form status';
    }
    constructor(key, valid) {
      this.key = key;
      this.valid = valid;
    }
  }
  return SetFormStatus;
})();
let ResetFormValue = /*#__PURE__*/(() => {
  class ResetFormValue {
    static {
      this.type = '[FormRenderer] Reset form value';
    }
    constructor(key) {
      this.key = key;
    }
  }
  return ResetFormValue;
})();
const defaultLayoutTemplates = {
  default: {
    amountOfContentGroups: 1,
    locations: {
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'col'
      },
      header: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      },
      footer: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      }
    }
  },
  one_column: {
    amountOfContentGroups: 1,
    locations: {
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      }
    }
  },
  two_column: {
    amountOfContentGroups: 2,
    locations: {
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12 lg:cpb-col-6'
      }
    }
  },
  three_column: {
    amountOfContentGroups: 3,
    locations: {
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-4'
      }
    }
  },
  two_columns_with_header_and_footer: {
    amountOfContentGroups: 2,
    locations: {
      header: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      },
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12 md:cpb-col-6'
      },
      footer: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      }
    }
  },
  three_columns_with_header_and_footer: {
    amountOfContentGroups: 3,
    locations: {
      header: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      },
      content: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12 md:cpb-col-4'
      },
      footer: {
        containerClass: 'cpb-grid',
        groupClass: 'cpb-col-12'
      }
    }
  }
};
class FormFieldsManipulatorUtil {
  static getFormInputByKey(fieldGroup, key) {
    let selectedFieldGroup = null;
    for (const fieldConfig of fieldGroup) {
      if (fieldConfig.key && fieldConfig.key === key) {
        selectedFieldGroup = fieldConfig;
        break;
      } else if (fieldConfig?.fieldGroup?.length && !selectedFieldGroup) {
        selectedFieldGroup = FormFieldsManipulatorUtil.getFormInputByKey(fieldConfig?.fieldGroup, key);
      }
    }
    return selectedFieldGroup;
  }
  static patchprops(formConfig, key, props) {
    const input = FormFieldsManipulatorUtil.getFormInputByKey(formConfig, key);
    input.props = {
      ...input.props,
      ...props
    };
    return formConfig;
  }
  static patchFormField(formConfig, key, fieldConfig) {
    const input = FormFieldsManipulatorUtil.getFormInputByKey(formConfig, key);
    for (const fieldConfigKey in fieldConfig) {
      if (input.hasOwnProperty(fieldConfigKey) && fieldConfig.hasOwnProperty(fieldConfigKey)) {
        if (fieldConfigKey === 'props') {
          input[fieldConfigKey] = {
            ...input[fieldConfigKey],
            ...fieldConfig[fieldConfigKey]
          };
        } else {
          input[fieldConfigKey] = fieldConfig[fieldConfigKey];
        }
      }
    }
    return formConfig;
  }
  static getFormlyTypeName(inputType) {
    return `cpb-${inputType}`;
  }
}
let FormBuilderBaseDataService = /*#__PURE__*/(() => {
  class FormBuilderBaseDataService {
    constructor(translateService) {
      this.translateService = translateService;
    }
    list(key) {
      return from(BaseDataIndexedDbModel.query().where({
        key
      }).first()).pipe(this.prepareBaseDataValues.bind(this));
    }
    getBaseDataValuesByKeyAndAttribute(key, attributeKey, attributeValue = null) {
      return from(BaseDataValueIndexedDbModel.getByBaseDataKey(`${key}`)).pipe(map(baseDataValues => {
        const items = [];
        baseDataValues.forEach(baseDataValue => {
          if (this.hasAttributeByKeyAndValue(baseDataValue, attributeKey, attributeValue) || !attributeKey && !attributeValue) {
            items.push({
              ...baseDataValue,
              ...this.convertBaseDataValueToMapItem({
                id: baseDataValue.id,
                value: baseDataValue.value
              })
            });
          }
        });
        return items;
      }));
    }
    getBaseDataValueTranslation(baseDataValue) {
      return baseDataValue?.id ? this.translateService.instant(`base-data.${baseDataValue.id}`) : null;
    }
    convertBaseDataValueToMapItem(baseDataValue) {
      return {
        label: this.getBaseDataValueTranslation(baseDataValue),
        value: baseDataValue.id,
        value_key: baseDataValue.value
      };
    }
    getById(id) {
      const result = BaseDataValueIndexedDbModel.query().where({
        id
      }).first();
      return from(result).pipe(map(data => ({
        ...data,
        label: this.getBaseDataValueTranslation(data)
      })));
    }
    hasAttributeByKeyAndValue(baseDataValue, attributeKey, attributeValue) {
      if (attributeKey && attributeValue && !baseDataValue.attributes && baseDataValue.attributes.length) {
        return !!baseDataValue.attributes.find(attribute => {
          if (attribute.attribute.data_type.type === 'boolean') {
            attribute.value = attribute.value === 'true';
          }
          return attribute.attribute.key === attributeKey && attribute.value === attributeValue;
        });
      }
      return false;
    }
    prepareBaseDataValues(source) {
      const self = this;
      return new Observable(subscriber => {
        source.subscribe({
          next(baseDataKey) {
            if (baseDataKey?.values) {
              /* @ts-ignore */
              subscriber.next(self.unflattenBaseDataValueChildren(baseDataKey.values.map(baseDataValue => {
                return {
                  ...self.convertBaseDataValueToMapItem(baseDataValue),
                  parent_id: baseDataValue.parent_id,
                  attributes: baseDataValue.attributes
                };
              })));
            } else {
              subscriber.next([]);
            }
            subscriber.complete();
          }
        });
      });
    }
    unflattenBaseDataValueChildren(list) {
      const children = [];
      for (const item of list) {
        if (item.parent_id) {
          continue;
        }
        const groupItem = {
          ...item,
          children: []
        };
        for (const subItem of list) {
          if (subItem.parent_id !== groupItem.value) {
            continue;
          }
          if (subItem) {
            groupItem.children.push({
              ...subItem
            });
          }
        }
        children.push(groupItem);
      }
      return children;
    }
    static {
      this.ɵfac = function FormBuilderBaseDataService_Factory(t) {
        return new (t || FormBuilderBaseDataService)(i0.ɵɵinject(i6.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormBuilderBaseDataService,
        factory: FormBuilderBaseDataService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormBuilderBaseDataService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormInputHelperService = /*#__PURE__*/(() => {
  class FormInputHelperService {
    constructor(store, authService, baseDataService, validatorService) {
      this.store = store;
      this.authService = authService;
      this.baseDataService = baseDataService;
      this.validatorService = validatorService;
      this.subscription = new Subscription();
      this.inputsConfiguration = {};
      this.setDefaultStateValues();
      this.addCustomTranslation();
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
      this.inputsConfiguration = {};
    }
    handleOptionsSourceSets(field, configuration) {
      if (field.formControl) {
        this.subscription.add(field.formControl.valueChanges.pipe(startWith(field.formControl.value), switchMap(fieldValue => {
          return field.props ? field.props.options$.asObservable().pipe(map(fieldOptions => ({
            fieldValue,
            fieldOptions
          }))) : of({
            fieldValue: null,
            fieldOptions: []
          });
        })).subscribe(({
          fieldValue,
          fieldOptions
        }) => {
          this.setValueByKey(configuration.sets, fieldOptions.find(item => item[configuration.options.source.value_key] === fieldValue));
        }));
      }
    }
    resolveDependencies(field, dependencies, dependencyOperator, options$) {
      if (field.form) {
        const source$ = this.getDependenciesSource(this.getDependencyParts(dependencies, field.form));
        if (source$) {
          this.subscription.add(combineLatest(source$).pipe(map(data => data.filter(value => value !== null && value !== undefined))).subscribe(data => {
            const isOrOperator = dependencyOperator === DependencyOperator.or;
            if (field.formControl) {
              field.formControl.reset(field.formControl.value);
            }
            field.hide = isOrOperator ? data.every(isHidden => isHidden) : data.some(isHidden => isHidden);
            if (!field.hide) {
              // Set default options
              if (options$) {
                this.setDefaultDropdownOption(options$, field);
              }
            }
          }));
        }
      }
    }
    getValidations(validations = []) {
      const validators = {};
      if (validations && validations.length) {
        validations.forEach(validation => {
          if (validation === 'required') {
            validators.required = true;
          } else if (validation.startsWith('max')) {
            validators.maxLength = validation.split(':')[1];
          }
        });
      }
      return validators;
    }
    setCustomValidations(validations, field) {
      if (field.formControl && field.form) {
        if (validations?.hasOwnProperty('required_if')) {
          const source$ = [...this.getDependenciesSource(this.getDependencyParts(validations.required_if, field.form)), field.formControl.valueChanges.pipe(startWith(field.formControl.value))];
          if (source$) {
            this.subscription.add(combineLatest(source$).pipe(map(data => data.filter(value => value !== null && value !== undefined))).subscribe(data => {
              if (field.form) {
                const required = data.every(isHidden => !isHidden);
                const fieldControl = field.form.get(field.key);
                if (required) {
                  fieldControl?.setErrors({
                    required
                  });
                } else {
                  fieldControl?.clearValidators();
                  fieldControl?.updateValueAndValidity({
                    onlySelf: true,
                    emitEvent: false
                  });
                }
              }
            }));
          }
        }
      }
    }
    getLabelKeyBySource(source) {
      let labelKey = source?.label_key;
      if (source?.type === 'base_data') {
        labelKey = 'label';
      }
      return labelKey;
    }
    getValueKeyBySource(source) {
      let labelKey = source?.value_key;
      if (source?.type === 'base_data') {
        labelKey = 'value';
      }
      return labelKey;
    }
    setValueByKey(key, value) {
      this.store.dispatch(new SetValue(key, value));
    }
    getValueByKeyOrDefault(key, defaultValue = null) {
      const formBuilderState = this.store.selectSnapshot(state => state.formBuilder);
      const value = formBuilderState[key];
      return value === undefined || value === null ? defaultValue : value;
    }
    getValueAsArrayByKeyOrDefault(key, defaultValue = null) {
      const formBuilderState = this.store.selectSnapshot(state => state.formBuilder);
      let value = formBuilderState[key];
      if (value !== null && value !== undefined) {
        value = Array.isArray(value) ? value : [value];
      }
      return value === null || value === undefined ? defaultValue : value;
    }
    getOptionsWithImageKey(options, imageKey) {
      if (imageKey) {
        options = options.map(option => ({
          ...option,
          url: `assets/images/form-builder${imageKey}.png`
        }));
      }
      return options;
    }
    setInputConfiguration(name, configuration) {
      this.inputsConfiguration[name] = configuration;
    }
    setDefaultOption(field, options) {
      const defaultOption = options.find(option => option.is_default);
      const defaultValue = field.props && defaultOption ? defaultOption[field.props.value_key] : null;
      if (field.formControl && (field.defaultValue === null || field.defaultValue === undefined) && defaultValue !== null && defaultValue !== undefined) {
        field.formControl.setValue(defaultValue);
      }
    }
    setDefaultDropdownOption(options$, field) {
      if (options$) {
        options$.pipe(take(1)).subscribe(options => {
          this.setDefaultOption(field, options);
          if (field.props) {
            field.props.options$.next(options);
          }
        });
      }
    }
    setDefaultStateValues() {
      this.store.dispatch([new SetValue('currentUser', this.authService.getUser())]);
    }
    getDependencyParts(dependencies, form) {
      return dependencies.map(dependency => {
        let field;
        let values = [];
        let control;
        if (dependency.includes(':')) {
          const dependencyParts = dependency.split(':');
          field = dependencyParts[0];
          values = dependencyParts[1].split(',');
        } else {
          field = dependency;
        }
        control = form.get(field);
        return {
          field,
          values,
          control
        };
      });
    }
    getDependenciesSource(dependencyParts) {
      if (dependencyParts?.length) {
        return dependencyParts.map(dependency => dependency.control ? dependency.control.valueChanges.pipe(startWith(dependency.control.value), switchMap(value => {
          const isFieldBaseDataValue = this.inputsConfiguration[dependency.field]?.props?.is_base_data;
          if (value && isFieldBaseDataValue) {
            return this.baseDataService.getById(value).pipe(map(baseDataItem => baseDataItem.value));
          } else {
            return of(value);
          }
        }), map(value => {
          if (dependency.values?.length) {
            const isEmptyArray = Array.isArray(value) && value.length;
            return (!value || isEmptyArray) && dependency.values.includes('empty') ? false : !dependency.values.includes(value?.toString());
          } else {
            return value === null || value === undefined || value === false;
          }
        })) : of(false));
      }
      return [];
    }
    addCustomTranslation() {
      this.validatorService.setValidationMessages({
        maxlength: 'validation-errors.maxlength'
      });
    }
    static {
      this.ɵfac = function FormInputHelperService_Factory(t) {
        return new (t || FormInputHelperService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2$3.AuthService), i0.ɵɵinject(FormBuilderBaseDataService), i0.ɵɵinject(i5.ValidatorService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormInputHelperService,
        factory: FormInputHelperService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormInputHelperService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionsPipe = /*#__PURE__*/(() => {
  class OptionsPipe extends ApiService {
    constructor(apiHttpService, baseDataService, formInputHelperService, builderApiService, coreConfigService) {
      super(apiHttpService);
      this.baseDataService = baseDataService;
      this.formInputHelperService = formInputHelperService;
      this.builderApiService = builderApiService;
      this.coreConfigService = coreConfigService;
    }
    transform(source, key) {
      let storageClass;
      if (source?.action?.endpoint) {
        if (source.action.options.cache?.enabled) {
          storageClass = this.coreConfigService.getStorageClassByKey(source.action.options.cache.driver);
          if (storageClass) {
            const data = storageClass.getItem(source?.action?.endpoint);
            if (data) {
              return of(data);
            }
          }
        }
        return this.builderApiService.get(key, `${this.getUrl(source.action.endpoint)}`).pipe(responseData, tap(data => {
          if (storageClass && source?.action?.options.cache?.enabled) {
            storageClass.setItem(source?.action?.endpoint, data, source?.action?.options.cache?.expiration);
          }
        }));
      } else if (source.items) {
        return of(source.items);
      }
      return of([]);
    }
    getUrl(endpoint) {
      return endpoint.split('/').map(path => this.isPathVariable(path) ? this.formInputHelperService.getValueByKeyOrDefault(path.slice(1, -1)) : path).join('/');
    }
    isPathVariable(value) {
      return value.startsWith('{') && value.endsWith('}');
    }
    static {
      this.ɵfac = function OptionsPipe_Factory(t) {
        return new (t || OptionsPipe)(i0.ɵɵdirectiveInject(i1$3.ApiHttpService, 16), i0.ɵɵdirectiveInject(FormBuilderBaseDataService, 16), i0.ɵɵdirectiveInject(FormInputHelperService, 16), i0.ɵɵdirectiveInject(i4.BuilderApiService, 16), i0.ɵɵdirectiveInject(i4.BuilderCoreConfigService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "options",
        type: OptionsPipe,
        pure: true
      });
    }
  }
  return OptionsPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormRendererConfigService = /*#__PURE__*/(() => {
  class FormRendererConfigService {
    constructor() {
      this.translationKeyPrefix = '';
      this.layoutTemplates = {};
    }
    addConfig(config) {
      if (config?.translationKeyPrefix) {
        this.translationKeyPrefix = config.translationKeyPrefix;
      }
      if (config?.formBuilderApi) {
        this.formBuilderApi = config.formBuilderApi;
      }
      if (config?.dynamicForms) {
        this.dynamicForms = [...(config.dynamicForms || []), ...(this.dynamicForms || [])];
      }
      if (config?.layoutTemplates) {
        this.layoutTemplates = {
          ...this.layoutTemplates,
          ...config.layoutTemplates
        };
      }
      if (config?.types) {
        this.types = [...(this.types || []), ...(config.types || [])];
      }
      if (config?.builders) {
        this.builders = {
          ...this.builders,
          ...config.builders
        };
      }
      if (config?.defaultEmptyValue) {
        this.defaultEmptyValue = config.defaultEmptyValue;
      }
    }
    static {
      this.ɵfac = function FormRendererConfigService_Factory(t) {
        return new (t || FormRendererConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormRendererConfigService,
        factory: FormRendererConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormRendererConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormManipulatorService = /*#__PURE__*/(() => {
  class FormManipulatorService {
    constructor(apiHttpService) {
      this.apiHttpService = apiHttpService;
      this.formManipulations = new BehaviorSubject(null);
    }
    get formManipulations$() {
      return this.formManipulations.asObservable();
    }
    getFormManipulation(formKey) {
      return this.formManipulations$.pipe(filter(manipulations => !!manipulations[formKey]), map(manipulations => manipulations[formKey]));
    }
    getFieldManipulations(formKey, fieldKey) {
      return this.formManipulations$.pipe(filter(manipulations => !!manipulations?.[formKey]?.[fieldKey]), map(manipulations => manipulations[formKey][fieldKey]));
    }
    setFieldManipulation(formKey, fieldKey, manipulations) {
      this.formManipulations.next({
        [formKey]: {
          [fieldKey]: manipulations
        }
      });
    }
    registerTriggerHandler(field, formKey, configuration) {
      if (field?.formControl) {
        field.formControl.valueChanges.pipe(debounceTime(400), switchMap(() => {
          return this.apiHttpService.post(formKey, configuration.trigger.action.endpoint, field.form.getRawValue());
        }), takeUntil(field.props.destroy)).subscribe(response => {
          this.formManipulations.next({
            [formKey]: response
          });
        });
      }
    }
    resetFormManipulations(formKey) {
      this.formManipulations.next({
        [formKey]: null
      });
    }
    static {
      this.ɵfac = function FormManipulatorService_Factory(t) {
        return new (t || FormManipulatorService)(i0.ɵɵinject(i4.BuilderApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormManipulatorService,
        factory: FormManipulatorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormManipulatorService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormInputTypeFacade = /*#__PURE__*/(() => {
  class FormInputTypeFacade {
    constructor(optionsPipe, formInputHelperService, translateService, formRendererConfig, store, formManipulatorService) {
      this.optionsPipe = optionsPipe;
      this.formInputHelperService = formInputHelperService;
      this.translateService = translateService;
      this.formRendererConfig = formRendererConfig;
      this.store = store;
      this.formManipulatorService = formManipulatorService;
    }
    getTransformedOptions(source, formKey) {
      return this.optionsPipe.transform(source, formKey).pipe(map(options => {
        return this.formInputHelperService.getOptionsWithImageKey([...options], source.source?.image_key);
      }), shareReplay(1));
    }
    setInputConfiguration(name, configuration) {
      this.formInputHelperService.setInputConfiguration(name, configuration);
    }
    handleOptionsSourceSets(field, configuration) {
      this.formInputHelperService.handleOptionsSourceSets(field, configuration);
    }
    resolveDependencies(field, configuration, options$) {
      this.formInputHelperService.resolveDependencies(field, configuration.dependencies, configuration.dependency_operator, options$);
    }
    setDefaultDropdownOption(options$, field) {
      this.formInputHelperService.setDefaultDropdownOption(options$, field);
    }
    setCustomValidations(configuration, field) {
      if (configuration?.validations) {
        this.formInputHelperService.setCustomValidations(configuration.validations, field);
      }
    }
    getValidations(configuration) {
      if (configuration?.validations) {
        return this.formInputHelperService.getValidations(configuration?.validations);
      }
      return {};
    }
    getLabelPosition(formKey) {
      return this.store.select(FormRendererState.configurationByKey(formKey)).pipe(switchMap(config => of(config?.label_position ?? null)));
    }
    setValueByKey(sets, value) {
      this.formInputHelperService.setValueByKey(sets, value);
    }
    registerTriggerHandler(field, formKey, configuration) {
      this.formManipulatorService.registerTriggerHandler(field, formKey, configuration);
    }
    getFormManipulations(formKey, fieldKey) {
      return this.formManipulatorService.getFieldManipulations(formKey, fieldKey);
    }
    getFormRendererConfig() {
      return this.formRendererConfig;
    }
    static {
      this.ɵfac = function FormInputTypeFacade_Factory(t) {
        return new (t || FormInputTypeFacade)(i0.ɵɵinject(OptionsPipe), i0.ɵɵinject(FormInputHelperService), i0.ɵɵinject(i6.TranslateService), i0.ɵɵinject(FormRendererConfigService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(FormManipulatorService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormInputTypeFacade,
        factory: FormInputTypeFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormInputTypeFacade;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTypeBuilder = /*#__PURE__*/(() => {
  class InputTypeBuilder {
    constructor(formInputTypeFacade) {
      this.formInputTypeFacade = formInputTypeFacade;
      this.destroy$ = new Subject();
    }
    getInput(configuration, formKey, defaultValue, defaultEmptyValue = '') {
      let options$;
      if (configuration?.options?.action?.endpoint || configuration?.options?.items) {
        options$ = this.formInputTypeFacade.getTransformedOptions(configuration.options, formKey);
      }
      const input = this.getInitialFormlyConfig(configuration, formKey, defaultValue, defaultEmptyValue);
      if (configuration.name) {
        this.formInputTypeFacade.setInputConfiguration(configuration.name, {
          ...input
        });
      }
      if (input?.props?.css_class) {
        input.className = `${input.className || ''} ${input.props.css_class}`;
      }
      input.hooks = {
        onInit: field => {
          if (field) {
            if (configuration.sets) {
              this.formInputTypeFacade.handleOptionsSourceSets(field, configuration);
            }
            if (configuration.options?.disabled) {
              field.formControl.disable();
            }
            if (configuration.dependencies && configuration?.dependencies?.length) {
              this.formInputTypeFacade.resolveDependencies(field, configuration, options$);
            } else {
              if (options$) {
                this.formInputTypeFacade.setDefaultDropdownOption(options$, field);
              }
            }
            this.formInputTypeFacade.setCustomValidations(configuration.validations, field);
          }
          if (input.props.options$) {
            input.props.options = input.props.options$.asObservable();
          }
          if (configuration.trigger) {
            this.checkFieldTriggers(formKey, field, configuration);
          }
          this.formInputTypeFacade.getFormManipulations(formKey, field.key).pipe(takeUntil(this.destroy$)).subscribe(manipulations => {
            if (manipulations.hasOwnProperty('read_only')) {
              field.props.readonly = manipulations.read_only;
            }
            if (manipulations.hasOwnProperty('options')) {
              if (this.inputType === InputType.dropdown || this.inputType === InputType.multiSelect) {
                field.props.options$ = new BehaviorSubject(manipulations.options);
              } else {
                field.props = {
                  ...field.props,
                  ...manipulations.options
                };
              }
            }
            setTimeout(() => {
              if (manipulations.hasOwnProperty('value')) {
                field.formControl.setValue(manipulations.value);
              }
            }, 0);
            if (manipulations.hasOwnProperty('source_endpoint')) {
              field.props.options$ = this.formInputTypeFacade.getTransformedOptions({
                action: {
                  endpoint: manipulations.source_endpoint,
                  options: null
                }
              }, formKey);
            }
          });
        },
        onDestroy: field => {
          field.props.destroy.next();
          this.destroy$.next();
        }
      };
      this.appendOptions(input, configuration);
      this.setDefaultValue(input, defaultValue);
      return input;
    }
    appendOptions(input, configuration) {
      // do nothing
    }
    setDefaultValue(input, value) {
      if (value && !input.defaultValue) {
        input.defaultValue = value[input.key] ?? null;
      }
    }
    setDefaultOption(field, options) {
      const defaultOption = options.find(option => option.is_default);
      const defaultValue = field.props && defaultOption ? defaultOption[field.props.value_key] : null;
      if (field.formControl && (field.defaultValue === null || field.defaultValue === undefined) && defaultValue !== null && defaultValue !== undefined) {
        field.formControl.setValue(defaultValue);
      }
    }
    getInitialFormlyConfig(configuration, formKey, defaultValue, defaultEmptyValue = '') {
      const config = this.formInputTypeFacade.getFormRendererConfig();
      const input = config.types.find(configInputType => configInputType.name === configuration.type);
      const wrappers = input?.wrappers || ['default-input-wrapper'];
      const defaultValueForField = defaultValue?.[configuration?.name] || configuration.default;
      return {
        key: configuration.name,
        defaultValue: defaultValueForField,
        wrappers,
        props: {
          forcedReadonly: !!configuration.readonly,
          readonly: !!configuration.readonly,
          label: configuration.label,
          tooltip: configuration.tooltip,
          placeholder: configuration.placeholder,
          label_key: configuration.options?.label_key || 'label',
          value_key: configuration.options?.value_key || 'key',
          image_key: configuration.options?.source?.image_key,
          options$: new BehaviorSubject([]),
          description: configuration.options?.description,
          sort_asc: configuration.options?.sort_asc,
          css_class: configuration.options?.css_class,
          formKey: formKey,
          disabled: configuration.options?.disabled,
          configurationOptions: configuration.options,
          label_position: this.formInputTypeFacade.getLabelPosition(formKey),
          is_base_data: configuration?.options?.source?.type === 'base_data',
          ...this.formInputTypeFacade.getValidations(configuration),
          destroy: new Subject(),
          defaultEmptyValue
        },
        type: FormFieldsManipulatorUtil.getFormlyTypeName(configuration.type),
        expressionProperties: {
          'props.readonly': 'formState.readonly || field.props.forcedReadonly'
        }
      };
    }
    checkFieldTriggers(formKey, field, configuration) {
      this.formInputTypeFacade.registerTriggerHandler(field, formKey, configuration);
      this.formInputTypeFacade.getFormManipulations(formKey, field.key).pipe(takeUntil(this.destroy$)).subscribe(manipulations => {
        if (manipulations.hasOwnProperty('readonly')) {
          field.props.readonly = manipulations.readonly;
        }
      });
    }
    static {
      this.ɵfac = function InputTypeBuilder_Factory(t) {
        return new (t || InputTypeBuilder)(i0.ɵɵinject(FormInputTypeFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: InputTypeBuilder,
        factory: InputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return InputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomInputTypeBuilder = /*#__PURE__*/(() => {
  class CustomInputTypeBuilder extends InputTypeBuilder {
    appendOptions(input, configuration) {
      if (configuration?.options?.key) {
        input.type = FormFieldsManipulatorUtil.getFormlyTypeName(configuration?.options?.key);
      }
    }
    setDefaultValue(input, value) {
      input.defaultValue = input.defaultValue || value;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCustomInputTypeBuilder_BaseFactory;
        return function CustomInputTypeBuilder_Factory(t) {
          return (ɵCustomInputTypeBuilder_BaseFactory || (ɵCustomInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(CustomInputTypeBuilder)))(t || CustomInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomInputTypeBuilder,
        factory: CustomInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CustomInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FormBuilderModel extends IndexedDbModel {
  constructor(attributes) {
    super(attributes);
    this.entity = 'form-builder';
    this.table = 'form_builder';
    this.schema = 'key';
    this.sync = true;
  }
}
let FormRendererApiService = /*#__PURE__*/(() => {
  class FormRendererApiService extends ApiService {
    constructor(apiHttpService, formBuilderRendererConfigService, store, builderApiService, contextService, sessionStorageService) {
      super(apiHttpService);
      this.formBuilderRendererConfigService = formBuilderRendererConfigService;
      this.store = store;
      this.builderApiService = builderApiService;
      this.contextService = contextService;
      this.sessionStorageService = sessionStorageService;
      this.endpoint = 'builder';
    }
    resolveFormBuilders() {
      return combineLatest([this.getFormConfigs(), from(FormBuilderModel.query().clear()) // @TODO: Remove this?
      ]).pipe(switchMap(([response]) => {
        return from(FormBuilderModel.query().bulkPut(response.data));
      }), switchMap(response => of(true)));
    }
    getFormBuilderByKey(key, contextKey) {
      const currentContext = this.contextService.getContextByKey(contextKey);
      const formConfig = this.sessionStorageService.getItem(`form_config_${key}`);
      if (formConfig && formConfig.config && (!formConfig.context && !currentContext || this.areObjectsEqual(formConfig?.context, currentContext))) {
        return of(formConfig.config);
      }
      return this.builderApiService.get(key, `/${this.endpoint}/config/${key}`).pipe(responseData, tap(configuration => {
        if (configuration.options?.cache) {
          this.sessionStorageService.setItem(`form_config_${key}`, {
            config: configuration,
            context: currentContext
          });
        }
        this.store.dispatch(new SetFormConfiguration(contextKey || key, configuration, this.contextService.getContextByKey(contextKey || key)));
      }));
    }
    getFormConfigs() {
      return this.apiHttp.get(this.formBuilderRendererConfigService.formBuilderApi);
    }
    submitFormValue(endpoint, formValue) {
      return this.apiHttp.post(endpoint, formValue);
    }
    getSource(configuration, id, key) {
      const endpoint = configuration.source.endpoint.replace('{{id}}', id);
      return this.builderApiService.get(key, `${endpoint}`).pipe(map(response => {
        if (response.hasOwnProperty('data')) {
          return response.data;
        }
        return response;
      }));
    }
    areObjectsEqual(object1, object2) {
      return object1 && object2 && Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every(key => object1[key] === object2[key]);
    }
    static {
      this.ɵfac = function FormRendererApiService_Factory(t) {
        return new (t || FormRendererApiService)(i0.ɵɵinject(i1$3.ApiHttpService), i0.ɵɵinject(FormRendererConfigService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i4.BuilderApiService), i0.ɵɵinject(i4.CapturumBuildersContextService), i0.ɵɵinject(i5.SessionStorageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormRendererApiService,
        factory: FormRendererApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormRendererApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormRendererService = /*#__PURE__*/(() => {
  class FormRendererService {
    constructor(formRendererApiService, injector, translateService, formInputHelperService, formRendererConfig, store, contextService) {
      this.formRendererApiService = formRendererApiService;
      this.injector = injector;
      this.translateService = translateService;
      this.formInputHelperService = formInputHelperService;
      this.formRendererConfig = formRendererConfig;
      this.store = store;
      this.contextService = contextService;
    }
    ngOnDestroy() {
      this.formInputHelperService.ngOnDestroy();
    }
    getFields(formKey, defaultValue, contextKey, cacheOptions) {
      this.formKey = formKey;
      const dynamicForm = this.formRendererConfig.dynamicForms && this.formRendererConfig.dynamicForms.find(form => form.key === formKey);
      const formBuilderRequest = dynamicForm ? dynamicForm.callback(this.injector) : this.retrieveBuilderConfig(formKey, contextKey, cacheOptions);
      return formBuilderRequest.pipe(map(formConfigs => this.getFieldConfig(formConfigs, contextKey || formKey, defaultValue)));
    }
    getFieldConfig(formConfigs, formKey, defaultValue) {
      const formConfigGroups = formConfigs.groups;
      const formlyConfig = [];
      const layoutTemplates = this.getLayoutTemplates();
      const formLayoutTemplate = layoutTemplates.hasOwnProperty(formConfigs?.template) ? layoutTemplates[formConfigs?.template] : layoutTemplates.default;
      const locationGroups = formConfigGroups.reduce((acc, group) => {
        acc[group.location] = [...(acc[group.location] || []), group];
        return acc;
      }, {});
      for (const location in locationGroups) {
        if (locationGroups.hasOwnProperty(location)) {
          const locationTemplate = formLayoutTemplate.locations[location];
          const locationGroup = this.getContainerFormGroupConfig(locationTemplate?.containerClass || null);
          locationGroup.fieldGroup = locationGroups[location].map(locationField => {
            return this.getWrapperFormGroup(locationField, locationTemplate, formKey, defaultValue);
          });
          formlyConfig.push(locationGroup);
        }
      }
      return {
        inputs: formlyConfig,
        permissions: formConfigs.permissions,
        title: formConfigs.title,
        callbacks: formConfigs.callbacks
      };
    }
    updateFormValueState(key, value) {
      this.store.dispatch(new SetFormValue(key, value));
    }
    updateFormStatus(key, value) {
      this.store.dispatch(new SetFormStatus(key, value));
    }
    resetFormValue(key) {
      this.store.dispatch(new ResetFormValue(key));
    }
    setSourceValue(key, value) {
      this.store.dispatch(new SetSourceValue(key, value));
    }
    submitToBackend(key, value) {
      return this.formRendererApiService.submitFormValue(key, value);
    }
    getFormValueByKey(key) {
      return this.store.select(FormRendererState.formValueByKey(key)).pipe(take(1));
    }
    getFormValueSnapshotByKey(key) {
      return this.store.selectSnapshot(FormRendererState.formValueByKey(key));
    }
    getFormValueStreamByKey(key) {
      return this.store.select(FormRendererState.formValueByKey(key));
    }
    getSourceValueByKey(key) {
      return this.store.select(FormRendererState.sourceValueByKey(key));
    }
    getFormConfigurationByKey(key) {
      return this.store.select(FormRendererState.configurationByKey(key));
    }
    setConfig(config, key) {
      this.store.dispatch(new SetFormConfiguration(key, config));
    }
    setIsSubmitted(key) {
      this.store.dispatch(new SetSubmitted(key));
    }
    getInputByConfigs(configs, formKey, defaultValue) {
      const builderClass = this.formRendererConfig.builders[configs.type];
      let fieldConfig = null;
      if (builderClass) {
        fieldConfig = this.injector.get(builderClass).getInput(configs, formKey, defaultValue, this.formRendererConfig.defaultEmptyValue);
      } else if (configs.type !== 'group') {
        fieldConfig = this.injector.get(CustomInputTypeBuilder).getInput(configs, formKey, defaultValue, this.formRendererConfig.defaultEmptyValue);
      }
      return fieldConfig;
    }
    resetValidationErrors(key) {
      this.store.dispatch(new SetFormValidationErrors(key, null));
    }
    retrieveBuilderConfig(formKey, contextKey, cacheOptions) {
      const context = this.contextService.getContextByKey(contextKey || formKey);
      if (cacheOptions?.cache) {
        const config = this.store.selectSnapshot(FormRendererState.formByKeyAndContext(contextKey || formKey, context, cacheOptions?.cacheWithoutCheckingContext));
        if (config) {
          return of(config.configuration);
        }
      }
      return this.formRendererApiService.getFormBuilderByKey(formKey, contextKey);
    }
    getContainerFormGroupConfig(containerClass) {
      return {
        fieldGroup: [],
        fieldGroupClassName: containerClass ?? null
      };
    }
    getWrapperFormGroup(group, template, key, defaultValue) {
      const hasWrapper = inputTypeWrappers.some(item => item.name === group.location);
      const wrapper = hasWrapper ? group.location : null;
      const inputs = group.inputs.map(input => {
        return this.getInputByConfigs(input, key, defaultValue);
      });
      return {
        type: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.group),
        fieldGroup: inputs,
        className: template?.groupClass ?? null,
        wrappers: group.collapsable ? ['collapsable-wrapper'] : wrapper ? [wrapper] : null,
        label: group.label ? this.translateService.instant(`${this.formRendererConfig.translationKeyPrefix}.${group.label}`) : null,
        description: group.description ? this.translateService.instant(`${this.formRendererConfig.translationKeyPrefix}.${group.description}`) : null,
        props: {
          collapsed: group.collapsed,
          title: group.name,
          tooltip: group.tooltip ? group.tooltip : null
        }
      };
    }
    getLayoutTemplates() {
      return {
        ...defaultLayoutTemplates,
        ...this.formRendererConfig.layoutTemplates
      };
    }
    areObjectsEqual(object1, object2) {
      return object1 && object2 && Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every(key => object1[key] === object2[key]);
    }
    static {
      this.ɵfac = function FormRendererService_Factory(t) {
        return new (t || FormRendererService)(i0.ɵɵinject(FormRendererApiService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i6.TranslateService), i0.ɵɵinject(FormInputHelperService), i0.ɵɵinject(FormRendererConfigService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i4.CapturumBuildersContextService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormRendererService,
        factory: FormRendererService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormRendererService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EntityTextInputDialogComponent = /*#__PURE__*/(() => {
  class EntityTextInputDialogComponent extends DestroyBase {
    constructor(config, entityService, formRendererService, dialogRef) {
      super();
      this.config = config;
      this.entityService = entityService;
      this.formRendererService = formRendererService;
      this.dialogRef = dialogRef;
      this.suggestions = [];
      this.entities = new Map();
      this.disabled = true;
      this.key = this.config?.data?.key;
      this.type = this.config?.data?.type;
      this.sourceMethod = !(this.type === EntityInfoType.list || this.type === EntityInfoType.form) ? EntityInfoSourceMethod.getSourceValueByKey : EntityInfoSourceMethod.getFormValueByKey;
    }
    ngOnInit() {
      if (this.key) {
        this.formRendererService[this.sourceMethod](this.key).pipe(takeUntil(this.destroy$), switchMap(({
          source
        }) => {
          const entity = {
            type: !(this.type === EntityInfoType.list || this.type === EntityInfoType.form) ? this.type : EntityInfoType.method,
            service: source.get.class
          };
          return this.entityService.searchEntityInformation(entity);
        }), catchError(error => {
          this.closeDialog();
          return of(error);
        })).subscribe(entities => {
          Object.keys(entities).forEach(entity => {
            if (entity !== EntityInfoType.name) {
              this.entities.set(entity, entities[entity]);
            }
          });
          this.disabled = false;
        });
      }
    }
    ngAfterViewInit() {
      this.autoComplete.multiInputEl.nativeElement.readOnly = true;
    }
    onFocus(event) {
      const eventTarget = event.target;
      if (eventTarget.value.trim() === '' && !this.selectedEntities) {
        this.getEntitiesStartPoint();
      }
      this.autoComplete.show();
    }
    selectItem(item) {
      this.autoComplete.multiInputEl.nativeElement.disabled = item.type !== EntityInfoType.relations;
      const relations = this.getFromEntitiesList(item.key);
      if (relations) {
        this.suggestions = this.mapEntityInformationResult(relations);
      }
      this.blurOnSelectUnselectItem();
    }
    unselectItem(item) {
      this.autoComplete.multiInputEl.nativeElement.disabled = false;
      if (this.selectedEntities?.length) {
        const [entity] = this.selectedEntities.slice(-1);
        this.suggestions = this.mapEntityInformationResult(this.getFromEntitiesList(entity.key));
      } else {
        this.getEntitiesStartPoint();
      }
      this.blurOnSelectUnselectItem();
    }
    closeDialog() {
      this.dialogRef.close({
        action: EntityDialogAction.cancel
      });
      this.dialogRef.destroy();
    }
    submit() {
      this.dialogRef.close({
        action: EntityDialogAction.submit,
        data: this.selectedEntities.map(entity => entity.value).join('.')
      });
    }
    getEntitiesStartPoint() {
      const [service_methods] = this.entities.values();
      this.suggestions = this.mapEntityInformationResult(this.entities.has(EntityInfoType.start) ? this.entities.get(EntityInfoType.start) : service_methods);
    }
    mapEntityInformationResult(result) {
      const grouppedInfo = [];
      if (Array.isArray(result)) {
        grouppedInfo.push({
          label: EntityInfoType.methods,
          items: result.map(item => ({
            key: item,
            value: item,
            type: EntityInfoType.methods
          }))
        });
        return grouppedInfo;
      }
      for (const info in result) {
        if (info !== EntityInfoType.name) {
          if (!Array.isArray(result[info]) && typeof Object.values(result[info]) === 'object') {
            const relationItems = [];
            for (const [relationKey, relationValue] of Object.entries(result[info])) {
              relationItems.push({
                key: relationKey,
                value: relationValue,
                type: info
              });
            }
            grouppedInfo.push({
              label: info,
              items: relationItems
            });
          } else if (Array.isArray(result[info])) {
            grouppedInfo.push({
              label: info,
              items: result[info].map(item => ({
                key: item,
                value: item,
                type: info
              }))
            });
          }
        }
      }
      return grouppedInfo;
    }
    getFromEntitiesList(entity) {
      for (const [key, value] of this.entities.entries()) {
        if (key === entity) {
          return this.entities.get(key);
        }
      }
    }
    blurOnSelectUnselectItem() {
      interval(0).pipe(take(1)).subscribe(() => this.autoComplete.multiInputEl.nativeElement.blur());
    }
    static {
      this.ɵfac = function EntityTextInputDialogComponent_Factory(t) {
        return new (t || EntityTextInputDialogComponent)(i0.ɵɵdirectiveInject(i1$4.DynamicDialogConfig), i0.ɵɵdirectiveInject(BuilderUiEntityService), i0.ɵɵdirectiveInject(FormRendererService), i0.ɵɵdirectiveInject(i1$4.DynamicDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EntityTextInputDialogComponent,
        selectors: [["cpb-entity-text-input-dialog"]],
        viewQuery: function EntityTextInputDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c8, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 12,
        vars: 11,
        consts: [[1, "dialog-container"], [1, "dialog-container__header"], [1, "fas", "fa-times", "close", 3, "click"], [1, "dialog-container__content"], ["styleClass", "autocomplete", "field", "value", "placeholder", "entity", 3, "ngModel", "suggestions", "multiple", "group", "ngModelChange", "onFocus", "onSelect", "onUnselect"], ["autoComplete", ""], [1, "dialog-container__footer"], ["styleClass", "primary", 3, "label", "disabled", "onClick"]],
        template: function EntityTextInputDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "i", 2);
            i0.ɵɵlistener("click", function EntityTextInputDialogComponent_Template_i_click_5_listener() {
              return ctx.closeDialog();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3)(7, "p-autoComplete", 4, 5);
            i0.ɵɵlistener("ngModelChange", function EntityTextInputDialogComponent_Template_p_autoComplete_ngModelChange_7_listener($event) {
              return ctx.selectedEntities = $event;
            })("onFocus", function EntityTextInputDialogComponent_Template_p_autoComplete_onFocus_7_listener($event) {
              return ctx.onFocus($event);
            })("onSelect", function EntityTextInputDialogComponent_Template_p_autoComplete_onSelect_7_listener($event) {
              return ctx.selectItem($event);
            })("onUnselect", function EntityTextInputDialogComponent_Template_p_autoComplete_onUnselect_7_listener($event) {
              return ctx.unselectItem($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 6)(10, "cap-button", 7);
            i0.ɵɵlistener("onClick", function EntityTextInputDialogComponent_Template_cap_button_onClick_10_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "builders.entity.info.header"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.selectedEntities)("suggestions", ctx.suggestions)("multiple", true)("group", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(11, 9, "button.submit"))("disabled", !(ctx.selectedEntities == null ? null : ctx.selectedEntities.length));
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.NgModel, i3.CapturumButtonComponent, i6$1.AutoComplete, i6.TranslatePipe],
        styles: ["@charset \"UTF-8\";:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}body .entity-text-input-dialog .p-dialog-content{flex:1;min-height:0;padding:0}body .entity-text-input-dialog .dialog-container{display:flex;height:100%;flex-direction:column;font-size:1rem}body .entity-text-input-dialog .dialog-container__header{background:var(--cap-primary-color);padding:20px;font-weight:700;font-size:1.2em;color:#fff;display:flex;justify-content:space-between;min-height:55px}body .entity-text-input-dialog .dialog-container__header .close{cursor:pointer}body .entity-text-input-dialog .dialog-container__content{flex:1;padding:1.25rem}body .entity-text-input-dialog .dialog-container__footer{display:flex;justify-content:flex-end;font-size:inherit;padding:1.25rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container{flex:1;padding:.5rem;border-color:#ddd;align-items:stretch;border-radius:3px}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container:hover:not(.p-disabled){border-color:#ddd}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token{position:relative;border-radius:3px;font-size:1rem;margin-right:.75rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:after{content:\"\\b7\";position:absolute;right:-8px;font-weight:700;font-size:1.25rem;top:50%;color:#000;display:flex;vertical-align:bottom;line-height:10px}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:nth-first-child(0){margin-right:.286rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:nth-first-child(0):after{display:none}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token .p-autocomplete-token-icon{display:none;opacity:0;visibility:hidden;margin-left:.5rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:nth-last-child(2){margin-right:.286rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:nth-last-child(2):after{display:none}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token:nth-last-child(2) .p-autocomplete-token-icon{display:block;opacity:1;visibility:visible}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container .p-autocomplete-token-label{padding-right:0}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-button.p-button-icon-only{position:unset;border-left:0;height:auto}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-items .p-autocomplete-item-group{font-size:1.1rem;font-weight:700;padding:.5rem 1rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-items .p-autocomplete-item{padding:.35rem 1rem}body .autocomplete.p-autocomplete.p-autocomplete-multiple .p-autocomplete-items .p-autocomplete-item:hover{background-color:var(--cap-primary-color);color:#fff}\n"],
        encapsulation: 2
      });
    }
  }
  return EntityTextInputDialogComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const entityTextFormKey = {
  form_edit_form: 'form_edit_form',
  form_edit_list: 'form_edit_list',
  form_edit_column: 'form_edit_list',
  form_edit_filter: 'form_edit_list'
};
let CapturumBuilderEntityTextInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderEntityTextInputComponent extends FieldType {
    constructor(dialogService, cdr) {
      super();
      this.dialogService = dialogService;
      this.cdr = cdr;
      this.labelPosition = LabelPosition;
      this.subscription = new Subscription();
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    openEntityBuilderInfoDialog() {
      this.dialogRef = this.dialogService.open(EntityTextInputDialogComponent, {
        data: {
          key: entityTextFormKey[this.to.formKey],
          type: this.to.formKey.split('_').slice(-1).toString()
        },
        width: '600px',
        height: '350px',
        styleClass: 'entity-text-input-dialog',
        closable: true,
        dismissableMask: true,
        showHeader: false
      });
      this.subscription.add(this.dialogRef.onClose.pipe(filter(value => value?.action === EntityDialogAction.submit)).subscribe(res => {
        if (res.data) {
          this.formControl.setValue(res.data);
        }
        this.cdr.detectChanges();
        this.dialogRef.destroy();
      }));
    }
    static {
      this.ɵfac = function CapturumBuilderEntityTextInputComponent_Factory(t) {
        return new (t || CapturumBuilderEntityTextInputComponent)(i0.ɵɵdirectiveInject(CapturumDialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderEntityTextInputComponent,
        selectors: [["cpb-entity-text-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 20,
        consts: [[1, "entity-text-wrapper"], [1, "p-inputgroup"], [1, "p-inputwrapper"], [3, "formControl", "floatLabel", "label", "readonly", "hidden", "hasTooltip", "selectOnFocus", "placeholder"], ["styleClass", "primary", "icon", "fas fa-search", 3, "onClick"], [3, "hidden"]],
        template: function CapturumBuilderEntityTextInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "cap-input", 3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵpipe(6, "async");
            i0.ɵɵpipe(7, "observablePipe");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "cap-button", 4);
            i0.ɵɵlistener("onClick", function CapturumBuilderEntityTextInputComponent_Template_cap_button_onClick_8_listener() {
              return ctx.openEntityBuilderInfoDialog();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "cpb-readonly-container", 5);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(4, 12, i0.ɵɵpipeBind1(5, 14, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(6, 16, i0.ɵɵpipeBind1(7, 18, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("readonly", ctx.to.readonly)("hidden", ctx.to.readonly)("hasTooltip", ctx.to.tooltip)("selectOnFocus", ctx.to == null ? null : ctx.to.select_on_focus)("placeholder", ctx.to.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.formControl.value, " ");
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2$1.CapturumInputComponent, i3.CapturumButtonComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe],
        styles: ["body .entity-text-wrapper>.p-inputgroup .p-inputwrapper{flex:1 1 auto;width:1%}body .entity-text-wrapper>.p-inputgroup .p-inputwrapper .cap-input.p-inputtext,body .entity-text-wrapper>.p-inputgroup .p-inputwrapper.cap-input.p-inputtext:enabled:focus:not(.p-state-error),body .entity-text-wrapper>.p-inputgroup .p-inputwrapper.cap-input.p-inputtext:enabled:hover:not(.p-state-error){border-radius:3px 0 0 3px}body .entity-text-wrapper>.p-inputgroup .cap-button{height:100%;border-radius:0 3px 3px 0}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderEntityTextInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderFileInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderFileInputComponent extends FieldType {
    constructor(vaporFileUploadService, store, cdr) {
      super();
      this.vaporFileUploadService = vaporFileUploadService;
      this.store = store;
      this.cdr = cdr;
      this.previewFiles = [];
      this.destroy$ = new Subject();
    }
    static getRandomId(length = 5) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
    ngOnInit() {
      if (this.props.previewData) {
        this.previewFiles = Array.isArray(this.props.previewData) ? this.props.previewData : [this.props.previewData];
      }
      this.store.select(FormRendererState.sourceValueByKey(this.props.formKey)).pipe(takeUntil(this.destroy$)).subscribe(value => {
        let files = value?.[this.key];
        if (files) {
          files = Array.isArray(files) ? files : [files];
          this.previewFiles = files.map(file => {
            const currentFile = this.previewFiles.find(previewFile => file.data === previewFile.id || file.id === previewFile.id);
            return {
              ...currentFile,
              url: file?.public_url || currentFile?.url,
              name: file?.filename,
              id: file?.id || file?.data || currentFile?.id
            };
          });
        }
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    handleFileChange(files) {
      const formattedFiles = [];
      files.forEach(file => {
        formattedFiles.push({
          file,
          id: CapturumBuilderFileInputComponent.getRandomId(5)
        });
      });
      for (const file of formattedFiles) {
        this.setPreviewFile(file, this.props.multiple, 1);
      }
      this.setVaporFile(formattedFiles);
      this.cdr.detectChanges();
    }
    removeFile(fileItem) {
      if (this.props.multiple) {
        this.formControl.setValue(this.formControl.value.filter(file => {
          return file.data !== fileItem.id && file.id !== fileItem.id;
        }));
      } else {
        this.formControl.setValue(null);
      }
      this.previewFiles = this.previewFiles.filter(file => file.id !== fileItem?.id);
    }
    setVaporFile(files) {
      forkJoin(files.map(file => {
        return this.vaporFileUploadService.uploadFile(file.file).pipe(tap(response => {
          if (response.data['progress']) {
            this.updatePreviewFiles(file.id, {
              uploadProgress: response.data['progress']
            });
          }
        }), filter(response => response.type === HttpEventType.Response), map(response => {
          return {
            uuid: response.data['uuid'],
            file
          };
        }));
      })).subscribe(response => {
        for (const fileResponse of response) {
          this.updatePreviewFiles(fileResponse.file.id, {
            id: fileResponse.uuid,
            uploadProgress: null,
            uploading: false
          });
        }
        this.setFormControlForVaporFileUpload(response, this.props.multiple);
        this.cdr.detectChanges();
      });
    }
    setPreviewFile(file, multiple = false, uploadProgress) {
      const fileReader = new FileReader();
      fileReader.onloadend = result => {
        if (multiple) {
          this.previewFiles = [...this.previewFiles, {
            url: result.target.result,
            name: file.file.name,
            uploading: !!uploadProgress,
            uploadProgress,
            id: file.id
          }];
        } else {
          this.previewFiles = [{
            url: result.target.result,
            name: file.file.name,
            uploading: !!uploadProgress,
            uploadProgress,
            id: file.id
          }];
        }
      };
      fileReader.readAsDataURL(file.file);
    }
    setFormControl(files, multiple) {
      if (multiple) {
        this.formControl.setValue([...(this.formControl.value || []), ...files]);
      } else {
        this.formControl.setValue(files);
      }
    }
    setFormControlForVaporFileUpload(files, multiple) {
      if (files) {
        if (multiple) {
          this.formControl.setValue([...(this.formControl.value || []), ...files.map(file => {
            return {
              data: file.uuid,
              mime_type: file.file.file.type,
              filename: file.file.file.name
            };
          })]);
        } else {
          if (files[0].file.file) {
            this.formControl.setValue({
              data: files[0].uuid,
              mime_type: files[0].file.file.type,
              filename: files[0].file.file.name
            });
          }
        }
      }
    }
    updatePreviewFiles(id, updatedProperties) {
      this.previewFiles = this.previewFiles.map(file => {
        if (file.id === id) {
          file = {
            ...file,
            ...updatedProperties
          };
        }
        return file;
      });
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CapturumBuilderFileInputComponent_Factory(t) {
        return new (t || CapturumBuilderFileInputComponent)(i0.ɵɵdirectiveInject(i1$3.VaporFileUploadService), i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderFileInputComponent,
        selectors: [["cpb-file-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 8,
        consts: [["styleClass", "g-uploader", "label", "", 3, "id", "multiple", "accept", "uploaderContent", "onFileChange"], [1, "preview--section"], [3, "files", "showDelete", "onDeleteClick"], ["uploadContent", ""], [1, "upload"], [1, "fas", "fa-cloud-upload-alt"], [3, "innerHTML"], ["class", "placeholder", 4, "ngIf"], [1, "placeholder"]],
        template: function CapturumBuilderFileInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-file-upload", 0);
            i0.ɵɵlistener("onFileChange", function CapturumBuilderFileInputComponent_Template_cap_file_upload_onFileChange_0_listener($event) {
              return ctx.handleFileChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 1)(2, "cap-file-preview-list", 2);
            i0.ɵɵlistener("onDeleteClick", function CapturumBuilderFileInputComponent_Template_cap_file_preview_list_onDeleteClick_2_listener($event) {
              return ctx.removeFile($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, CapturumBuilderFileInputComponent_ng_template_3_Template, 4, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(4);
            i0.ɵɵproperty("id", ctx.field.key)("multiple", ctx.to.multiple)("accept", ctx.to.availableExtensions)("uploaderContent", _r0);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("files", ctx.previewFiles)("showDelete", true);
          }
        },
        dependencies: [i1$1.NgIf, i4$2.CapturumFileUploadComponent, i5$1.FilePreviewListComponent, i6.TranslatePipe],
        styles: ["[_nghost-%COMP%]     .prime-file-upload{border:2px dashed #ddd;border-radius:7px;height:70px}.upload[_ngcontent-%COMP%]{display:flex;height:100%;align-items:center;padding:0 20px}.upload[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:initial;color:#5f6062;font-size:21px;margin-right:10px}.upload[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--primary-color);font-weight:700}.upload[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{padding-left:5px;font-weight:400;color:#ddd}.preview--section[_ngcontent-%COMP%]{margin-top:20px}"]
      });
    }
  }
  return CapturumBuilderFileInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CreateObjectUrlPipe = /*#__PURE__*/(() => {
  class CreateObjectUrlPipe {
    constructor(domSanitizer) {
      this.domSanitizer = domSanitizer;
    }
    transform(file) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
    }
    static {
      this.ɵfac = function CreateObjectUrlPipe_Factory(t) {
        return new (t || CreateObjectUrlPipe)(i0.ɵɵdirectiveInject(i1$5.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "createObjectUrl",
        type: CreateObjectUrlPipe,
        pure: true
      });
    }
  }
  return CreateObjectUrlPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilePreviewComponent = /*#__PURE__*/(() => {
  class FilePreviewComponent {
    constructor() {
      this.styleClass = 'col-3';
      this.deletable = false;
      this.nameProperty = 'name';
      this.showThumbnail = true;
      this.removeClick = new EventEmitter();
      this.cardClick = new EventEmitter();
    }
    handleRemoveIconClick(event, filename) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.removeClick.next(filename);
    }
    static {
      this.ɵfac = function FilePreviewComponent_Factory(t) {
        return new (t || FilePreviewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilePreviewComponent,
        selectors: [["cpb-file-preview"]],
        inputs: {
          styleClass: "styleClass",
          items: "items",
          deletable: "deletable",
          nameProperty: "nameProperty",
          imagePathProperty: "imagePathProperty",
          showThumbnail: "showThumbnail"
        },
        outputs: {
          removeClick: "removeClick",
          cardClick: "cardClick"
        },
        decls: 1,
        vars: 1,
        consts: [["class", "preview row", 4, "ngIf"], [1, "preview", "row"], [3, "classList", 4, "ngFor", "ngForOf"], [3, "classList"], ["class", "file", 3, "click", 4, "ngIf"], [1, "file", 3, "click"], [1, "file__preview", 3, "ngClass"], [4, "ngIf"], [1, "file__name"], ["class", "fas fa-trash-alt file--remove", 3, "click", 4, "ngIf"], [3, "src", "alt", 4, "ngIf"], [3, "src", "alt"], [1, "far", "fa-file"], [1, "fas", "fa-trash-alt", "file--remove", 3, "click"]],
        template: function FilePreviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FilePreviewComponent_div_0_Template, 2, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.items);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, CreateObjectUrlPipe],
        styles: [".preview[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:nth-child(n+1){margin-bottom:15px}.preview[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:nth-child(n+1):last-child{margin-bottom:0}.preview[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]{padding:8px;border-radius:7px;background-color:#f0f0f0;display:flex;position:relative}.preview[_ngcontent-%COMP%]   .file__preview[_ngcontent-%COMP%]{width:50px;height:50px;border-radius:3px;background-color:#fff}.preview[_ngcontent-%COMP%]   .file__preview[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%;object-fit:contain}.preview[_ngcontent-%COMP%]   .file__name[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;justify-content:flex-start;width:calc(100% - 50px);padding-right:15px;font-size:12px;margin-left:13px;word-wrap:break-word}.preview[_ngcontent-%COMP%]   .file--remove[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;color:var(--error-color);font-size:13px;cursor:pointer}.preview[_ngcontent-%COMP%]   .file__preview--centered[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}"]
      });
    }
  }
  return FilePreviewComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubmitButtonComponent = /*#__PURE__*/(() => {
  class SubmitButtonComponent {
    constructor(formSaverService) {
      this.formSaverService = formSaverService;
      this.submitSubject = new Subject();
      this.loading$ = this.submitSubject.asObservable().pipe(switchMap(() => {
        return concat(of(true), this.formSaverService.submit(this.key).pipe(catchError(() => of(false)), map(() => false)));
      }), shareReplay(1));
    }
    submit() {
      this.submitSubject.next(true);
    }
    static {
      this.ɵfac = function SubmitButtonComponent_Factory(t) {
        return new (t || SubmitButtonComponent)(i0.ɵɵdirectiveInject(FormSaverService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubmitButtonComponent,
        selectors: [["cpb-form-submit-button"]],
        inputs: {
          actionConfiguration: "actionConfiguration",
          key: "key"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngxPermissionsOnly"], ["styleClass", "primary", 3, "label", "icon", "disabled", "click", 4, "ngIf"], ["styleClass", "primary", 3, "label", "icon", "disabled", "click"]],
        template: function SubmitButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, SubmitButtonComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngxPermissionsOnly", ctx.actionConfiguration.permissions);
          }
        },
        dependencies: [i1$1.NgIf, i3.CapturumButtonComponent, i4$1.NgxPermissionsDirective, i1$1.AsyncPipe],
        styles: [_c10],
        changeDetection: 0
      });
    }
  }
  return SubmitButtonComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormRendererHeaderComponent = /*#__PURE__*/(() => {
  class FormRendererHeaderComponent {
    static {
      this.ɵfac = function FormRendererHeaderComponent_Factory(t) {
        return new (t || FormRendererHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormRendererHeaderComponent,
        selectors: [["cpb-form-renderer-header"]],
        inputs: {
          title: "title",
          callbacks: "callbacks",
          formKey: "formKey",
          leftButtonTemplate: "leftButtonTemplate",
          rightButtonTemplate: "rightButtonTemplate"
        },
        decls: 7,
        vars: 4,
        consts: [[1, "form-renderer-header"], [1, "form-renderer-title"], [1, "form-renderer-actions"], [3, "ngTemplateOutlet"], [4, "ngIf"], [3, "key", "actionConfiguration", 4, "ngIf"], [3, "key", "actionConfiguration"]],
        template: function FormRendererHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵelementContainer(4, 3);
            i0.ɵɵtemplate(5, FormRendererHeaderComponent_ng_container_5_Template, 3, 2, "ng-container", 4);
            i0.ɵɵelementContainer(6, 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.leftButtonTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.callbacks);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.rightButtonTemplate);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, SubmitButtonComponent, CancelButtonComponent],
        styles: [".form-renderer-header{display:flex;justify-content:space-between;border-bottom:1px solid #ddd;padding:15px;margin-bottom:15px}.form-renderer-header .form-renderer-title{display:flex;flex-direction:column;justify-content:center;font-size:1.8em}.form-renderer-header .form-renderer-actions{display:flex}.form-renderer-header .form-renderer-actions>*:not(:last-child){margin-right:15px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return FormRendererHeaderComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderGroupInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderGroupInputComponent extends FieldType {
    ngAfterContentChecked() {
      if (this.field.fieldGroup) {
        this.hidden = this.field.fieldGroup.every(field => field.hide);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderGroupInputComponent_BaseFactory;
        return function CapturumBuilderGroupInputComponent_Factory(t) {
          return (ɵCapturumBuilderGroupInputComponent_BaseFactory || (ɵCapturumBuilderGroupInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderGroupInputComponent)))(t || CapturumBuilderGroupInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderGroupInputComponent,
        selectors: [["cpb-group-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 4,
        consts: [[1, "denomination", 3, "hidden"], ["class", "group-heading", 4, "ngIf"], [1, "description"], [3, "field", 4, "ngFor", "ngForOf"], [1, "group-heading"], [1, "label"], [3, "field"]],
        template: function CapturumBuilderGroupInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumBuilderGroupInputComponent_div_1_Template, 3, 1, "div", 1);
            i0.ɵɵelementStart(2, "p", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, CapturumBuilderGroupInputComponent_formly_field_4_Template, 1, 1, "formly-field", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.hidden);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.field.label || ctx.field.tooltip);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.field == null ? null : ctx.field.description);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.field.fieldGroup);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$6.FormlyField],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderGroupInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderHiddenTypeComponent = /*#__PURE__*/(() => {
  class CapturumBuilderHiddenTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderHiddenTypeComponent_BaseFactory;
        return function CapturumBuilderHiddenTypeComponent_Factory(t) {
          return (ɵCapturumBuilderHiddenTypeComponent_BaseFactory || (ɵCapturumBuilderHiddenTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderHiddenTypeComponent)))(t || CapturumBuilderHiddenTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderHiddenTypeComponent,
        selectors: [["cpb-hidden-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function CapturumBuilderHiddenTypeComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderHiddenTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderImageInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderImageInputComponent extends CapturumBuilderFileInputComponent {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderImageInputComponent_BaseFactory;
        return function CapturumBuilderImageInputComponent_Factory(t) {
          return (ɵCapturumBuilderImageInputComponent_BaseFactory || (ɵCapturumBuilderImageInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderImageInputComponent)))(t || CapturumBuilderImageInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderImageInputComponent,
        selectors: [["cpb-image-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 8,
        consts: [["label", "", 3, "id", "multiple", "accept", "uploaderContent", "onFileChange", 4, "ngIf"], [1, "preview--section"], [3, "files", "showDelete", "onDeleteClick"], ["uploadContent", ""], [3, "hidden"], ["label", "", 3, "id", "multiple", "accept", "uploaderContent", "onFileChange"], ["capFileUpload", ""], [1, "upload"], [1, "fas", "fa-cloud-upload-alt"], [3, "innerHTML"], ["class", "placeholder", 4, "ngIf"], [1, "placeholder"]],
        template: function CapturumBuilderImageInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumBuilderImageInputComponent_cap_file_upload_0_Template, 2, 5, "cap-file-upload", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "cap-file-preview-list", 2);
            i0.ɵɵlistener("onDeleteClick", function CapturumBuilderImageInputComponent_Template_cap_file_preview_list_onDeleteClick_2_listener($event) {
              return ctx.removeFile($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, CapturumBuilderImageInputComponent_ng_template_3_Template, 4, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(5, "cpb-readonly-container", 4);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.to.readonly);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("files", ctx.previewFiles)("showDelete", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hidden", !((ctx.to == null ? null : ctx.to.readonly) && ctx.previewFiles.length < 1));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "builders.no_preview_available.label"), "\n");
          }
        },
        dependencies: [i1$1.NgIf, i4$2.CapturumFileUploadComponent, i5$1.FilePreviewListComponent, CapturumReadonlyContainerComponent, i6.TranslatePipe],
        styles: [".upload[_ngcontent-%COMP%]{display:flex;align-items:center;cursor:pointer}.upload[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#3c3c3b;font-size:1.375rem;margin-bottom:0;opacity:1;padding-right:1rem}.upload[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .upload[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#145996;font-size:1rem;font-weight:400}.upload[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#ddd}.preview--section[_ngcontent-%COMP%]{margin-bottom:.375rem}[_nghost-%COMP%]     .prime-file-upload{border-radius:7px;padding:0 1.25rem;border:3px dashed #ddd;justify-content:flex-start;flex-direction:unset;box-shadow:unset;margin-bottom:.375rem;height:70px}label[_ngcontent-%COMP%]{font-size:1rem;font-weight:400}.preview-image-wrapper[_ngcontent-%COMP%]{overflow:hidden;position:relative;max-width:45%}.preview-image-wrapper[_ngcontent-%COMP%]   .preview-image[_ngcontent-%COMP%]{box-shadow:0 1px 3px #00000026;border-radius:7px;position:relative;overflow:hidden}.preview-image-wrapper[_ngcontent-%COMP%]   .preview-image-actions[_ngcontent-%COMP%]{position:absolute;top:0;right:0;transform:translate3d(-12px,12px,0);display:inline-flex}.preview-image-wrapper[_ngcontent-%COMP%]   .preview-image-actions-action[_ngcontent-%COMP%]{margin-left:10px;box-shadow:0 5px 13px #00000040;width:36px;height:36px;display:flex;justify-content:center;align-items:center;background-color:#fff;border-radius:50%}.preview-image-wrapper[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{color:var(--cap-primary-color);cursor:pointer;font-size:1rem}.preview-image-wrapper[_ngcontent-%COMP%]   .preview-image--remove[_ngcontent-%COMP%]{color:#ff3b30}"]
      });
    }
  }
  return CapturumBuilderImageInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderLabelInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderLabelInputComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderLabelInputComponent_BaseFactory;
        return function CapturumBuilderLabelInputComponent_Factory(t) {
          return (ɵCapturumBuilderLabelInputComponent_BaseFactory || (ɵCapturumBuilderLabelInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderLabelInputComponent)))(t || CapturumBuilderLabelInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderLabelInputComponent,
        selectors: [["cpb-label-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[1, "form-element", 3, "ngClass"], [4, "ngIf"]],
        template: function CapturumBuilderLabelInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumBuilderLabelInputComponent_label_1_Template, 3, 1, "label", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.to == null ? null : ctx.to.css_class);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to == null ? null : ctx.to.label);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderLabelInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumMultiSelectInputComponent = /*#__PURE__*/(() => {
  class CapturumMultiSelectInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(filter(value => {
        return Array.isArray(value) && value.some(item => typeof item === 'object');
      }), takeUntil(this.destroy$)).subscribe(valueObject => {
        const values = valueObject.map(value => {
          return value[this.props.sourceValueKey || 'id'] ?? value;
        });
        this.formControl.setValue(values, {
          emitEvent: false
        });
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumMultiSelectInputComponent_BaseFactory;
        return function CapturumMultiSelectInputComponent_Factory(t) {
          return (ɵCapturumMultiSelectInputComponent_BaseFactory || (ɵCapturumMultiSelectInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumMultiSelectInputComponent)))(t || CapturumMultiSelectInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumMultiSelectInputComponent,
        selectors: [["cpb-multi-select-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "formControl", "floatLabel", "label", "options", "optionLabel", "optionValue", "selectionLimit", "panelStyleClass", "resetFilterOnHide", "virtualScroll", "filterBy", "virtualScrollItemSize", "defaultLabel", "appendTo", "readonly", "sortBy"], [1, "multiselect-list__readonly"]],
        template: function CapturumMultiSelectInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumMultiSelectInputComponent_ng_container_0_Template, 8, 30, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.props.options$));
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$4.CapturumMultiSelectComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe, i6.TranslatePipe, LabelsByValuesPipe],
        styles: [".multiselect-list__readonly[_ngcontent-%COMP%]{height:36px;display:flex;flex-direction:column;justify-content:center}"]
      });
    }
  }
  return CapturumMultiSelectInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderNumberFormatInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderNumberFormatInputComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderNumberFormatInputComponent_BaseFactory;
        return function CapturumBuilderNumberFormatInputComponent_Factory(t) {
          return (ɵCapturumBuilderNumberFormatInputComponent_BaseFactory || (ɵCapturumBuilderNumberFormatInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderNumberFormatInputComponent)))(t || CapturumBuilderNumberFormatInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderNumberFormatInputComponent,
        selectors: [["cpb-number-format-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 15,
        consts: [[3, "formControl", "locale", "prefix", "suffix", "useGrouping", "minFractionDigits", "maxFractionDigits", "disabled", "selectOnFocus", "min", "max", "styleClass", "autocomplete", "readonly"]],
        template: function CapturumBuilderNumberFormatInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input-number", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("locale", ctx.props == null ? null : ctx.props.locale_format)("prefix", ctx.props == null ? null : ctx.props.prefix)("suffix", ctx.props == null ? null : ctx.props.suffix)("useGrouping", ctx.props == null ? null : ctx.props.group_thousands)("minFractionDigits", (ctx.props == null ? null : ctx.props.decimals) || 0)("maxFractionDigits", (ctx.props == null ? null : ctx.props.decimals) || 0)("disabled", ctx.props == null ? null : ctx.props.readonly)("selectOnFocus", ctx.props == null ? null : ctx.props.select_on_focus)("min", ctx.props == null ? null : ctx.props.min)("max", ctx.props == null ? null : ctx.props.max)("styleClass", (ctx.props == null ? null : ctx.props.readonly) ? "cap-number-format-readonly" : "")("autocomplete", ctx.props == null ? null : ctx.props.autocomplete)("readonly", ctx.props.readonly);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2$4.CapturumInputNumberComponent],
        styles: ["cpb-number-format-input .form-element p-inputnumber{flex:1}cpb-number-format-input .form-element p-inputnumber .p-inputnumber{width:100%;font-size:1rem}body .cap-number-format-readonly .p-inputnumber-input.p-component:disabled,body .cap-number-format-readonly .p-inputnumber-input.p-disabled{opacity:1;border:0;padding:0}body .cap-number-format-readonly .p-inputnumber-input.p-component:disabled:hover,body .cap-number-format-readonly .p-inputnumber-input.p-disabled:hover{opacity:1}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderNumberFormatInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderNumberInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderNumberInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderNumberInputComponent_BaseFactory;
        return function CapturumBuilderNumberInputComponent_Factory(t) {
          return (ɵCapturumBuilderNumberInputComponent_BaseFactory || (ɵCapturumBuilderNumberInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderNumberInputComponent)))(t || CapturumBuilderNumberInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderNumberInputComponent,
        selectors: [["cpb-number-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 23,
        consts: [["type", "number", 3, "formControl", "floatLabel", "label", "readonly", "selectOnFocus", "hasTooltip", "hidden", "placeholder"], [3, "hidden"]],
        template: function CapturumBuilderNumberInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵelementStart(5, "cpb-readonly-container", 1);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "default");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 12, i0.ɵɵpipeBind1(2, 14, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 16, i0.ɵɵpipeBind1(4, 18, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("readonly", ctx.to.readonly)("selectOnFocus", ctx.to == null ? null : ctx.to.select_on_focus)("hasTooltip", ctx.to.tooltip)("hidden", ctx.to.readonly)("placeholder", ctx.formState.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 20, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue), "\n");
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2$1.CapturumInputComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderNumberInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderPasswordTypeComponent = /*#__PURE__*/(() => {
  class CapturumBuilderPasswordTypeComponent extends FieldType {
    constructor(formBuilder, validatorService) {
      super();
      this.formBuilder = formBuilder;
      this.validatorService = validatorService;
      this.destroy$ = new Subject();
      this.addCustomTranslation();
    }
    ngOnInit() {
      this.passwordFormGroup = this.formBuilder.group({
        password: [null, passwordValidator],
        confirm_password: [null, passwordValidator]
      }, {
        validators: controlsEqual('confirm_password', 'password', 'fieldMatch')
      });
      this.passwordFormGroup.valueChanges.pipe(takeUntil$1(this.destroy$)).subscribe(changes => {
        this.formControl.setValue(changes);
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    generatePassword() {
      const letters = 4;
      const numbers = 4;
      const specialCharacters = 4;
      const either = 4;
      const lowercaseLetters = 4;
      const chars = ['ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz', '0123456789', '!@#$%^&*()', 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' // either
      ];

      const password = [letters, lowercaseLetters, numbers, specialCharacters, either].map(function (length, i) {
        return Array(length).fill(chars[i]).map(function (x) {
          return x[Math.floor(Math.random() * x.length)];
        }).join('');
      }).concat().join('').split('').sort(function () {
        return 0.5 - Math.random();
      }).join('');
      this.passwordFormGroup.setValue({
        password,
        confirm_password: password
      });
    }
    addCustomTranslation() {
      this.validatorService.setValidationMessages({
        fieldMatch: 'auth.reset-password.mismatch.message'
      });
    }
    static {
      this.ɵfac = function CapturumBuilderPasswordTypeComponent_Factory(t) {
        return new (t || CapturumBuilderPasswordTypeComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(i5.ValidatorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderPasswordTypeComponent,
        selectors: [["cpb-password-type"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 10,
        consts: [[1, "password-fields", 3, "formGroup"], ["formControlName", "password", 3, "toggleMask"], [1, "validation-message"], [3, "field"], ["formControlName", "confirm_password", 3, "toggleMask"], [1, "generate-password"], ["styleClass", "secondary", "icon", "fas fa-key-skeleton", 3, "label", "onClick"]],
        template: function CapturumBuilderPasswordTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cap-password", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "cbp-validation-message", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "label");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "cap-password", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 5)(9, "cap-button", 6);
            i0.ɵɵlistener("onClick", function CapturumBuilderPasswordTypeComponent_Template_cap_button_onClick_9_listener() {
              return ctx.generatePassword();
            });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.passwordFormGroup);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("toggleMask", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("field", ctx.field);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "builders.profile.confirm-password.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("toggleMask", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 8, "builders.profile.generate-password.button"));
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, i3.CapturumButtonComponent, i4$3.CapturumPasswordComponent, CapturumBuilderValidationMessageComponent, i6.TranslatePipe],
        styles: ["app-password-type .generate-password{margin-top:15px}app-password-type .validation-message{min-height:1.2rem}app-password-type .generate-password .cap-button{white-space:nowrap}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CapturumBuilderPasswordTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderRadioInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderRadioInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.radioForm = new FormGroup({
        radio: new FormControl(null)
      });
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
        this.radioForm.get('radio').setValue(value, {
          emitEvent: false
        });
      });
      this.radioForm.get('radio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
        this.formControl.setValue(value, {
          emitEvent: false
        });
        this.formControl.updateValueAndValidity();
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderRadioInputComponent_BaseFactory;
        return function CapturumBuilderRadioInputComponent_Factory(t) {
          return (ɵCapturumBuilderRadioInputComponent_BaseFactory || (ɵCapturumBuilderRadioInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderRadioInputComponent)))(t || CapturumBuilderRadioInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderRadioInputComponent,
        selectors: [["cpb-radio-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 5,
        consts: [[1, "radio-input-container", 3, "formGroup"], [4, "ngIf"], ["class", "p-field-radiobutton", 4, "ngFor", "ngForOf"], [1, "p-field-radiobutton"], ["formControlName", "radio", "name", "radio", 3, "value", "inputId"], [3, "for"]],
        template: function CapturumBuilderRadioInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵtemplate(1, CapturumBuilderRadioInputComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.radioForm);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx.to.options$));
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$2.ɵNgNoValidate, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, i3$5.RadioButton, i1$1.AsyncPipe],
        styles: [".radio-input-container[_ngcontent-%COMP%]{padding-top:10px}"]
      });
    }
  }
  return CapturumBuilderRadioInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumRepeatInputTypeComponent = /*#__PURE__*/(() => {
  class CapturumRepeatInputTypeComponent extends FieldArrayType {
    constructor(formRendererService, formRendererConfig) {
      super();
      this.formRendererService = formRendererService;
      this.formRendererConfig = formRendererConfig;
    }
    ngOnInit() {
      const configurations = this.field.props.configuration;
      const templates = {
        ...defaultLayoutTemplates,
        ...this.formRendererConfig.layoutTemplates
      };
      const template = templates[configurations.options?.form?.template];
      const fields = configurations.options.form.groups.reduce((acc, group) => {
        const inputs = group.inputs.map(inputConfiguration => {
          const inputField = this.formRendererService.getInputByConfigs(inputConfiguration, '', [{}]);
          if (template) {
            inputField.className = template.locations.content.groupClass;
          }
          return inputField;
        });
        return [...acc, ...inputs];
      }, []);
      this.field.fieldArray = {
        fieldGroup: fields,
        fieldGroupClassName: template?.locations.content?.containerClass || null
      };
      if (!this.field.defaultValue || !this.field?.defaultValue?.length) {
        this.add();
      }
      this.repeatReady = true;
    }
    static {
      this.ɵfac = function CapturumRepeatInputTypeComponent_Factory(t) {
        return new (t || CapturumRepeatInputTypeComponent)(i0.ɵɵdirectiveInject(FormRendererService), i0.ɵɵdirectiveInject(FormRendererConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumRepeatInputTypeComponent,
        selectors: [["cpb-repeat-input-type"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["class", "repeat-field-row", 4, "ngFor", "ngForOf"], ["class", "repeat-add-button", 4, "ngIf"], [1, "repeat-field-row"], [1, "repeat-field-form", 3, "field"], [1, "repeat-field-delete"], ["class", "fas fa-trash-alt repeat-field-delete-icon", 3, "click", 4, "ngIf"], [1, "fas", "fa-trash-alt", "repeat-field-delete-icon", 3, "click"], [1, "repeat-add-button"], ["styleClass", "primary", 3, "label", "icon", "click"]],
        template: function CapturumRepeatInputTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumRepeatInputTypeComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.repeatReady);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i3.CapturumButtonComponent, i1$6.FormlyField],
        styles: [".repeat-field-row[_ngcontent-%COMP%]{display:flex;width:80%;border:1px solid #ddd;padding:.5rem .9rem;justify-content:space-between;position:relative;border-radius:3px}.repeat-field-row[_ngcontent-%COMP%]:not(:last-of-type){margin-bottom:10px}.repeat-field-delete[_ngcontent-%COMP%], .repeat-field-form[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center}.repeat-field-delete-icon[_ngcontent-%COMP%]{position:absolute;top:0;right:0;color:#ff3b30;padding:5px;cursor:pointer}"]
      });
    }
  }
  return CapturumRepeatInputTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderTextInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderTextInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderTextInputComponent_BaseFactory;
        return function CapturumBuilderTextInputComponent_Factory(t) {
          return (ɵCapturumBuilderTextInputComponent_BaseFactory || (ɵCapturumBuilderTextInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderTextInputComponent)))(t || CapturumBuilderTextInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderTextInputComponent,
        selectors: [["cpb-text-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 24,
        consts: [[3, "formControl", "floatLabel", "label", "readonly", "hidden", "hasTooltip", "selectOnFocus", "placeholder"], [4, "ngIf"], [3, "hidden"], ["capTemplate", "content-left"]],
        template: function CapturumBuilderTextInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-input", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵtemplate(5, CapturumBuilderTextInputComponent_ng_container_5_Template, 2, 0, "ng-container", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "cpb-readonly-container", 2);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "default");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 13, i0.ɵɵpipeBind1(2, 15, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 17, i0.ɵɵpipeBind1(4, 19, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("readonly", ctx.to.readonly)("hidden", ctx.to.readonly)("hasTooltip", ctx.to.tooltip)("selectOnFocus", ctx.to == null ? null : ctx.to.select_on_focus)("placeholder", ctx.to.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.to == null ? null : ctx.to.content_left);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 21, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue), "\n");
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i5.CapturumTemplateDirective, i2$1.CapturumInputComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderTextInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderTextareaInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderTextareaInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderTextareaInputComponent_BaseFactory;
        return function CapturumBuilderTextareaInputComponent_Factory(t) {
          return (ɵCapturumBuilderTextareaInputComponent_BaseFactory || (ɵCapturumBuilderTextareaInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderTextareaInputComponent)))(t || CapturumBuilderTextareaInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderTextareaInputComponent,
        selectors: [["cpb-textarea-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 25,
        consts: [[3, "formControl", "floatLabel", "label", "hasTooltip", "hidden", "id", "maxlength", "readonly", "selectOnFocus", "placeholder"], [3, "hidden"]],
        template: function CapturumBuilderTextareaInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-textarea", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵelementStart(5, "cpb-readonly-container", 1);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "default");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 14, i0.ɵɵpipeBind1(2, 16, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 18, i0.ɵɵpipeBind1(4, 20, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("hasTooltip", ctx.to.tooltip)("hidden", ctx.to.readonly)("id", ctx.key)("maxlength", ctx.to == null ? null : ctx.to.maxLength)("readonly", ctx.formState.readonly)("selectOnFocus", ctx.to == null ? null : ctx.to.select_on_focus)("placeholder", ctx.formState.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 22, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue), "\n");
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.MaxLengthValidator, i1$2.FormControlDirective, i2$5.CapturumTextareaComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderTextareaInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderToggleInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderToggleInputComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderToggleInputComponent_BaseFactory;
        return function CapturumBuilderToggleInputComponent_Factory(t) {
          return (ɵCapturumBuilderToggleInputComponent_BaseFactory || (ɵCapturumBuilderToggleInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderToggleInputComponent)))(t || CapturumBuilderToggleInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderToggleInputComponent,
        selectors: [["cpb-toggle-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 8,
        consts: [[3, "name", "disabled", "formControl", "formlyAttributes"], [4, "ngIf"]],
        template: function CapturumBuilderToggleInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵelement(1, "cap-input-switch", 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, CapturumBuilderToggleInputComponent_span_2_Template, 3, 4, "span", 1);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.to.readonly ? "none" : "block");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("name", ctx.field.key)("disabled", ctx.to.readonly)("formControl", ctx.formControl)("formlyAttributes", ctx.field);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to.readonly);
          }
        },
        dependencies: [i1$1.NgIf, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$6.CapturumInputSwitchComponent, i1$6.ɵFormlyAttributes, i1$1.JsonPipe],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderToggleInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DisplayValueByCurrentLocalePipe = /*#__PURE__*/(() => {
  class DisplayValueByCurrentLocalePipe {
    constructor(store) {
      this.store = store;
    }
    transform(value) {
      const currentLocale = this.store.selectSnapshot(state => state.formBuilder.currentUser.locale.code);
      return value[0].hasOwnProperty(currentLocale) ? value[0][currentLocale] : null;
    }
    static {
      this.ɵfac = function DisplayValueByCurrentLocalePipe_Factory(t) {
        return new (t || DisplayValueByCurrentLocalePipe)(i0.ɵɵdirectiveInject(i1.Store, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "displayValueByCurrentLocale",
        type: DisplayValueByCurrentLocalePipe,
        pure: true
      });
    }
  }
  return DisplayValueByCurrentLocalePipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderTranslatedInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderTranslatedInputComponent extends FieldArrayType {
    constructor(formRendererService, elementRef, renderer) {
      super();
      this.formRendererService = formRendererService;
      this.elementRef = elementRef;
      this.renderer = renderer;
    }
    ngOnInit() {
      if (this.field.props) {
        const locales = this.field.props.options$.getValue();
        this.localeOptions = locales.map(locale => {
          return {
            label: locale.locale_code,
            command: event => this.selectLocale(event)
          };
        });
        this.selectedLocale = locales[0].locale_code;
        const fields = locales.map(locale => {
          const configuration = {
            type: InputType.text,
            name: locale.locale_code,
            label: locale.locale_code,
            validations: []
          };
          const input = this.formRendererService.getInputByConfigs(configuration, '', [{}]);
          input.className = `locales locale_${locale.locale_code}`;
          return input;
        });
        this.field.fieldArray = {
          fieldGroup: fields
        };
        if (!this.field.defaultValue || !this.field?.defaultValue?.length) {
          this.add();
        }
      }
    }
    ngAfterViewInit() {
      this.localeElements = this.elementRef.nativeElement.querySelectorAll('.locales');
      if (this.localeElements.length) {
        this.renderer.setStyle(this.localeElements[0], 'display', 'block');
      }
    }
    selectLocale(event) {
      this.selectedLocale = event.item.label;
      this.setActiveLocaleFormControl();
    }
    toggleMenu(event) {
      if (this.localeButton) {
        this.localeButton.onDropdownButtonClick(event);
      }
    }
    setActiveLocaleFormControl() {
      this.localeElements.forEach(element => this.renderer.removeStyle(element, 'display'));
      const activeLocale = this.elementRef.nativeElement.querySelector(`.locale_${this.selectedLocale}`);
      this.renderer.setStyle(activeLocale, 'display', 'block');
    }
    static {
      this.ɵfac = function CapturumBuilderTranslatedInputComponent_Factory(t) {
        return new (t || CapturumBuilderTranslatedInputComponent)(i0.ɵɵdirectiveInject(FormRendererService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderTranslatedInputComponent,
        selectors: [["cpb-translated-input"]],
        viewQuery: function CapturumBuilderTranslatedInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.localeButton = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 14,
        consts: [[1, "translated-field-wrapper", 3, "hidden"], [1, "field-locale-selector"], [3, "model", "label", "onClick"], ["localeButton", ""], [1, "translated-field-group"], [1, "field-group-addon"], [1, "flag", 3, "ngClass"], [1, "field-group-input"], ["class", "repeat-field-row", 4, "ngFor", "ngForOf"], [3, "hidden"], [1, "repeat-field-row"], [1, "repeat-field-form", 3, "field"]],
        template: function CapturumBuilderTranslatedInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p-splitButton", 2, 3);
            i0.ɵɵlistener("onClick", function CapturumBuilderTranslatedInputComponent_Template_p_splitButton_onClick_2_listener($event) {
              return ctx.toggleMenu($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
            i0.ɵɵelement(6, "span", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵtemplate(8, CapturumBuilderTranslatedInputComponent_div_8_Template, 2, 1, "div", 8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "cpb-readonly-container", 9);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "default");
            i0.ɵɵpipe(12, "displayValueByCurrentLocale");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.localeOptions)("label", ctx.selectedLocale);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngClass", "flag-" + ctx.selectedLocale);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.field.fieldGroup);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 9, i0.ɵɵpipeBind1(12, 12, ctx.formControl.value), ctx.to == null ? null : ctx.to.defaultEmptyValue), "\n");
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$6.FormlyField, i4$4.SplitButton, CapturumReadonlyContainerComponent, i5.DefaultPipe, DisplayValueByCurrentLocalePipe],
        styles: ["span.flag{width:44px;height:30px;display:inline-block}img.flag{width:30px}.flag{background:url(flags_responsive.png) no-repeat;background-size:100%;vertical-align:middle}.flag-ad{background-position:0 .413223%;color:red}.flag-ae{background-position:0 .826446%;color:red}.flag-af{background-position:0 1.239669%;color:red}.flag-ag{background-position:0 1.652892%;color:red}.flag-ai{background-position:0 2.066115%;color:red}.flag-al{background-position:0 2.479338%;color:red}.flag-am{background-position:0 2.892561%;color:red}.flag-an{background-position:0 3.305784%;color:red}.flag-ao{background-position:0 3.719007%;color:red}.flag-aq{background-position:0 4.13223%;color:red}.flag-ar{background-position:0 4.545453%;color:red}.flag-as{background-position:0 4.958676%;color:red}.flag-at{background-position:0 5.371899%;color:red}.flag-au{background-position:0 5.785122%;color:red}.flag-aw{background-position:0 6.198345%;color:red}.flag-az{background-position:0 6.611568%;color:red}.flag-ba{background-position:0 7.024791%;color:red}.flag-bb{background-position:0 7.438014%;color:red}.flag-bd{background-position:0 7.851237%;color:red}.flag-be{background-position:0 8.26446%;color:red}.flag-bf{background-position:0 8.677683%;color:red}.flag-bg{background-position:0 9.090906%;color:red}.flag-bh{background-position:0 9.504129%;color:red}.flag-bi{background-position:0 9.917352%;color:red}.flag-bj{background-position:0 10.330575%;color:red}.flag-bm{background-position:0 10.743798%;color:red}.flag-bn{background-position:0 11.157021%;color:red}.flag-bo{background-position:0 11.570244%;color:red}.flag-br{background-position:0 11.983467%;color:red}.flag-bs{background-position:0 12.39669%;color:red}.flag-bt{background-position:0 12.809913%;color:red}.flag-bv{background-position:0 13.223136%;color:red}.flag-bw{background-position:0 13.636359%;color:red}.flag-by{background-position:0 14.049582%;color:red}.flag-bz{background-position:0 14.462805%;color:red}.flag-ca{background-position:0 14.876028%;color:red}.flag-cc{background-position:0 15.289251%;color:red}.flag-cd{background-position:0 15.702474%;color:red}.flag-cf{background-position:0 16.115697%;color:red}.flag-cg{background-position:0 16.52892%;color:red}.flag-ch{background-position:0 16.942143%;color:red}.flag-ci{background-position:0 17.355366%;color:red}.flag-ck{background-position:0 17.768589%;color:red}.flag-cl{background-position:0 18.181812%;color:red}.flag-cm{background-position:0 18.595035%;color:red}.flag-cn{background-position:0 19.008258%;color:red}.flag-co{background-position:0 19.421481%;color:red}.flag-cr{background-position:0 19.834704%;color:red}.flag-cu{background-position:0 20.247927%;color:red}.flag-cv{background-position:0 20.66115%;color:red}.flag-cx{background-position:0 21.074373%;color:red}.flag-cy{background-position:0 21.487596%;color:red}.flag-cz{background-position:0 21.900819%;color:red}.flag-de{background-position:0 22.314042%;color:red}.flag-dj{background-position:0 22.727265%;color:red}.flag-dk{background-position:0 23.140488%;color:red}.flag-dm{background-position:0 23.553711%;color:red}.flag-do{background-position:0 23.966934%;color:red}.flag-dz{background-position:0 24.380157%;color:red}.flag-ec{background-position:0 24.79338%;color:red}.flag-ee{background-position:0 25.206603%;color:red}.flag-eg{background-position:0 25.619826%;color:red}.flag-eh{background-position:0 26.033049%;color:red}.flag-er{background-position:0 26.446272%;color:red}.flag-es{background-position:0 26.859495%;color:red}.flag-et{background-position:0 27.272718%;color:red}.flag-fi{background-position:0 27.685941%;color:red}.flag-fj{background-position:0 28.099164%;color:red}.flag-fk{background-position:0 28.512387%;color:red}.flag-fm{background-position:0 28.92561%;color:red}.flag-fo{background-position:0 29.338833%;color:red}.flag-fr{background-position:0 29.752056%;color:red}.flag-ga{background-position:0 30.165279%;color:red}.flag-gd{background-position:0 30.578502%;color:red}.flag-ge{background-position:0 30.991725%;color:red}.flag-gf{background-position:0 31.404948%;color:red}.flag-gh{background-position:0 31.818171%;color:red}.flag-gi{background-position:0 32.231394%;color:red}.flag-gl{background-position:0 32.644617%;color:red}.flag-gm{background-position:0 33.05784%;color:red}.flag-gn{background-position:0 33.471063%;color:red}.flag-gp{background-position:0 33.884286%;color:red}.flag-gq{background-position:0 34.297509%;color:red}.flag-gr{background-position:0 34.710732%;color:red}.flag-gs{background-position:0 35.123955%;color:red}.flag-gt{background-position:0 35.537178%;color:red}.flag-gu{background-position:0 35.950401%;color:red}.flag-gw{background-position:0 36.363624%;color:red}.flag-gy{background-position:0 36.776847%;color:red}.flag-hk{background-position:0 37.19007%;color:red}.flag-hm{background-position:0 37.603293%;color:red}.flag-hn{background-position:0 38.016516%;color:red}.flag-hr{background-position:0 38.429739%;color:red}.flag-ht{background-position:0 38.842962%;color:red}.flag-hu{background-position:0 39.256185%;color:red}.flag-id{background-position:0 39.669408%;color:red}.flag-ie{background-position:0 40.082631%;color:red}.flag-il{background-position:0 40.495854%;color:red}.flag-in{background-position:0 40.909077%;color:red}.flag-io{background-position:0 41.3223%;color:red}.flag-iq{background-position:0 41.735523%;color:red}.flag-ir{background-position:0 42.148746%;color:red}.flag-is{background-position:0 42.561969%;color:red}.flag-it{background-position:0 42.975192%;color:red}.flag-jm{background-position:0 43.388415%;color:red}.flag-jo{background-position:0 43.801638%;color:red}.flag-jp{background-position:0 44.214861%;color:red}.flag-ke{background-position:0 44.628084%;color:red}.flag-kg{background-position:0 45.041307%;color:red}.flag-kh{background-position:0 45.45453%;color:red}.flag-ki{background-position:0 45.867753%;color:red}.flag-km{background-position:0 46.280976%;color:red}.flag-kn{background-position:0 46.694199%;color:red}.flag-kp{background-position:0 47.107422%;color:red}.flag-kr{background-position:0 47.520645%;color:red}.flag-kw{background-position:0 47.933868%;color:red}.flag-ky{background-position:0 48.347091%;color:red}.flag-kz{background-position:0 48.760314%;color:red}.flag-la{background-position:0 49.173537%;color:red}.flag-lb{background-position:0 49.58676%;color:red}.flag-lc{background-position:0 49.999983%;color:red}.flag-li{background-position:0 50.413206%;color:red}.flag-lk{background-position:0 50.826429%;color:red}.flag-lr{background-position:0 51.239652%;color:red}.flag-ls{background-position:0 51.652875%;color:red}.flag-lt{background-position:0 52.066098%;color:red}.flag-lu{background-position:0 52.479321%;color:red}.flag-lv{background-position:0 52.892544%;color:red}.flag-ly{background-position:0 53.305767%;color:red}.flag-ma{background-position:0 53.71899%;color:red}.flag-mc{background-position:0 54.132213%;color:red}.flag-md{background-position:0 54.545436%;color:red}.flag-me{background-position:0 54.958659%;color:red}.flag-mg{background-position:0 55.371882%;color:red}.flag-mh{background-position:0 55.785105%;color:red}.flag-mk{background-position:0 56.198328%;color:red}.flag-ml{background-position:0 56.611551%;color:red}.flag-mm{background-position:0 57.024774%;color:red}.flag-mn{background-position:0 57.437997%;color:red}.flag-mo{background-position:0 57.85122%;color:red}.flag-mp{background-position:0 58.264443%;color:red}.flag-mq{background-position:0 58.677666%;color:red}.flag-mr{background-position:0 59.090889%;color:red}.flag-ms{background-position:0 59.504112%;color:red}.flag-mt{background-position:0 59.917335%;color:red}.flag-mu{background-position:0 60.330558%;color:red}.flag-mv{background-position:0 60.743781%;color:red}.flag-mw{background-position:0 61.157004%;color:red}.flag-mx{background-position:0 61.570227%;color:red}.flag-my{background-position:0 61.98345%;color:red}.flag-mz{background-position:0 62.396673%;color:red}.flag-na{background-position:0 62.809896%;color:red}.flag-nc{background-position:0 63.223119%;color:red}.flag-ne{background-position:0 63.636342%;color:red}.flag-nf{background-position:0 64.049565%;color:red}.flag-ng{background-position:0 64.462788%;color:red}.flag-ni{background-position:0 64.876011%;color:red}.flag-nl{background-position:0 65.289234%;color:red}.flag-no{background-position:0 65.702457%;color:red}.flag-np{background-position:0 66.11568%;color:red}.flag-nr{background-position:0 66.528903%;color:red}.flag-nu{background-position:0 66.942126%;color:red}.flag-nz{background-position:0 67.355349%;color:red}.flag-om{background-position:0 67.768572%;color:red}.flag-pa{background-position:0 68.181795%;color:red}.flag-pe{background-position:0 68.595018%;color:red}.flag-pf{background-position:0 69.008241%;color:red}.flag-pg{background-position:0 69.421464%;color:red}.flag-ph{background-position:0 69.834687%;color:red}.flag-pk{background-position:0 70.24791%;color:red}.flag-pl{background-position:0 70.661133%;color:red}.flag-pm{background-position:0 71.074356%;color:red}.flag-pn{background-position:0 71.487579%;color:red}.flag-pr{background-position:0 71.900802%;color:red}.flag-pt{background-position:0 72.314025%;color:red}.flag-pw{background-position:0 72.727248%;color:red}.flag-py{background-position:0 73.140471%;color:red}.flag-qa{background-position:0 73.553694%;color:red}.flag-re{background-position:0 73.966917%;color:red}.flag-ro{background-position:0 74.38014%;color:red}.flag-rs{background-position:0 74.793363%;color:red}.flag-ru{background-position:0 75.206586%;color:red}.flag-rw{background-position:0 75.619809%;color:red}.flag-sa{background-position:0 76.033032%;color:red}.flag-sb{background-position:0 76.446255%;color:red}.flag-sc{background-position:0 76.859478%;color:red}.flag-sd{background-position:0 77.272701%;color:red}.flag-se{background-position:0 77.685924%;color:red}.flag-sg{background-position:0 78.099147%;color:red}.flag-sh{background-position:0 78.51237%;color:red}.flag-si{background-position:0 78.925593%;color:red}.flag-sj{background-position:0 79.338816%;color:red}.flag-sk{background-position:0 79.752039%;color:red}.flag-sl{background-position:0 80.165262%;color:red}.flag-sm{background-position:0 80.578485%;color:red}.flag-sn{background-position:0 80.991708%;color:red}.flag-so{background-position:0 81.404931%;color:red}.flag-sr{background-position:0 81.818154%;color:red}.flag-ss{background-position:0 82.231377%;color:red}.flag-st{background-position:0 82.6446%;color:red}.flag-sv{background-position:0 83.057823%;color:red}.flag-sy{background-position:0 83.471046%;color:red}.flag-sz{background-position:0 83.884269%;color:red}.flag-tc{background-position:0 84.297492%;color:red}.flag-td{background-position:0 84.710715%;color:red}.flag-tf{background-position:0 85.123938%;color:red}.flag-tg{background-position:0 85.537161%;color:red}.flag-th{background-position:0 85.950384%;color:red}.flag-tj{background-position:0 86.363607%;color:red}.flag-tk{background-position:0 86.77683%;color:red}.flag-tl{background-position:0 87.190053%;color:red}.flag-tm{background-position:0 87.603276%;color:red}.flag-tn{background-position:0 88.016499%;color:red}.flag-to{background-position:0 88.429722%;color:red}.flag-tp{background-position:0 88.842945%;color:red}.flag-tr{background-position:0 89.256168%;color:red}.flag-tt{background-position:0 89.669391%;color:red}.flag-tv{background-position:0 90.082614%;color:red}.flag-tw{background-position:0 90.495837%;color:red}.flag-ty{background-position:0 90.90906%;color:red}.flag-tz{background-position:0 91.322283%;color:red}.flag-ua{background-position:0 91.735506%;color:red}.flag-ug{background-position:0 92.148729%;color:red}.flag-uk{background-position:0 92.561952%;color:red}.flag-um{background-position:0 92.975175%;color:red}.flag-us{background-position:0 93.388398%;color:red}.flag-uy{background-position:0 93.801621%;color:red}.flag-uz{background-position:0 94.214844%;color:red}.flag-va{background-position:0 94.628067%;color:red}.flag-vc{background-position:0 95.04129%;color:red}.flag-ve{background-position:0 95.454513%;color:red}.flag-vg{background-position:0 95.867736%;color:red}.flag-vi{background-position:0 96.280959%;color:red}.flag-vn{background-position:0 96.694182%;color:red}.flag-vu{background-position:0 97.107405%;color:red}.flag-wf{background-position:0 97.520628%;color:red}.flag-ws{background-position:0 97.933851%;color:red}.flag-ye{background-position:0 98.347074%;color:red}.flag-za{background-position:0 98.760297%;color:red}.flag-zm{background-position:0 99.17352%;color:red}.flag-zr{background-position:0 99.586743%;color:red}.flag-zw{background-position:0 99.999966%;color:red}.flag-gb,.flag-uk,.flag-en{background-position:0 92.561983%}.translated-field-wrapper{position:relative}.translated-field-wrapper .field-locale-selector{position:absolute;right:0;top:0;transform:translate3d(0,-24px,0)}.translated-field-wrapper .field-locale-selector .p-splitbutton{padding-right:1rem}.translated-field-wrapper .field-locale-selector .p-splitbutton-defaultbutton{border:0;background-color:transparent}.translated-field-wrapper .field-locale-selector .p-splitbutton-defaultbutton .p-button-label{font-size:1rem;padding:0;text-transform:uppercase}.translated-field-wrapper .field-locale-selector .p-splitbutton-menubutton.p-button{border:0;background-color:transparent;padding:0}.translated-field-wrapper .field-locale-selector .p-menu .p-menu-list{text-transform:uppercase}.translated-field-group{display:flex;border:1px solid #ced4da;border-radius:3px}.translated-field-group .field-group-addon{flex:0 0 50px;max-width:50px;border-right:1px solid #ced4da;display:flex;align-items:center;justify-content:center}.translated-field-group .field-group-addon .flag{transform:scale(.7)}.translated-field-group .field-group-input{flex-grow:1}.translated-field-group .field-group-input .p-inputgroup .p-inputtext{border:0}body .translated-field-group .field-group-input .p-inputgroup .p-inputtext:enabled,body .translated-field-group .field-group-input .p-inputgroup .p-inputtext:enabled:hover,body .translated-field-group .field-group-input .p-inputgroup .p-inputtext:enabled:focus,body .translated-field-group .field-group-input .p-inputgroup .p-inputtext:focus-visible{border:0;outline:0}.translated-field-group .locales{display:none}.translated-field-group .locales cpb-default-input-wrapper .form-group .label-wrapper{display:none}.translated-field-group .locales cpb-default-input-wrapper .form-group .form-invalid-feedback{display:none}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderTranslatedInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderUrlInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderUrlInputComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.labelPosition = LabelPosition;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumBuilderUrlInputComponent_BaseFactory;
        return function CapturumBuilderUrlInputComponent_Factory(t) {
          return (ɵCapturumBuilderUrlInputComponent_BaseFactory || (ɵCapturumBuilderUrlInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumBuilderUrlInputComponent)))(t || CapturumBuilderUrlInputComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderUrlInputComponent,
        selectors: [["cpb-url-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 24,
        consts: [[3, "formControl", "floatLabel", "label", "readonly", "hidden", "hasTooltip", "selectOnFocus", "placeholder"], [3, "hidden"], ["target", "_blank", 3, "href"]],
        template: function CapturumBuilderUrlInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵelementStart(5, "cpb-readonly-container", 1)(6, "a", 2);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "default");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 13, i0.ɵɵpipeBind1(2, 15, ctx.to.label_position)) === ctx.labelPosition.Floating)("label", i0.ɵɵpipeBind1(3, 17, i0.ɵɵpipeBind1(4, 19, ctx.to.label_position)) === ctx.labelPosition.Floating ? ctx.to.label : "")("readonly", ctx.to.readonly)("hidden", ctx.to.readonly)("hasTooltip", ctx.to.tooltip)("selectOnFocus", ctx.to == null ? null : ctx.to.select_on_focus)("placeholder", ctx.to.readonly ? "" : ctx.to.placeholder);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("href", ctx.formControl.value, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 21, ctx.formControl.value, ctx.to == null ? null : ctx.to.defaultEmptyValue));
          }
        },
        dependencies: [i1$2.NgControlStatus, i1$2.FormControlDirective, i2$1.CapturumInputComponent, CapturumReadonlyContainerComponent, i1$1.AsyncPipe, i5.ObservablePipe, i5.DefaultPipe]
      });
    }
  }
  return CapturumBuilderUrlInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumFormlyConfig = /*#__PURE__*/(() => {
  class CapturumFormlyConfig extends FormlyConfig {
    constructor(translateService) {
      super();
      this.translateService = translateService;
    }
    getValidatorMessage(name) {
      return this.translateService.instant(`validation-errors.${name}`);
    }
    static {
      this.ɵfac = function CapturumFormlyConfig_Factory(t) {
        return new (t || CapturumFormlyConfig)(i0.ɵɵinject(i6.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumFormlyConfig,
        factory: CapturumFormlyConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CapturumFormlyConfig;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextInputTypeBuilder = /*#__PURE__*/(() => {
  class TextInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.text;
    }
    appendOptions(input, configuration) {
      input.props = {
        ...input.props,
        content_left: configuration?.options?.content_left ?? null
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵTextInputTypeBuilder_BaseFactory;
        return function TextInputTypeBuilder_Factory(t) {
          return (ɵTextInputTypeBuilder_BaseFactory || (ɵTextInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(TextInputTypeBuilder)))(t || TextInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TextInputTypeBuilder,
        factory: TextInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TextInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UrlInputTypeBuilder = /*#__PURE__*/(() => {
  class UrlInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.url;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵUrlInputTypeBuilder_BaseFactory;
        return function UrlInputTypeBuilder_Factory(t) {
          return (ɵUrlInputTypeBuilder_BaseFactory || (ɵUrlInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(UrlInputTypeBuilder)))(t || UrlInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UrlInputTypeBuilder,
        factory: UrlInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UrlInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HiddenInputTypeBuilder = /*#__PURE__*/(() => {
  class HiddenInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.hidden;
    }
    appendOptions(input, configuration) {
      super.appendOptions(input, configuration);
      input.wrappers = ['hidden'];
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵHiddenInputTypeBuilder_BaseFactory;
        return function HiddenInputTypeBuilder_Factory(t) {
          return (ɵHiddenInputTypeBuilder_BaseFactory || (ɵHiddenInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(HiddenInputTypeBuilder)))(t || HiddenInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HiddenInputTypeBuilder,
        factory: HiddenInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HiddenInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EntityTextInputTypeBuilder = /*#__PURE__*/(() => {
  class EntityTextInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.entityText;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵEntityTextInputTypeBuilder_BaseFactory;
        return function EntityTextInputTypeBuilder_Factory(t) {
          return (ɵEntityTextInputTypeBuilder_BaseFactory || (ɵEntityTextInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(EntityTextInputTypeBuilder)))(t || EntityTextInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EntityTextInputTypeBuilder,
        factory: EntityTextInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EntityTextInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslatedInputTypeBuilder = /*#__PURE__*/(() => {
  class TranslatedInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.translated;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵTranslatedInputTypeBuilder_BaseFactory;
        return function TranslatedInputTypeBuilder_Factory(t) {
          return (ɵTranslatedInputTypeBuilder_BaseFactory || (ɵTranslatedInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(TranslatedInputTypeBuilder)))(t || TranslatedInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslatedInputTypeBuilder,
        factory: TranslatedInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TranslatedInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxInputTypeBuilder = /*#__PURE__*/(() => {
  class CheckboxInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.checkbox;
    }
    appendOptions(input, configuration) {
      input.wrappers = ['checkbox-wrapper'];
    }
    setDefaultValue(input, value) {
      if (value) {
        input.defaultValue = value[input.key] ?? null;
      } else {
        input.defaultValue = input.defaultValue ?? false;
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCheckboxInputTypeBuilder_BaseFactory;
        return function CheckboxInputTypeBuilder_Factory(t) {
          return (ɵCheckboxInputTypeBuilder_BaseFactory || (ɵCheckboxInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxInputTypeBuilder)))(t || CheckboxInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckboxInputTypeBuilder,
        factory: CheckboxInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckboxInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxListInputTypeBuilder = /*#__PURE__*/(() => {
  class CheckboxListInputTypeBuilder extends InputTypeBuilder {
    constructor(formInputTypeFacade) {
      super(formInputTypeFacade);
      this.formInputTypeFacade = formInputTypeFacade;
      this.inputType = InputType.checkboxList;
      this.subscription = new Subscription();
    }
    getValueChangesSubscription(field, configuration) {
      return field.formControl.valueChanges.pipe(startWith(field.formControl.value), switchMap(fieldValue => {
        return field?.props?.options$ ? field.props.options$.asObservable().pipe(map(fieldOptions => ({
          fieldValue,
          fieldOptions
        }))) : of({
          fieldValue: null,
          fieldOptions: []
        });
      })).subscribe(({
        fieldValue,
        fieldOptions
      }) => {
        if (field?.props) {
          this.setStateValue(fieldOptions, field, fieldValue, configuration);
        }
      });
    }
    appendOptions(input, configuration) {
      if (configuration.options) {
        const options$ = this.formInputTypeFacade.getTransformedOptions(configuration.options, input.props.formKey).pipe(shareReplay(1));
        input.hooks = {
          onInit: field => {
            this.setprops(options$, input);
            if (configuration.sets && field?.formControl) {
              this.subscription.add(this.getValueChangesSubscription(field, configuration));
            }
            if (configuration.dependencies && configuration.dependencies.length && configuration?.dependency_operator && field) {
              this.formInputTypeFacade.resolveDependencies(field, configuration);
            }
          },
          onDestroy: () => this.subscription.unsubscribe()
        };
      }
    }
    setprops(options$, input) {
      options$.pipe(take(1)).subscribe(options => {
        input.props.options$.next(options);
      });
    }
    setStateValue(fieldOptions, field, fieldValue, configuration) {
      const stateOptions = fieldOptions.filter(option => {
        return fieldValue && fieldValue.includes(option[field?.props?.value_key]);
      });
      this.formInputTypeFacade.setValueByKey(configuration.sets, stateOptions);
    }
    static {
      this.ɵfac = function CheckboxListInputTypeBuilder_Factory(t) {
        return new (t || CheckboxListInputTypeBuilder)(i0.ɵɵinject(FormInputTypeFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckboxListInputTypeBuilder,
        factory: CheckboxListInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckboxListInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextareaInputTypeBuilder = /*#__PURE__*/(() => {
  class TextareaInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.textarea;
    }
    appendOptions(input, configuration) {
      if (input?.props && configuration?.options) {
        input.props.cols = configuration.options.cols;
        input.props.rows = configuration.options.rows;
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵTextareaInputTypeBuilder_BaseFactory;
        return function TextareaInputTypeBuilder_Factory(t) {
          return (ɵTextareaInputTypeBuilder_BaseFactory || (ɵTextareaInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(TextareaInputTypeBuilder)))(t || TextareaInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TextareaInputTypeBuilder,
        factory: TextareaInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TextareaInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelInputTypeBuilder = /*#__PURE__*/(() => {
  class LabelInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.label;
    }
    appendOptions(input, configuration) {
      input.wrappers = ['content'];
      input.props = {
        ...input.props,
        css_class: configuration?.options?.css_class
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵLabelInputTypeBuilder_BaseFactory;
        return function LabelInputTypeBuilder_Factory(t) {
          return (ɵLabelInputTypeBuilder_BaseFactory || (ɵLabelInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(LabelInputTypeBuilder)))(t || LabelInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LabelInputTypeBuilder,
        factory: LabelInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LabelInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmailInputTypeBuilder = /*#__PURE__*/(() => {
  class EmailInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.email;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵEmailInputTypeBuilder_BaseFactory;
        return function EmailInputTypeBuilder_Factory(t) {
          return (ɵEmailInputTypeBuilder_BaseFactory || (ɵEmailInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(EmailInputTypeBuilder)))(t || EmailInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EmailInputTypeBuilder,
        factory: EmailInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EmailInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateInputTypeBuilder = /*#__PURE__*/(() => {
  class DateInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.date;
    }
    appendOptions(input, configuration) {
      if (input.props) {
        input.props.start_date = configuration.options?.start_date || null;
        input.props.min_date = configuration.options?.min_date ? new Date(configuration.options?.min_date) : null;
        input.props.max_date = configuration.options?.max_date ? new Date(configuration.options?.max_date) : null;
        input.props.date = configuration.options?.date ?? null;
        input.props.time = configuration.options?.time ?? null;
        input.props.timezone = configuration.options?.timezone ?? null;
        input.props.selectionMode = configuration.options?.selectionMode ?? null;
        input.props.appendTo = configuration.options?.appendTo ?? null;
      }
    }
    setDefaultValue(input, value) {
      const defaultDate = new Date(input.defaultValue);
      input.defaultValue = input.defaultValue && !isNaN(defaultDate.getTime()) ? new Date(input.defaultValue) : null;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵDateInputTypeBuilder_BaseFactory;
        return function DateInputTypeBuilder_Factory(t) {
          return (ɵDateInputTypeBuilder_BaseFactory || (ɵDateInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(DateInputTypeBuilder)))(t || DateInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DateInputTypeBuilder,
        factory: DateInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DateInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RadioInputTypeBuilder = /*#__PURE__*/(() => {
  class RadioInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.radio;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵRadioInputTypeBuilder_BaseFactory;
        return function RadioInputTypeBuilder_Factory(t) {
          return (ɵRadioInputTypeBuilder_BaseFactory || (ɵRadioInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(RadioInputTypeBuilder)))(t || RadioInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RadioInputTypeBuilder,
        factory: RadioInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RadioInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DropdownInputTypeBuilder = /*#__PURE__*/(() => {
  class DropdownInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.dropdown;
    }
    appendOptions(input, configuration) {
      input.props.virtualScroll = configuration.options.virtualScroll;
      input.props.virtualScrollItemSize = configuration.options.virtualScrollItemSize;
      input.props.appendTo = configuration.options?.appendTo ?? null;
      input.props.withIcons = configuration.options.show_option_icon;
      input.props.filterBy = configuration.options.filterBy || null;
      super.appendOptions(input, configuration);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵDropdownInputTypeBuilder_BaseFactory;
        return function DropdownInputTypeBuilder_Factory(t) {
          return (ɵDropdownInputTypeBuilder_BaseFactory || (ɵDropdownInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(DropdownInputTypeBuilder)))(t || DropdownInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DropdownInputTypeBuilder,
        factory: DropdownInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DropdownInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileInputTypeBuilder = /*#__PURE__*/(() => {
  class FileInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.file;
    }
    appendOptions(input, configuration) {
      if (input.props && configuration) {
        input.props.multiple = configuration?.options?.is_multiple ?? true;
        input.props.validations = this.prepareValidations(configuration);
        input.props.availableExtensions = this.prepareAvailableExtensions(configuration);
        input.props.isVapor = configuration.options?.is_vapor;
        if (configuration?.options?.tag || configuration.options?.tag?.length) {
          input.props.tag = configuration.options.tag;
        }
        input.props.fileableType = configuration?.options?.fileable ?? null;
      }
    }
    prepareValidations(configuration) {
      const validations = {
        mimes: '',
        max: null
      };
      for (const validation in configuration.validations) {
        if (configuration.validations.hasOwnProperty(validation)) {
          if (typeof configuration.validations[validation] === 'string') {
            const validationParts = configuration.validations[validation].split(':');
            const validationName = validationParts[0];
            let validationRules = validationParts[1];
            if (validationName === 'max') {
              validationRules = +validationRules * 1024; // Convert KB to B.
            }

            if (validations.hasOwnProperty(validationName)) {
              validations[validationName] = validationRules;
            } else {
              validations[validation] = configuration.validations[validation];
            }
          }
        }
      }
      return validations;
    }
    prepareAvailableExtensions(configuration) {
      return this.prepareValidations(configuration).mimes.split(',').map(extension => `.${extension}`).join(',');
    }
    setDefaultValue(input, value) {
      if (value) {
        if (Array.isArray(value)) {
          input.defaultValue = value.map(val => this.getDefaultValueData(val));
          input.props = {
            ...input.props,
            previewData: value.map(val => this.getFilePreviewData(val))
          };
        } else {
          input.defaultValue = this.getDefaultValueData(value);
          input.props = {
            ...input.props,
            previewData: this.getFilePreviewData(value)
          };
        }
      }
    }
    getDefaultValueData(value) {
      return {
        data: value.id,
        filename: value.filename,
        mime_type: value.mime_type
      };
    }
    getFilePreviewData(value) {
      return {
        url: value.public_url,
        name: value.filename,
        id: value.id
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵFileInputTypeBuilder_BaseFactory;
        return function FileInputTypeBuilder_Factory(t) {
          return (ɵFileInputTypeBuilder_BaseFactory || (ɵFileInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(FileInputTypeBuilder)))(t || FileInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FileInputTypeBuilder,
        factory: FileInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FileInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSelectInputTypeBuilder = /*#__PURE__*/(() => {
  class MultiSelectInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.multiSelect;
    }
    appendOptions(input, configuration) {
      input.props.virtualScroll = configuration.options.virtualScroll;
      input.props.virtualScrollItemSize = configuration.options.virtualScrollItemSize;
      input.props.resetFilterOnHide = configuration.options.resetFilterOnHide;
      input.props.sourceValueKey = configuration.options.sourceValueKey;
      input.props.appendTo = configuration.options?.appendTo ?? null;
      input.props.selectionLimit = configuration.options?.selectionLimit ?? null;
      input.props.filterBy = configuration.options.filterBy || null;
      super.appendOptions(input, configuration);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵMultiSelectInputTypeBuilder_BaseFactory;
        return function MultiSelectInputTypeBuilder_Factory(t) {
          return (ɵMultiSelectInputTypeBuilder_BaseFactory || (ɵMultiSelectInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(MultiSelectInputTypeBuilder)))(t || MultiSelectInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MultiSelectInputTypeBuilder,
        factory: MultiSelectInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MultiSelectInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToggleInputTypeBuilder = /*#__PURE__*/(() => {
  class ToggleInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.toggle;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵToggleInputTypeBuilder_BaseFactory;
        return function ToggleInputTypeBuilder_Factory(t) {
          return (ɵToggleInputTypeBuilder_BaseFactory || (ɵToggleInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(ToggleInputTypeBuilder)))(t || ToggleInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ToggleInputTypeBuilder,
        factory: ToggleInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ToggleInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RepeatInputTypeBuilder = /*#__PURE__*/(() => {
  class RepeatInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.repeat;
    }
    appendOptions(input, configuration) {
      input.props = {
        ...input.props,
        configuration,
        addButtonText: configuration.options.actions.add_button.label,
        addButtonIcon: configuration.options.actions.add_button.icon,
        deleteButtonIcon: configuration.options.actions.delete_button.icon,
        deleteButtonText: configuration.options.actions.delete_button.label
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵRepeatInputTypeBuilder_BaseFactory;
        return function RepeatInputTypeBuilder_Factory(t) {
          return (ɵRepeatInputTypeBuilder_BaseFactory || (ɵRepeatInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(RepeatInputTypeBuilder)))(t || RepeatInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RepeatInputTypeBuilder,
        factory: RepeatInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RepeatInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageInputTypeBuilder = /*#__PURE__*/(() => {
  class ImageInputTypeBuilder extends FileInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.image;
    }
    appendOptions(input, configuration) {
      super.appendOptions(input, configuration);
      if (!input.props.availableExtensions || input.props.availableExtensions === '.') {
        input.props.availableExtensions = 'image/*';
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵImageInputTypeBuilder_BaseFactory;
        return function ImageInputTypeBuilder_Factory(t) {
          return (ɵImageInputTypeBuilder_BaseFactory || (ɵImageInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(ImageInputTypeBuilder)))(t || ImageInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ImageInputTypeBuilder,
        factory: ImageInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ImageInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NumberFormatTypeBuilder = /*#__PURE__*/(() => {
  class NumberFormatTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.number;
    }
    appendOptions(input, configuration) {
      if (input?.props && configuration?.options?.number) {
        input.props = {
          ...input.props,
          ...configuration?.options,
          ...configuration?.options.number
        };
        delete input.props.number;
      }
      super.appendOptions(input, configuration);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵNumberFormatTypeBuilder_BaseFactory;
        return function NumberFormatTypeBuilder_Factory(t) {
          return (ɵNumberFormatTypeBuilder_BaseFactory || (ɵNumberFormatTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(NumberFormatTypeBuilder)))(t || NumberFormatTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NumberFormatTypeBuilder,
        factory: NumberFormatTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NumberFormatTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxValueInputTypeBuilder = /*#__PURE__*/(() => {
  class CheckboxValueInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.checkbox;
    }
    appendOptions(input, configuration) {
      input.wrappers = ['checkbox-wrapper'];
      input.props.trueValue = configuration.options?.trueValue || true;
      input.props.falseValue = configuration.options?.falseValue || false;
    }
    setDefaultValue(input, value) {
      if (value) {
        input.defaultValue = value[input.key] ?? null;
      } else {
        input.defaultValue = input.defaultValue ?? false;
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCheckboxValueInputTypeBuilder_BaseFactory;
        return function CheckboxValueInputTypeBuilder_Factory(t) {
          return (ɵCheckboxValueInputTypeBuilder_BaseFactory || (ɵCheckboxValueInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxValueInputTypeBuilder)))(t || CheckboxValueInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckboxValueInputTypeBuilder,
        factory: CheckboxValueInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckboxValueInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconInputTypeBuilder = /*#__PURE__*/(() => {
  class IconInputTypeBuilder extends InputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.icon;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵIconInputTypeBuilder_BaseFactory;
        return function IconInputTypeBuilder_Factory(t) {
          return (ɵIconInputTypeBuilder_BaseFactory || (ɵIconInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(IconInputTypeBuilder)))(t || IconInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IconInputTypeBuilder,
        factory: IconInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IconInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditorInputTypeBuilder = /*#__PURE__*/(() => {
  class EditorInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.editor;
    }
    appendOptions(input, configuration) {
      input.props = {
        ...input.props,
        ...configuration.options
      };
      super.appendOptions(input, configuration);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵEditorInputTypeBuilder_BaseFactory;
        return function EditorInputTypeBuilder_Factory(t) {
          return (ɵEditorInputTypeBuilder_BaseFactory || (ɵEditorInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(EditorInputTypeBuilder)))(t || EditorInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EditorInputTypeBuilder,
        factory: EditorInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EditorInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const inputTypeBuilders = {
  [InputType.checkbox]: CheckboxInputTypeBuilder,
  [InputType.checkboxList]: CheckboxListInputTypeBuilder,
  [InputType.text]: TextInputTypeBuilder,
  [InputType.textarea]: TextareaInputTypeBuilder,
  [InputType.label]: LabelInputTypeBuilder,
  [InputType.email]: EmailInputTypeBuilder,
  [InputType.image]: ImageInputTypeBuilder,
  [InputType.number]: NumberFormatTypeBuilder,
  [InputType.date]: DateInputTypeBuilder,
  [InputType.radio]: RadioInputTypeBuilder,
  [InputType.dropdown]: DropdownInputTypeBuilder,
  [InputType.custom]: CustomInputTypeBuilder,
  [InputType.file]: FileInputTypeBuilder,
  [InputType.multiSelect]: MultiSelectInputTypeBuilder,
  [InputType.toggle]: ToggleInputTypeBuilder,
  [InputType.repeat]: RepeatInputTypeBuilder,
  [InputType.translated]: TranslatedInputTypeBuilder,
  [InputType.entityText]: EntityTextInputTypeBuilder,
  [InputType.editor]: EditorInputTypeBuilder,
  [InputType.checkboxValue]: CheckboxValueInputTypeBuilder,
  [InputType.hidden]: HiddenInputTypeBuilder,
  [InputType.url]: UrlInputTypeBuilder,
  [InputType.icon]: IconInputTypeBuilder
};
let CapturumBuilderIconInputComponent = /*#__PURE__*/(() => {
  class CapturumBuilderIconInputComponent extends FieldType {
    constructor(http) {
      super();
      this.http = http;
      this.icons = [];
      this.destroy$ = new Subject();
      this.mappedIcons = './assets/reduced-font-awesome-icons.json';
    }
    ngOnInit() {
      this.http.get(this.mappedIcons).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.icons = data;
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function CapturumBuilderIconInputComponent_Factory(t) {
        return new (t || CapturumBuilderIconInputComponent)(i0.ɵɵdirectiveInject(i1$7.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumBuilderIconInputComponent,
        selectors: [["cpb-icon-input"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 32,
        consts: [[3, "appendTo", "filterBy", "filter", "formControl", "hidden", "optionLabel", "optionValue", "options", "panelStyleClass", "placeholder", "readonly", "showClear", "sortAlphabetically", "virtualScrollItemSize", "virtualScroll"], ["capTemplate", "item"], ["capTemplate", "selectedItem"], ["icon", ""], [3, "hidden"], [1, "cpb-icon-input-icons"], [3, "ngClass"], [3, "ngTemplateOutletContext", "ngTemplateOutlet"], [1, "icon-name"]],
        template: function CapturumBuilderIconInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dropdown", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵtext(2, "> ");
            i0.ɵɵtemplate(3, CapturumBuilderIconInputComponent_ng_template_3_Template, 1, 4, "ng-template", 1);
            i0.ɵɵtemplate(4, CapturumBuilderIconInputComponent_ng_template_4_Template, 1, 4, "ng-template", 2);
            i0.ɵɵtemplate(5, CapturumBuilderIconInputComponent_ng_template_5_Template, 4, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "cpb-readonly-container", 4)(8, "div", 5);
            i0.ɵɵelement(9, "i", 6);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "default");
            i0.ɵɵpipe(12, "labelsByValue");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("appendTo", (ctx.to == null ? null : ctx.to.appendTo) || "body")("filterBy", "search")("filter", true)("formControl", ctx.formControl)("hidden", ctx.to.readonly)("optionLabel", "label")("optionValue", "key")("options", ctx.icons)("panelStyleClass", ctx.to.css_class)("placeholder", ctx.to.placeholder || i0.ɵɵpipeBind1(1, 22, "placeholder.select"))("readonly", ctx.to.readonly)("showClear", true)("sortAlphabetically", ctx.to == null ? null : ctx.to.sort_asc)("virtualScrollItemSize", ctx.to.virtualScrollItemSize || 30)("virtualScroll", ctx.to.virtualScroll);
            i0.ɵɵattribute("data-test", "builder-" + ctx.field.key);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("hidden", !ctx.to.readonly);
            i0.ɵɵattribute("data-test", "builder-readonly-" + ctx.field.key);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.formControl.value);
            i0.ɵɵproperty("ngClass", "input-icon");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 24, i0.ɵɵpipeBind2(12, 27, i0.ɵɵpureFunction1(30, _c2, ctx.formControl.value), ctx.icons), ctx.to == null ? null : ctx.to.defaultEmptyValue), " ");
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgTemplateOutlet, i1$2.NgControlStatus, i1$2.FormControlDirective, i3$3.CapturumDropdownComponent, i5.CapturumTemplateDirective, CapturumReadonlyContainerComponent, i5.DefaultPipe, i6.TranslatePipe, LabelsByValuesPipe],
        styles: ["cpb-icon-input .cap-dropdown.p-dropdown .p-dropdown-clear-icon{position:static;padding-right:.5rem;margin-top:0;align-self:center}.cpb-icon-input-icons{display:flex;align-items:center}.cpb-icon-input-icons .input-icon{margin-right:5px}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumBuilderIconInputComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const inputTypeComponents = [{
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.checkbox),
  component: CapturumBuilderCheckboxInputComponent,
  wrappers: ['checkbox-wrapper']
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.checkboxList),
  component: CapturumBuilderCheckboxListInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.text),
  component: CapturumBuilderTextInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.textarea),
  component: CapturumBuilderTextareaInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.label),
  component: CapturumBuilderLabelInputComponent,
  wrappers: ['content']
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.email),
  component: CapturumBuilderEmailInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.dropdown),
  component: CapturumBuilderDropdownInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.image),
  component: CapturumBuilderImageInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.number),
  component: CapturumBuilderNumberFormatInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.date),
  component: CapturumBuilderDateInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.group),
  component: CapturumBuilderGroupInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.multiSelect),
  component: CapturumMultiSelectInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.radio),
  component: CapturumBuilderRadioInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.toggle),
  component: CapturumBuilderToggleInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.repeat),
  component: CapturumRepeatInputTypeComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.file),
  component: CapturumBuilderFileInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.translated),
  component: CapturumBuilderTranslatedInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.entityText),
  component: CapturumBuilderEntityTextInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.editor),
  component: CapturumBuilderEditorInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.checkboxValue),
  component: CapturumBuilderCheckboxValueInputComponent,
  wrappers: ['checkbox-wrapper']
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.hidden),
  component: CapturumBuilderHiddenTypeComponent,
  wrappers: ['hidden']
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.url),
  component: CapturumBuilderUrlInputComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.password),
  component: CapturumBuilderPasswordTypeComponent
}, {
  name: FormFieldsManipulatorUtil.getFormlyTypeName(InputType.icon),
  component: CapturumBuilderIconInputComponent
}];
var TemplateTypes = /*#__PURE__*/function (TemplateTypes) {
  TemplateTypes["header"] = "header";
  TemplateTypes["rightButtons"] = "rightButtons";
  TemplateTypes["leftButtons"] = "leftButtons";
  return TemplateTypes;
}(TemplateTypes || {});
let CapturumFormRendererComponent = /*#__PURE__*/(() => {
  class CapturumFormRendererComponent {
    constructor(formRendererService, formRendererApiService, cdr, contextService, formManipulatorService) {
      this.formRendererService = formRendererService;
      this.formRendererApiService = formRendererApiService;
      this.cdr = cdr;
      this.contextService = contextService;
      this.formManipulatorService = formManipulatorService;
      this.showHeader = true;
      this.form = new FormGroup({});
      this.formOptions = {
        formState: {
          readonly: false
        }
      };
      this.destroy$ = new Subject();
      this.fieldsReadySubject = new BehaviorSubject(false);
      this.updateFormFieldsSubject = new BehaviorSubject(null);
      this._readOnly = false;
    }
    get formKey() {
      return this.contextKey || this._formKey;
    }
    set formKey(value) {
      if (value) {
        this._formKey = value;
      }
    }
    get formConfiguration() {
      return this._formConfiguration;
    }
    set formConfiguration(value) {
      if (value) {
        this._formConfiguration = value;
        this.fetchFields();
      }
    }
    get readOnly() {
      return this._readOnly;
    }
    set readOnly(value) {
      this._readOnly = value;
      this.formOptions.formState.readonly = value;
    }
    get modelId() {
      return this._modelId;
    }
    set modelId(value) {
      if (value) {
        this._modelId = value;
        this.getFormSourceData();
      }
    }
    get defaultValue() {
      return this._defaultValue;
    }
    set defaultValue(value) {
      this._defaultValue = value;
      if (!this.modelId) {
        this.formModel = {
          ...value
        };
      }
    }
    ngOnInit() {
      this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.formRendererService.updateFormValueState(this.formKey, this.form.getRawValue());
      });
      this.form.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(status => {
        this.formRendererService.updateFormStatus(this.formKey, status === 'VALID');
      });
    }
    ngAfterViewInit() {
      this.assignTemplates();
    }
    ngOnChanges(changes) {
      if (!this.contextIsSet && this.formKey && !!this.context) {
        this.contextService.setContext(this.contextKey || this.formKey, this.context);
        this.contextIsSet = true;
        this.fetchFields();
      } else if (!this.contextIsSet && this.formKey) {
        this.fetchFields();
        this.contextIsSet = true;
      } else if (this.contextIsSet && changes.formKey) {
        this.fetchFields();
      }
    }
    ngOnDestroy() {
      this.formRendererService.resetFormValue(this._formKey);
      this.contextService.clearContextByKey(this.formKey);
      this.formManipulatorService.resetFormManipulations(this.formKey);
      this.destroy$.next();
      this.destroy$.complete();
      this.formRendererService.setSourceValue(this.formKey, null);
    }
    getFormSourceData() {
      combineLatest([this.formRendererService.getFormConfigurationByKey(this.formKey).pipe(filter(Boolean), take(1)), this.fieldsReadySubject.asObservable().pipe(filter(Boolean), take(1), takeUntil(this.destroy$))]).pipe(switchMap(([configuration, ready]) => {
        const formConfiguration = ready && this._formConfiguration ? this._formConfiguration : configuration;
        return this.formRendererApiService.getSource(formConfiguration, this.modelId, this._formKey).pipe(map(source => [source, configuration]));
      })).subscribe(([response, config]) => {
        response = {
          [config.identifier_field]: this.modelId,
          ...response
        };
        if (config && response.hasOwnProperty(config.identifier_field)) {
          this.form.setControl(config.identifier_field, new FormControl(response[config.identifier_field]));
        }
        this.formRendererService.setSourceValue(this.formKey, response);
        this.formModel = {
          ...clone(response),
          ...this.defaultValue
        };
        this.cdr.detectChanges();
      });
    }
    fetchFields() {
      this.fields$ = !this._formConfiguration ? this.formRendererService.getFields(this._formKey, this.defaultValue, this.contextKey, {
        cache: this.useCache,
        cacheWithoutCheckingContext: this.cacheWithoutCheckingContext
      }).pipe(tap(config => {
        this.fieldConfig = config?.inputs;
        this.fieldsReadySubject.next(true);
      })) : of(this.formConfiguration).pipe(map(config => this.formRendererService.getFieldConfig(config, this.formKey, this.defaultValue)), switchMap(fields => {
        return this.updateFormFieldsSubject.asObservable().pipe(filter(Boolean), startWith(fields?.inputs), map(inputs => ({
          ...fields,
          inputs
        })));
      }), tap(config => {
        this.fieldsReadySubject.next(true);
        this.formRendererService.setConfig(this._formConfiguration, this.formKey);
        this.fieldConfig = config?.inputs;
      }));
    }
    updateFormConfig(callback) {
      this.updateFormFieldsSubject.next(callback(this.fieldConfig));
    }
    assignTemplates() {
      if (this.templates) {
        this.templates.forEach(template => {
          switch (template.getType()) {
            case TemplateTypes.header:
              this.headerTemplate = template.template;
              break;
            case TemplateTypes.rightButtons:
              this.rightButtonTemplate = template.template;
              break;
            case TemplateTypes.leftButtons:
              this.leftButtonTemplate = template.template;
              break;
          }
        });
      }
    }
    static {
      this.ɵfac = function CapturumFormRendererComponent_Factory(t) {
        return new (t || CapturumFormRendererComponent)(i0.ɵɵdirectiveInject(FormRendererService), i0.ɵɵdirectiveInject(FormRendererApiService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.CapturumBuildersContextService), i0.ɵɵdirectiveInject(FormManipulatorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumFormRendererComponent,
        selectors: [["cpb-form-renderer"]],
        contentQueries: function CapturumFormRendererComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          showHeader: "showHeader",
          context: "context",
          contextKey: "contextKey",
          useCache: "useCache",
          cacheWithoutCheckingContext: "cacheWithoutCheckingContext",
          formKey: "formKey",
          formConfiguration: "formConfiguration",
          readOnly: "readOnly",
          modelId: "modelId",
          defaultValue: "defaultValue"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultHeader", ""], [4, "ngxPermissionsOnly"], [3, "leftButtonTemplate", "rightButtonTemplate", "formKey", "callbacks", "title", 4, "ngIf"], [3, "leftButtonTemplate", "rightButtonTemplate", "formKey", "callbacks", "title"], [3, "model", "form", "options", "fields", 4, "ngIf"], [3, "model", "form", "options", "fields"]],
        template: function CapturumFormRendererComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumFormRendererComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.fields$));
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i1$6.FormlyForm, i4$1.NgxPermissionsDirective, FormRendererHeaderComponent, i1$1.AsyncPipe],
        styles: [".cpb-grid{display:flex;flex-wrap:wrap;margin-right:-.5rem;margin-left:-.5rem;margin-top:-.5rem}.cpb-grid>.cpb-col,.cpb-grid>[class*=cpb-col]{box-sizing:border-box}.cpb-col{flex-grow:1;flex-basis:0;padding:.5rem}.cpb-col-fixed{flex:0 0 auto;padding:.5rem}.cpb-col-1{flex:0 0 auto;padding:.5rem;width:8.3333%}.cpb-col-2{flex:0 0 auto;padding:.5rem;width:16.6667%}.cpb-col-3{flex:0 0 auto;padding:.5rem;width:25%}.cpb-col-4{flex:0 0 auto;padding:.5rem;width:33.3333%}.cpb-col-5{flex:0 0 auto;padding:.5rem;width:41.6667%}.cpb-col-6{flex:0 0 auto;padding:.5rem;width:50%}.cpb-col-7{flex:0 0 auto;padding:.5rem;width:58.3333%}.cpb-col-8{flex:0 0 auto;padding:.5rem;width:66.6667%}.cpb-col-9{flex:0 0 auto;padding:.5rem;width:75%}.cpb-col-10{flex:0 0 auto;padding:.5rem;width:83.3333%}.cpb-col-11{flex:0 0 auto;padding:.5rem;width:91.6667%}.cpb-col-12{flex:0 0 auto;padding:.5rem;width:100%}@media screen and (min-width: 576px){.sm\\:cpb-col-1{flex:0 0 auto;padding:.5rem;width:8.3333%}.sm\\:cpb-col-2{flex:0 0 auto;padding:.5rem;width:16.6667%}.sm\\:cpb-col-3{flex:0 0 auto;padding:.5rem;width:25%}.sm\\:cpb-col-4{flex:0 0 auto;padding:.5rem;width:33.3333%}.sm\\:cpb-col-5{flex:0 0 auto;padding:.5rem;width:41.6667%}.sm\\:cpb-col-6{flex:0 0 auto;padding:.5rem;width:50%}.sm\\:cpb-col-7{flex:0 0 auto;padding:.5rem;width:58.3333%}.sm\\:cpb-col-8{flex:0 0 auto;padding:.5rem;width:66.6667%}.sm\\:cpb-col-9{flex:0 0 auto;padding:.5rem;width:75%}.sm\\:cpb-col-10{flex:0 0 auto;padding:.5rem;width:83.3333%}.sm\\:cpb-col-11{flex:0 0 auto;padding:.5rem;width:91.6667%}.sm\\:cpb-col-12{flex:0 0 auto;padding:.5rem;width:100%}}@media screen and (min-width: 768px){.md\\:cpb-col-1{flex:0 0 auto;padding:.5rem;width:8.3333%}.md\\:cpb-col-2{flex:0 0 auto;padding:.5rem;width:16.6667%}.md\\:cpb-col-3{flex:0 0 auto;padding:.5rem;width:25%}.md\\:cpb-col-4{flex:0 0 auto;padding:.5rem;width:33.3333%}.md\\:cpb-col-5{flex:0 0 auto;padding:.5rem;width:41.6667%}.md\\:cpb-col-6{flex:0 0 auto;padding:.5rem;width:50%}.md\\:cpb-col-7{flex:0 0 auto;padding:.5rem;width:58.3333%}.md\\:cpb-col-8{flex:0 0 auto;padding:.5rem;width:66.6667%}.md\\:cpb-col-9{flex:0 0 auto;padding:.5rem;width:75%}.md\\:cpb-col-10{flex:0 0 auto;padding:.5rem;width:83.3333%}.md\\:cpb-col-11{flex:0 0 auto;padding:.5rem;width:91.6667%}.md\\:cpb-col-12{flex:0 0 auto;padding:.5rem;width:100%}}@media screen and (min-width: 992px){.lg\\:cpb-col-1{flex:0 0 auto;padding:.5rem;width:8.3333%}.lg\\:cpb-col-2{flex:0 0 auto;padding:.5rem;width:16.6667%}.lg\\:cpb-col-3{flex:0 0 auto;padding:.5rem;width:25%}.lg\\:cpb-col-4{flex:0 0 auto;padding:.5rem;width:33.3333%}.lg\\:cpb-col-5{flex:0 0 auto;padding:.5rem;width:41.6667%}.lg\\:cpb-col-6{flex:0 0 auto;padding:.5rem;width:50%}.lg\\:cpb-col-7{flex:0 0 auto;padding:.5rem;width:58.3333%}.lg\\:cpb-col-8{flex:0 0 auto;padding:.5rem;width:66.6667%}.lg\\:cpb-col-9{flex:0 0 auto;padding:.5rem;width:75%}.lg\\:cpb-col-10{flex:0 0 auto;padding:.5rem;width:83.3333%}.lg\\:cpb-col-11{flex:0 0 auto;padding:.5rem;width:91.6667%}.lg\\:cpb-col-12{flex:0 0 auto;padding:.5rem;width:100%}}@media screen and (min-width: 1200px){.xl\\:cpb-col-1{flex:0 0 auto;padding:.5rem;width:8.3333%}.xl\\:cpb-col-2{flex:0 0 auto;padding:.5rem;width:16.6667%}.xl\\:cpb-col-3{flex:0 0 auto;padding:.5rem;width:25%}.xl\\:cpb-col-4{flex:0 0 auto;padding:.5rem;width:33.3333%}.xl\\:cpb-col-5{flex:0 0 auto;padding:.5rem;width:41.6667%}.xl\\:cpb-col-6{flex:0 0 auto;padding:.5rem;width:50%}.xl\\:cpb-col-7{flex:0 0 auto;padding:.5rem;width:58.3333%}.xl\\:cpb-col-8{flex:0 0 auto;padding:.5rem;width:66.6667%}.xl\\:cpb-col-9{flex:0 0 auto;padding:.5rem;width:75%}.xl\\:cpb-col-10{flex:0 0 auto;padding:.5rem;width:83.3333%}.xl\\:cpb-col-11{flex:0 0 auto;padding:.5rem;width:91.6667%}.xl\\:cpb-col-12{flex:0 0 auto;padding:.5rem;width:100%}}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumFormRendererComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormBuilderState = class FormBuilderState {
  setValue(ctx, {
    key,
    value
  }) {
    ctx.patchState({
      [key]: value
    });
  }
  static {
    this.ɵfac = function FormBuilderState_Factory(t) {
      return new (t || FormBuilderState)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormBuilderState,
      factory: FormBuilderState.ɵfac
    });
  }
};
__decorate([Action(SetValue)], FormBuilderState.prototype, "setValue", null);
FormBuilderState = __decorate([State({
  name: 'formBuilder'
})], FormBuilderState);
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ngxsModule = NgxsModule.forFeature([FormBuilderState, FormRendererState]);
const formlyModule = FormlyModule.forChild({
  types: inputTypeComponents,
  wrappers: inputTypeWrappers
});
const translateModule = TranslateModule;
const ngxPermissionModule = NgxPermissionsModule.forChild();
const FORM_RENDERER_CONFIG = new InjectionToken('FORM_RENDERER_CONFIG');
let CapturumFormRendererModule = /*#__PURE__*/(() => {
  class CapturumFormRendererModule {
    constructor(formlyConfig, formRendererConfigService, rendererConfig = []) {
      this.formRendererConfigService = formRendererConfigService;
      this.rendererConfig = rendererConfig;
      if (!rendererConfig) {
        return;
      }
      rendererConfig.forEach(config => {
        formlyConfig.addConfig(config);
        formRendererConfigService.addConfig(config);
      });
    }
    static forRoot(configs) {
      let types = [];
      if (configs?.types) {
        types = configs.types.map(type => {
          type.name = FormFieldsManipulatorUtil.getFormlyTypeName(type.name);
          return type;
        });
      }
      return {
        ngModule: CapturumFormRendererModule,
        providers: [{
          provide: FORM_RENDERER_CONFIG,
          useValue: {
            formBuilderApi: configs.formBuilderApi || '/form-builder',
            dynamicForms: configs.dynamicForms || [],
            types: types || [],
            builders: {
              ...inputTypeBuilders,
              ...(configs.builders || {})
            },
            wrappers: [...inputTypeWrappers, ...(configs.wrappers || [])],
            translationKeyPrefix: configs.translationKeyPrefix || '',
            layoutTemplates: {
              ...defaultLayoutTemplates,
              ...(configs.layoutTemplates || {})
            },
            defaultEmptyValue: configs.defaultEmptyValue || ''
          },
          multi: true
        }]
      };
    }
    static forChild(configs) {
      return {
        ngModule: CapturumFormRendererModule,
        providers: [{
          provide: FORM_RENDERER_CONFIG,
          useValue: {
            builders: {
              ...inputTypeBuilders,
              ...(configs.builders || {})
            }
          },
          multi: true
        }]
      };
    }
    static {
      this.ɵfac = function CapturumFormRendererModule_Factory(t) {
        return new (t || CapturumFormRendererModule)(i0.ɵɵinject(i1$6.FormlyConfig), i0.ɵɵinject(FormRendererConfigService), i0.ɵɵinject(FORM_RENDERER_CONFIG, 8));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumFormRendererModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [OptionsPipe, FormRendererService, {
          provide: FormlyConfig,
          useClass: CapturumFormlyConfig
        }, DynamicDialogRef],
        imports: [CommonModule, TooltipModule, FormsModule, ReactiveFormsModule, CapturumCheckboxModule, CapturumDropdownModule, CapturumFileUploadModule, CapturumSharedModule, CapturumTextareaModule, CapturumInputSwitchModule, CapturumMultiSelectModule, CapturumInputModule, CapturumButtonModule, CheckboxModule, translateModule, RadioButtonModule, CapturumCalendarModule, RouterModule, CapturumAccordionModule, ngxsModule, formlyModule, FormlyModule, ngxPermissionModule, CapturumFilePreviewListModule, SplitButtonModule, CapturumInputNumberModule, AutoCompleteModule, CapturumEditorModule, CapturumPasswordModule, FormlyModule]
      });
    }
  }
  return CapturumFormRendererModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function formlyFactory(configs) {
  return FormlyModule.forRoot(configs);
}
let NumberInputTypeBuilder = /*#__PURE__*/(() => {
  class NumberInputTypeBuilder extends TextInputTypeBuilder {
    constructor() {
      super(...arguments);
      this.inputType = InputType.number;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵNumberInputTypeBuilder_BaseFactory;
        return function NumberInputTypeBuilder_Factory(t) {
          return (ɵNumberInputTypeBuilder_BaseFactory || (ɵNumberInputTypeBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(NumberInputTypeBuilder)))(t || NumberInputTypeBuilder);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NumberInputTypeBuilder,
        factory: NumberInputTypeBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NumberInputTypeBuilder;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormBuilderResolver = /*#__PURE__*/(() => {
  class FormBuilderResolver {
    constructor(formRendererApiService) {
      this.formRendererApiService = formRendererApiService;
    }
    resolve(route, state) {
      return this.formRendererApiService.resolveFormBuilders();
    }
    static {
      this.ɵfac = function FormBuilderResolver_Factory(t) {
        return new (t || FormBuilderResolver)(i0.ɵɵinject(FormRendererApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormBuilderResolver,
        factory: FormBuilderResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormBuilderResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of builders/form-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumBuilderCheckboxInputComponent, CapturumBuilderCheckboxListInputComponent, CapturumBuilderDateInputComponent, CapturumBuilderDefaultInputWrapperComponent, CapturumBuilderDropdownInputComponent, CapturumBuilderEmailInputComponent, CapturumBuilderFileInputComponent, CapturumBuilderGroupInputComponent, CapturumBuilderHiddenTypeComponent, CapturumBuilderLabelInputComponent, CapturumBuilderNumberInputComponent, CapturumBuilderRadioInputComponent, CapturumBuilderTextInputComponent, CapturumBuilderTextareaInputComponent, CapturumBuilderTranslatedInputComponent, CapturumBuilderUrlInputComponent, CapturumBuilderValidationMessageComponent, CapturumFormRendererComponent, CapturumFormRendererModule, CapturumReadonlyContainerComponent, CheckboxInputTypeBuilder, CheckboxListInputTypeBuilder, CustomInputTypeBuilder, DateInputTypeBuilder, DropdownInputTypeBuilder, EmailInputTypeBuilder, FORM_RENDERER_CONFIG, FileInputTypeBuilder, FormBuilderModel, FormBuilderResolver, FormBuilderState, FormFieldsManipulatorUtil, FormInputHelperService, FormManipulatorService, FormRendererApiService, FormRendererConfigService, FormRendererService, FormSaverService, FormTooltipComponent, HiddenInputTypeBuilder, ImageInputTypeBuilder, InputTypeBuilder, LabelInputTypeBuilder, LabelsByValuesPipe, NumberInputTypeBuilder, OptionsPipe, RadioInputTypeBuilder, ResetFormValue, SetFormConfiguration, SetFormStatus, SetFormValue, SetValue, TextInputTypeBuilder, TextareaInputTypeBuilder, TranslatedInputTypeBuilder, UrlInputTypeBuilder, defaultLayoutTemplates, formlyFactory, formlyModule, inputTypeComponents, inputTypeWrappers, ngxPermissionModule, ngxsModule, translateModule };
